import React from 'react';

const Trope5: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-5 prefix__trope-decor"
      transform="translate(135, 205)"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1369.63,132.67c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1369.63,132.67Z"
                fill="#2f6840"
              />
              <path
                d="M1369.13,132.33c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1369.13,132.33Z"
                fill="#3ba525"
              />
              <path
                d="M1369.88,132.3a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1369.88,132.3Z"
                fill="#2f6840"
              />
              <path
                d="M1373.36,131.5c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1373.36,131.5Z"
                fill="#2f6840"
              />
              <path
                d="M1372,134.71a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1372,134.71Z"
                fill="#2f6840"
              />
              <path
                d="M1370,132.76c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1370,132.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1367,141.4c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1367,141.4Z"
                fill="#2f6840"
              />
              <path
                d="M1366.47,141.06c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1366.47,141.06Z"
                fill="#3ba525"
              />
              <path
                d="M1367.22,141a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1367.22,141Z"
                fill="#2f6840"
              />
              <path
                d="M1370.7,140.23c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1370.7,140.23Z"
                fill="#2f6840"
              />
              <path
                d="M1369.33,143.44a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1369.33,143.44Z"
                fill="#2f6840"
              />
              <path
                d="M1367.37,141.49c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1367.37,141.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1361.62,136.44c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1361.62,136.44Z"
                fill="#2f6840"
              />
              <path
                d="M1361.12,136.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1361.12,136.1Z"
                fill="#3ba525"
              />
              <path
                d="M1361.87,136.07a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1361.87,136.07Z"
                fill="#2f6840"
              />
              <path
                d="M1365.35,135.28c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1365.35,135.28Z"
                fill="#2f6840"
              />
              <path
                d="M1364,138.49a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1364,138.49Z"
                fill="#2f6840"
              />
              <path
                d="M1362,136.53c-.24.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1362,136.53Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1353.28,133.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1353.28,133.07Z"
                fill="#2f6840"
              />
              <path
                d="M1352.77,132.73c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1352.77,132.73Z"
                fill="#3ba525"
              />
              <path
                d="M1353.53,132.7a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1353.53,132.7Z"
                fill="#2f6840"
              />
              <path
                d="M1357,131.9c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1357,131.9Z"
                fill="#2f6840"
              />
              <path
                d="M1355.64,135.11a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1355.64,135.11Z"
                fill="#2f6840"
              />
              <path
                d="M1353.68,133.16c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1353.68,133.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1368,148.56c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1368,148.56Z"
                fill="#2f6840"
              />
              <path
                d="M1367.48,148.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1367.48,148.22Z"
                fill="#3ba525"
              />
              <path
                d="M1368.23,148.19a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1368.23,148.19Z"
                fill="#2f6840"
              />
              <path
                d="M1371.71,147.39c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1371.71,147.39Z"
                fill="#2f6840"
              />
              <path
                d="M1370.34,150.6a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1370.34,150.6Z"
                fill="#2f6840"
              />
              <path
                d="M1368.38,148.65c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1368.38,148.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1354.53,143c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1354.53,143Z"
                fill="#2f6840"
              />
              <path
                d="M1354,142.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1354,142.65Z"
                fill="#3ba525"
              />
              <path
                d="M1354.77,142.62a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1354.77,142.62Z"
                fill="#2f6840"
              />
              <path
                d="M1358.25,141.82c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1358.25,141.82Z"
                fill="#2f6840"
              />
              <path
                d="M1356.88,145a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1356.88,145Z"
                fill="#2f6840"
              />
              <path
                d="M1354.93,143.08c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1354.93,143.08Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1381.88,108.39c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1381.88,108.39Z"
                fill="#2f6840"
              />
              <path
                d="M1381.37,108c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1381.37,108Z"
                fill="#3ba525"
              />
              <path
                d="M1382.12,108a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1382.12,108Z"
                fill="#2f6840"
              />
              <path
                d="M1385.6,107.22a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1385.6,107.22Z"
                fill="#2f6840"
              />
              <path
                d="M1384.23,110.43a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1384.23,110.43Z"
                fill="#2f6840"
              />
              <path
                d="M1382.28,108.47c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1382.28,108.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1379.22,117.12c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1379.22,117.12Z"
                fill="#2f6840"
              />
              <path
                d="M1378.71,116.77c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1378.71,116.77Z"
                fill="#3ba525"
              />
              <path
                d="M1379.46,116.74a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1379.46,116.74Z"
                fill="#2f6840"
              />
              <path
                d="M1382.94,116c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.52,2.52,0,0,1,1.24-.86A2.07,2.07,0,0,1,1382.94,116Z"
                fill="#2f6840"
              />
              <path
                d="M1381.57,119.16a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1381.57,119.16Z"
                fill="#2f6840"
              />
              <path
                d="M1379.62,117.2c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1379.62,117.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1373.87,112.16c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1373.87,112.16Z"
                fill="#2f6840"
              />
              <path
                d="M1373.36,111.81c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1373.36,111.81Z"
                fill="#3ba525"
              />
              <path
                d="M1374.11,111.78a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1374.11,111.78Z"
                fill="#2f6840"
              />
              <path
                d="M1377.59,111c-.26,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1377.59,111Z"
                fill="#2f6840"
              />
              <path
                d="M1376.22,114.2a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1376.22,114.2Z"
                fill="#2f6840"
              />
              <path
                d="M1374.26,112.24c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1374.26,112.24Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1365.52,108.79c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1365.52,108.79Z"
                fill="#2f6840"
              />
              <path
                d="M1365,108.44c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1365,108.44Z"
                fill="#3ba525"
              />
              <path
                d="M1365.77,108.41a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1365.77,108.41Z"
                fill="#2f6840"
              />
              <path
                d="M1369.25,107.62a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1369.25,107.62Z"
                fill="#2f6840"
              />
              <path
                d="M1367.88,110.83a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1367.88,110.83Z"
                fill="#2f6840"
              />
              <path
                d="M1365.92,108.87c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1365.92,108.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1380.23,124.28c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1380.23,124.28Z"
                fill="#2f6840"
              />
              <path
                d="M1379.72,123.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1379.72,123.93Z"
                fill="#3ba525"
              />
              <path
                d="M1380.47,123.9a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1380.47,123.9Z"
                fill="#2f6840"
              />
              <path
                d="M1384,123.11c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1384,123.11Z"
                fill="#2f6840"
              />
              <path
                d="M1382.58,126.32a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1382.58,126.32Z"
                fill="#2f6840"
              />
              <path
                d="M1380.63,124.36c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1380.63,124.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1366.77,118.71c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1366.77,118.71Z"
                fill="#2f6840"
              />
              <path
                d="M1366.27,118.36c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1366.27,118.36Z"
                fill="#3ba525"
              />
              <path
                d="M1367,118.33a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1367,118.33Z"
                fill="#2f6840"
              />
              <path
                d="M1370.5,117.54c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1370.5,117.54Z"
                fill="#2f6840"
              />
              <path
                d="M1369.13,120.75a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1369.13,120.75Z"
                fill="#2f6840"
              />
              <path
                d="M1367.17,118.79c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1367.17,118.79Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1373.18,82.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1373.18,82.15Z"
                fill="#2f6840"
              />
              <path
                d="M1372.67,81.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1372.67,81.8Z"
                fill="#3ba525"
              />
              <path
                d="M1373.43,81.77a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1373.43,81.77Z"
                fill="#2f6840"
              />
              <path
                d="M1376.9,81a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1376.9,81Z"
                fill="#2f6840"
              />
              <path
                d="M1375.54,84.19a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1375.54,84.19Z"
                fill="#2f6840"
              />
              <path
                d="M1373.58,82.23c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1373.58,82.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1370.52,90.88c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1370.52,90.88Z"
                fill="#2f6840"
              />
              <path
                d="M1370,90.53c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1370,90.53Z"
                fill="#3ba525"
              />
              <path
                d="M1370.77,90.5a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1370.77,90.5Z"
                fill="#2f6840"
              />
              <path
                d="M1374.24,89.71c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1374.24,89.71Z"
                fill="#2f6840"
              />
              <path
                d="M1372.88,92.92a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1372.88,92.92Z"
                fill="#2f6840"
              />
              <path
                d="M1370.92,91c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1370.92,91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1365.17,85.92c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1365.17,85.92Z"
                fill="#2f6840"
              />
              <path
                d="M1364.66,85.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1364.66,85.57Z"
                fill="#3ba525"
              />
              <path
                d="M1365.41,85.54a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1365.41,85.54Z"
                fill="#2f6840"
              />
              <path
                d="M1368.89,84.75c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1368.89,84.75Z"
                fill="#2f6840"
              />
              <path
                d="M1367.52,88a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1367.52,88Z"
                fill="#2f6840"
              />
              <path
                d="M1365.57,86c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23A10,10,0,0,0,1363,87a2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1365.57,86Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1356.82,82.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1356.82,82.55Z"
                fill="#2f6840"
              />
              <path
                d="M1356.32,82.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1356.32,82.2Z"
                fill="#3ba525"
              />
              <path
                d="M1357.07,82.17a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1357.07,82.17Z"
                fill="#2f6840"
              />
              <path
                d="M1360.55,81.38a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1360.55,81.38Z"
                fill="#2f6840"
              />
              <path
                d="M1359.18,84.59a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1359.18,84.59Z"
                fill="#2f6840"
              />
              <path
                d="M1357.22,82.63c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1357.22,82.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1371.53,98c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1371.53,98Z"
                fill="#2f6840"
              />
              <path
                d="M1371,97.69c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1371,97.69Z"
                fill="#3ba525"
              />
              <path
                d="M1371.78,97.66a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1371.78,97.66Z"
                fill="#2f6840"
              />
              <path
                d="M1375.25,96.87c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1375.25,96.87Z"
                fill="#2f6840"
              />
              <path
                d="M1373.89,100.08a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1373.89,100.08Z"
                fill="#2f6840"
              />
              <path
                d="M1371.93,98.12c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1371.93,98.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1358.07,92.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1358.07,92.47Z"
                fill="#2f6840"
              />
              <path
                d="M1357.57,92.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1357.57,92.12Z"
                fill="#3ba525"
              />
              <path
                d="M1358.32,92.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1358.32,92.09Z"
                fill="#2f6840"
              />
              <path
                d="M1361.8,91.3a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1361.8,91.3Z"
                fill="#2f6840"
              />
              <path
                d="M1360.43,94.51a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1360.43,94.51Z"
                fill="#2f6840"
              />
              <path
                d="M1358.47,92.55c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1358.47,92.55Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1350.56,65.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1350.56,65.16Z"
                fill="#2f6840"
              />
              <path
                d="M1350.05,64.82c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1350.05,64.82Z"
                fill="#3ba525"
              />
              <path
                d="M1350.81,64.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1350.81,64.79Z"
                fill="#2f6840"
              />
              <path
                d="M1354.28,64c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1354.28,64Z"
                fill="#2f6840"
              />
              <path
                d="M1352.92,67.2a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1352.92,67.2Z"
                fill="#2f6840"
              />
              <path
                d="M1351,65.25c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1351,65.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1347.9,73.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1347.9,73.89Z"
                fill="#2f6840"
              />
              <path
                d="M1347.39,73.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1347.39,73.55Z"
                fill="#3ba525"
              />
              <path
                d="M1348.15,73.52a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1348.15,73.52Z"
                fill="#2f6840"
              />
              <path
                d="M1351.62,72.72c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1351.62,72.72Z"
                fill="#2f6840"
              />
              <path
                d="M1350.26,75.93a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1350.26,75.93Z"
                fill="#2f6840"
              />
              <path
                d="M1348.3,74a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1348.3,74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1342.55,68.93c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1342.55,68.93Z"
                fill="#2f6840"
              />
              <path
                d="M1342,68.59c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1342,68.59Z"
                fill="#3ba525"
              />
              <path
                d="M1342.79,68.56a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.23,2.23,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1342.79,68.56Z"
                fill="#2f6840"
              />
              <path
                d="M1346.27,67.76c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1346.27,67.76Z"
                fill="#2f6840"
              />
              <path
                d="M1344.9,71a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1344.9,71Z"
                fill="#2f6840"
              />
              <path
                d="M1343,69c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1343,69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1334.2,65.56c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S1342,66.15,1341,66s-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1334.2,65.56Z"
                fill="#2f6840"
              />
              <path
                d="M1333.7,65.22c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1333.7,65.22Z"
                fill="#3ba525"
              />
              <path
                d="M1334.45,65.19a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1334.45,65.19Z"
                fill="#2f6840"
              />
              <path
                d="M1337.93,64.39c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1337.93,64.39Z"
                fill="#2f6840"
              />
              <path
                d="M1336.56,67.6a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1336.56,67.6Z"
                fill="#2f6840"
              />
              <path
                d="M1334.6,65.65a7,7,0,0,0-.69.16,3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1334.6,65.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1348.91,81.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1348.91,81.05Z"
                fill="#2f6840"
              />
              <path
                d="M1348.4,80.71c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1348.4,80.71Z"
                fill="#3ba525"
              />
              <path
                d="M1349.16,80.68a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1349.16,80.68Z"
                fill="#2f6840"
              />
              <path
                d="M1352.63,79.88c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1352.63,79.88Z"
                fill="#2f6840"
              />
              <path
                d="M1351.27,83.09a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1351.27,83.09Z"
                fill="#2f6840"
              />
              <path
                d="M1349.31,81.14a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1349.31,81.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1335.45,75.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1335.45,75.48Z"
                fill="#2f6840"
              />
              <path
                d="M1335,75.14c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1335,75.14Z"
                fill="#3ba525"
              />
              <path
                d="M1335.7,75.11a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1335.7,75.11Z"
                fill="#2f6840"
              />
              <path
                d="M1339.18,74.31c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1339.18,74.31Z"
                fill="#2f6840"
              />
              <path
                d="M1337.81,77.52a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1337.81,77.52Z"
                fill="#2f6840"
              />
              <path
                d="M1335.85,75.57a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1335.85,75.57Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1340.21,88l3.53,2.19a1.16,1.16,0,0,0,1.07.07l8.48-3.79a1.15,1.15,0,0,0,.28-1.91h0a1.11,1.11,0,0,0-.9-.27l-12,1.59A1.15,1.15,0,0,0,1340.21,88Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1346.48 79.27 1341.7 80.28 1337.49 83.52 1344.54 86.34 1353.18 82.81 1346.48 79.27"
              fill="#ffedc8"
            />
            <polygon
              points="1337.49 83.52 1337.49 86.34 1344.26 89.25 1353.37 85.55 1353.18 82.81 1344.54 86.34 1337.49 83.52"
              fill="#ccae79"
            />
            <polygon
              points="1344.54 86.34 1344.26 89.25 1353.37 85.55 1353.18 82.81 1344.54 86.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1339.5,84.33a1.26,1.26,0,0,1,0,1.45c.32-.46.4-1.3.54-1.24Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1342.48,85.52a4.06,4.06,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1348.11,84.88a1.31,1.31,0,0,1,.7,1.15l-.21-1.35Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1351.27,81.8a8.58,8.58,0,0,1-2.81,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.22,12.22,0,0,1,1351.27,81.8Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1356.31,79.89l4.74,2.94a1.54,1.54,0,0,0,1.44.1l11.38-5.09a1.54,1.54,0,0,0,.38-2.57h0a1.52,1.52,0,0,0-1.21-.36l-16.12,2.14A1.54,1.54,0,0,0,1356.31,79.89Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1364.72 68.12 1358.31 69.48 1352.66 73.82 1362.13 77.62 1373.73 72.87 1364.72 68.12"
              fill="#ffedc8"
            />
            <polygon
              points="1352.66 73.82 1352.66 77.62 1361.75 81.51 1373.98 76.55 1373.73 72.87 1362.13 77.62 1352.66 73.82"
              fill="#ccae79"
            />
            <polygon
              points="1362.13 77.62 1361.75 81.51 1373.98 76.55 1373.73 72.87 1362.13 77.62"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1355.36,74.9a1.71,1.71,0,0,1,0,1.95c.43-.61.53-1.74.72-1.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1359.36,76.51a5.48,5.48,0,0,0,2.39-2.43L1360,76.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1366.92,75.65a1.77,1.77,0,0,1,.94,1.54l-.28-1.81Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1371.16,71.51c-.12-.06-2.4.46-3.77,0a5.42,5.42,0,0,1-2.74.19s2-.19,2.74.49A16.74,16.74,0,0,1,1371.16,71.51Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1378.93,125l4,2.52a1.31,1.31,0,0,0,1.23.08l9.72-4.34a1.32,1.32,0,0,0,.33-2.2h0a1.31,1.31,0,0,0-1-.31l-13.76,1.83A1.32,1.32,0,0,0,1378.93,125Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1386.12 114.91 1380.64 116.07 1375.81 119.78 1383.9 123.03 1393.81 118.97 1386.12 114.91"
              fill="#ffedc8"
            />
            <polygon
              points="1375.81 119.78 1375.81 123.03 1383.58 126.35 1394.03 122.11 1393.81 118.97 1383.9 123.03 1375.81 119.78"
              fill="#ccae79"
            />
            <polygon
              points="1383.9 123.03 1383.58 126.35 1394.03 122.11 1393.81 118.97 1383.9 123.03"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1378.12,120.71a1.44,1.44,0,0,1,0,1.66c.37-.52.45-1.48.62-1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1381.54,122.08a4.64,4.64,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1388,121.35a1.5,1.5,0,0,1,.81,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1391.61,117.81a9.83,9.83,0,0,1-3.21,0,4.58,4.58,0,0,1-2.34.16s1.71-.16,2.34.42A14.13,14.13,0,0,1,1391.61,117.81Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1353.94,120.61l4,2.52a1.31,1.31,0,0,0,1.23.08l9.72-4.34a1.32,1.32,0,0,0,.33-2.2h0a1.31,1.31,0,0,0-1-.31l-13.77,1.83A1.31,1.31,0,0,0,1353.94,120.61Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1361.13 110.56 1355.65 111.72 1350.82 115.43 1358.91 118.67 1368.82 114.62 1361.13 110.56"
              fill="#ffedc8"
            />
            <polygon
              points="1350.82 115.43 1350.82 118.67 1358.59 122 1369.03 117.76 1368.82 114.62 1358.91 118.67 1350.82 115.43"
              fill="#ccae79"
            />
            <polygon
              points="1358.91 118.67 1358.59 122 1369.03 117.76 1368.82 114.62 1358.91 118.67"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1353.13,116.36a1.44,1.44,0,0,1,0,1.66c.37-.52.45-1.48.62-1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1356.54,117.73a4.68,4.68,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1363,117a1.5,1.5,0,0,1,.81,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1366.62,113.46a9.83,9.83,0,0,1-3.21,0,4.62,4.62,0,0,1-2.35.16s1.72-.16,2.35.42A14.13,14.13,0,0,1,1366.62,113.46Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1355.1,99l4.74,2.94a1.53,1.53,0,0,0,1.44.1l11.38-5.09a1.54,1.54,0,0,0,.38-2.57h0a1.52,1.52,0,0,0-1.21-.36l-16.12,2.14A1.54,1.54,0,0,0,1355.1,99Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1363.51 87.18 1357.1 88.54 1351.44 92.88 1360.92 96.68 1372.52 91.93 1363.51 87.18"
              fill="#ffedc8"
            />
            <polygon
              points="1351.44 92.88 1351.44 96.68 1360.53 100.57 1372.77 95.61 1372.52 91.93 1360.92 96.68 1351.44 92.88"
              fill="#ccae79"
            />
            <polygon
              points="1360.92 96.68 1360.53 100.57 1372.77 95.61 1372.52 91.93 1360.92 96.68"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1354.15,94a1.7,1.7,0,0,1,0,1.94c.43-.61.53-1.73.72-1.65Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1358.14,95.57a5.43,5.43,0,0,0,2.39-2.43l-1.71,2.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1365.71,94.72a1.75,1.75,0,0,1,.94,1.53l-.28-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1370,90.57c-.12-.06-2.4.46-3.77,0a5.41,5.41,0,0,1-2.74.19s2-.19,2.74.5A16.36,16.36,0,0,1,1370,90.57Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1377.41,91.08l3.53,2.19a1.13,1.13,0,0,0,1.07.07l8.48-3.79a1.15,1.15,0,0,0,.28-1.91h0a1.11,1.11,0,0,0-.9-.27l-12,1.59A1.15,1.15,0,0,0,1377.41,91.08Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1383.67 82.31 1378.9 83.33 1374.69 86.56 1381.74 89.39 1390.38 85.85 1383.67 82.31"
              fill="#ffedc8"
            />
            <polygon
              points="1374.69 86.56 1374.69 89.39 1381.46 92.29 1390.57 88.59 1390.38 85.85 1381.74 89.39 1374.69 86.56"
              fill="#ccae79"
            />
            <polygon
              points="1381.74 89.39 1381.46 92.29 1390.57 88.59 1390.38 85.85 1381.74 89.39"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1376.7,87.37a1.26,1.26,0,0,1,0,1.45c.32-.46.39-1.3.54-1.24Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1379.68,88.56a4.06,4.06,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1385.31,87.93a1.29,1.29,0,0,1,.7,1.14l-.21-1.35Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1388.46,84.84a8.5,8.5,0,0,1-2.8,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.16,12.16,0,0,1,1388.46,84.84Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1357.93,131.36s1.85,3.68,4.43,4.3,6.47-1.94,5.87.18,4.86,3.06,7.2,2.49,7.48-5.58,7.45-7.17S1357.93,131.36,1357.93,131.36Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1357.85,128.35l.08,3,4.44,3.09,5.76-.15,1.36,2.21s4,1.85,6.62-.18a21.59,21.59,0,0,0,4.65-5.58l-.09-3Z"
              fill="#ccae79"
            />
            <path
              d="M1362.48,126.26l-4.63,2.09,4.76,3.07,5.5-.15,1.84,2.27s5.41,1.45,6.07-.17,4.65-5.64,4.65-5.64l-4.32-1.84Z"
              fill="#ffedc8"
            />
            <polygon
              points="1362.62 131.42 1362.37 134.46 1368.13 134.3 1368.11 131.27 1362.62 131.42"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1374.65,134.1s.95,2.75.08,2.94a13.25,13.25,0,0,0,6-6.29l-.09-3S1375.92,134.08,1374.65,134.1Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1370.94,133.77l1.09.2s-.68-.18-.51,1.09A3.08,3.08,0,0,0,1370.94,133.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1373.44,134.16c-.12,0,.21,0,1.19-1a6.48,6.48,0,0,0,1.34-2.08s-2.34,2.7-1.76,3.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1360.64,130.14a19.2,19.2,0,0,1,.06,2.19s-.13-1.65.33-1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1369.09,126.08l2.18-.06c.16,0-1.71,0-2.16,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1360.18,127.3l1.15-.52s-.65.41-.39.5,1.28.49,1.69.28a1.69,1.69,0,0,1,1.1,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1092.72,170.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1092.72,170.61Z"
                fill="#2f6840"
              />
              <path
                d="M1092.21,170.27c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1092.21,170.27Z"
                fill="#3ba525"
              />
              <path
                d="M1093,170.24a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1093,170.24Z"
                fill="#2f6840"
              />
              <path
                d="M1096.44,169.45c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1096.44,169.45Z"
                fill="#2f6840"
              />
              <path
                d="M1095.08,172.66a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1095.08,172.66Z"
                fill="#2f6840"
              />
              <path
                d="M1093.12,170.7c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1093.12,170.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1090.06,179.34c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1090.06,179.34Z"
                fill="#2f6840"
              />
              <path
                d="M1089.55,179c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1089.55,179Z"
                fill="#3ba525"
              />
              <path
                d="M1090.31,179a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1090.31,179Z"
                fill="#2f6840"
              />
              <path
                d="M1093.79,178.17c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,1093.79,178.17Z"
                fill="#2f6840"
              />
              <path
                d="M1092.42,181.38a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1092.42,181.38Z"
                fill="#2f6840"
              />
              <path
                d="M1090.46,179.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1090.46,179.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1084.71,174.38c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1084.71,174.38Z"
                fill="#2f6840"
              />
              <path
                d="M1084.2,174c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1084.2,174Z"
                fill="#3ba525"
              />
              <path
                d="M1085,174a2.15,2.15,0,0,0-.8-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1085,174Z"
                fill="#2f6840"
              />
              <path
                d="M1088.43,173.22c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1088.43,173.22Z"
                fill="#2f6840"
              />
              <path
                d="M1087.06,176.43a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1087.06,176.43Z"
                fill="#2f6840"
              />
              <path
                d="M1085.11,174.47c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1085.11,174.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1076.37,171c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1076.37,171Z"
                fill="#2f6840"
              />
              <path
                d="M1075.86,170.67c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1075.86,170.67Z"
                fill="#3ba525"
              />
              <path
                d="M1076.61,170.64a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1076.61,170.64Z"
                fill="#2f6840"
              />
              <path
                d="M1080.09,169.84c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1080.09,169.84Z"
                fill="#2f6840"
              />
              <path
                d="M1078.72,173.05a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1078.72,173.05Z"
                fill="#2f6840"
              />
              <path
                d="M1076.76,171.1c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1076.76,171.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1091.07,186.5c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1091.07,186.5Z"
                fill="#2f6840"
              />
              <path
                d="M1090.56,186.16c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1090.56,186.16Z"
                fill="#3ba525"
              />
              <path
                d="M1091.32,186.13a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1091.32,186.13Z"
                fill="#2f6840"
              />
              <path
                d="M1094.8,185.33c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,1094.8,185.33Z"
                fill="#2f6840"
              />
              <path
                d="M1093.43,188.54a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1093.43,188.54Z"
                fill="#2f6840"
              />
              <path
                d="M1091.47,186.59c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1091.47,186.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1077.61,180.93c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1077.61,180.93Z"
                fill="#2f6840"
              />
              <path
                d="M1077.11,180.59c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1077.11,180.59Z"
                fill="#3ba525"
              />
              <path
                d="M1077.86,180.56a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1077.86,180.56Z"
                fill="#2f6840"
              />
              <path
                d="M1081.34,179.76c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1081.34,179.76Z"
                fill="#2f6840"
              />
              <path
                d="M1080,183a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1080,183Z"
                fill="#2f6840"
              />
              <path
                d="M1078,181c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1078,181Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1121,168.66c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1121,168.66Z"
                fill="#2f6840"
              />
              <path
                d="M1120.45,168.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1120.45,168.31Z"
                fill="#3ba525"
              />
              <path
                d="M1121.2,168.28a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1121.2,168.28Z"
                fill="#2f6840"
              />
              <path
                d="M1124.68,167.49c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1124.68,167.49Z"
                fill="#2f6840"
              />
              <path
                d="M1123.31,170.7a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1123.31,170.7Z"
                fill="#2f6840"
              />
              <path
                d="M1121.35,168.74c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1121.35,168.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1118.29,177.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1118.29,177.38Z"
                fill="#2f6840"
              />
              <path
                d="M1117.79,177c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1117.79,177Z"
                fill="#3ba525"
              />
              <path
                d="M1118.54,177a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1118.54,177Z"
                fill="#2f6840"
              />
              <path
                d="M1122,176.22c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1122,176.22Z"
                fill="#2f6840"
              />
              <path
                d="M1120.65,179.43a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1120.65,179.43Z"
                fill="#2f6840"
              />
              <path
                d="M1118.69,177.47c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1118.69,177.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1112.94,172.43c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1112.94,172.43Z"
                fill="#2f6840"
              />
              <path
                d="M1112.43,172.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71S1113,173,1113,173s-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1112.43,172.08Z"
                fill="#3ba525"
              />
              <path
                d="M1113.19,172.05a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1113.19,172.05Z"
                fill="#2f6840"
              />
              <path
                d="M1116.66,171.26a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1116.66,171.26Z"
                fill="#2f6840"
              />
              <path
                d="M1115.3,174.47a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1115.3,174.47Z"
                fill="#2f6840"
              />
              <path
                d="M1113.34,172.51c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,11.51,11.51,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1113.34,172.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1104.6,169.05c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1104.6,169.05Z"
                fill="#2f6840"
              />
              <path
                d="M1104.09,168.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1104.09,168.71Z"
                fill="#3ba525"
              />
              <path
                d="M1104.84,168.68a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1104.84,168.68Z"
                fill="#2f6840"
              />
              <path
                d="M1108.32,167.89c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1108.32,167.89Z"
                fill="#2f6840"
              />
              <path
                d="M1107,171.1a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1107,171.1Z"
                fill="#2f6840"
              />
              <path
                d="M1105,169.14c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1105,169.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1119.3,184.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1119.3,184.54Z"
                fill="#2f6840"
              />
              <path
                d="M1118.8,184.2c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1118.8,184.2Z"
                fill="#3ba525"
              />
              <path
                d="M1119.55,184.17a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1119.55,184.17Z"
                fill="#2f6840"
              />
              <path
                d="M1123,183.38c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1123,183.38Z"
                fill="#2f6840"
              />
              <path
                d="M1121.66,186.59a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1121.66,186.59Z"
                fill="#2f6840"
              />
              <path
                d="M1119.7,184.63c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1119.7,184.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1105.84,179c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1105.84,179Z"
                fill="#2f6840"
              />
              <path
                d="M1105.34,178.63c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1105.34,178.63Z"
                fill="#3ba525"
              />
              <path
                d="M1106.09,178.6a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1106.09,178.6Z"
                fill="#2f6840"
              />
              <path
                d="M1109.57,177.81c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1109.57,177.81Z"
                fill="#2f6840"
              />
              <path
                d="M1108.2,181a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1108.2,181Z"
                fill="#2f6840"
              />
              <path
                d="M1106.24,179.06c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1106.24,179.06Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1149.34,170.81c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1149.34,170.81Z"
                fill="#2f6840"
              />
              <path
                d="M1148.83,170.46c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1148.83,170.46Z"
                fill="#3ba525"
              />
              <path
                d="M1149.58,170.44a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1149.58,170.44Z"
                fill="#2f6840"
              />
              <path
                d="M1153.06,169.64c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1153.06,169.64Z"
                fill="#2f6840"
              />
              <path
                d="M1151.69,172.85a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1151.69,172.85Z"
                fill="#2f6840"
              />
              <path
                d="M1149.73,170.9a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1149.73,170.9Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1146.68,179.54c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1146.68,179.54Z"
                fill="#2f6840"
              />
              <path
                d="M1146.17,179.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1146.17,179.19Z"
                fill="#3ba525"
              />
              <path
                d="M1146.92,179.16a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1146.92,179.16Z"
                fill="#2f6840"
              />
              <path
                d="M1150.4,178.37c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1150.4,178.37Z"
                fill="#2f6840"
              />
              <path
                d="M1149,181.58a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1149,181.58Z"
                fill="#2f6840"
              />
              <path
                d="M1147.08,179.62c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1147.08,179.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1141.32,174.58c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1141.32,174.58Z"
                fill="#2f6840"
              />
              <path
                d="M1140.82,174.23c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1140.82,174.23Z"
                fill="#3ba525"
              />
              <path
                d="M1141.57,174.21a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1141.57,174.21Z"
                fill="#2f6840"
              />
              <path
                d="M1145.05,173.41c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1145.05,173.41Z"
                fill="#2f6840"
              />
              <path
                d="M1143.68,176.62a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1143.68,176.62Z"
                fill="#2f6840"
              />
              <path
                d="M1141.72,174.67a7,7,0,0,0-.69.15,4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1141.72,174.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1133,171.21c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1133,171.21Z"
                fill="#2f6840"
              />
              <path
                d="M1132.48,170.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1132.48,170.86Z"
                fill="#3ba525"
              />
              <path
                d="M1133.23,170.83a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1133.23,170.83Z"
                fill="#2f6840"
              />
              <path
                d="M1136.71,170c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1136.71,170Z"
                fill="#2f6840"
              />
              <path
                d="M1135.34,173.25a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1135.34,173.25Z"
                fill="#2f6840"
              />
              <path
                d="M1133.38,171.29c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1133.38,171.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1147.69,186.7c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1147.69,186.7Z"
                fill="#2f6840"
              />
              <path
                d="M1147.18,186.35c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1147.18,186.35Z"
                fill="#3ba525"
              />
              <path
                d="M1147.93,186.32a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1147.93,186.32Z"
                fill="#2f6840"
              />
              <path
                d="M1151.41,185.53c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1151.41,185.53Z"
                fill="#2f6840"
              />
              <path
                d="M1150,188.74a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1150,188.74Z"
                fill="#2f6840"
              />
              <path
                d="M1148.09,186.78c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1148.09,186.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1134.23,181.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1134.23,181.13Z"
                fill="#2f6840"
              />
              <path
                d="M1133.72,180.78c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1133.72,180.78Z"
                fill="#3ba525"
              />
              <path
                d="M1134.48,180.75a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1134.48,180.75Z"
                fill="#2f6840"
              />
              <path
                d="M1138,180c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1138,180Z"
                fill="#2f6840"
              />
              <path
                d="M1136.59,183.17a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1136.59,183.17Z"
                fill="#2f6840"
              />
              <path
                d="M1134.63,181.21c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1134.63,181.21Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1176.74,164.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1176.74,164.26Z"
                fill="#2f6840"
              />
              <path
                d="M1176.24,163.92c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1176.24,163.92Z"
                fill="#3ba525"
              />
              <path
                d="M1177,163.89a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1177,163.89Z"
                fill="#2f6840"
              />
              <path
                d="M1180.47,163.09c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53A2.45,2.45,0,0,1,1179,163,2.12,2.12,0,0,1,1180.47,163.09Z"
                fill="#2f6840"
              />
              <path
                d="M1179.1,166.3a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1179.1,166.3Z"
                fill="#2f6840"
              />
              <path
                d="M1177.14,164.35a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1177.14,164.35Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1174.08,173c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1174.08,173Z"
                fill="#2f6840"
              />
              <path
                d="M1173.58,172.65c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1173.58,172.65Z"
                fill="#3ba525"
              />
              <path
                d="M1174.33,172.62a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1174.33,172.62Z"
                fill="#2f6840"
              />
              <path
                d="M1177.81,171.82c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1177.81,171.82Z"
                fill="#2f6840"
              />
              <path
                d="M1176.44,175a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1176.44,175Z"
                fill="#2f6840"
              />
              <path
                d="M1174.48,173.08c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1174.48,173.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1168.73,168c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1168.73,168Z"
                fill="#2f6840"
              />
              <path
                d="M1168.22,167.69c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1168.22,167.69Z"
                fill="#3ba525"
              />
              <path
                d="M1169,167.66a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1169,167.66Z"
                fill="#2f6840"
              />
              <path
                d="M1172.46,166.86c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1172.46,166.86Z"
                fill="#2f6840"
              />
              <path
                d="M1171.09,170.07a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1171.09,170.07Z"
                fill="#2f6840"
              />
              <path
                d="M1169.13,168.12c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1169.13,168.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1160.39,164.66c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1160.39,164.66Z"
                fill="#2f6840"
              />
              <path
                d="M1159.88,164.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1159.88,164.32Z"
                fill="#3ba525"
              />
              <path
                d="M1160.63,164.29a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1160.63,164.29Z"
                fill="#2f6840"
              />
              <path
                d="M1164.11,163.49c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1164.11,163.49Z"
                fill="#2f6840"
              />
              <path
                d="M1162.74,166.7a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1162.74,166.7Z"
                fill="#2f6840"
              />
              <path
                d="M1160.79,164.75a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1160.79,164.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1175.09,180.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1175.09,180.15Z"
                fill="#2f6840"
              />
              <path
                d="M1174.59,179.81c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1174.59,179.81Z"
                fill="#3ba525"
              />
              <path
                d="M1175.34,179.78a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1175.34,179.78Z"
                fill="#2f6840"
              />
              <path
                d="M1178.82,179c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1178.82,179Z"
                fill="#2f6840"
              />
              <path
                d="M1177.45,182.19a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1177.45,182.19Z"
                fill="#2f6840"
              />
              <path
                d="M1175.49,180.24c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1175.49,180.24Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1161.64,174.58c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1161.64,174.58Z"
                fill="#2f6840"
              />
              <path
                d="M1161.13,174.24c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1161.13,174.24Z"
                fill="#3ba525"
              />
              <path
                d="M1161.88,174.21a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1161.88,174.21Z"
                fill="#2f6840"
              />
              <path
                d="M1165.36,173.41c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1165.36,173.41Z"
                fill="#2f6840"
              />
              <path
                d="M1164,176.62a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1164,176.62Z"
                fill="#2f6840"
              />
              <path
                d="M1162,174.67a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1162,174.67Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1204.16,157.06c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1204.16,157.06Z"
                fill="#2f6840"
              />
              <path
                d="M1203.66,156.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1203.66,156.71Z"
                fill="#3ba525"
              />
              <path
                d="M1204.41,156.68a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1204.41,156.68Z"
                fill="#2f6840"
              />
              <path
                d="M1207.89,155.89c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1207.89,155.89Z"
                fill="#2f6840"
              />
              <path
                d="M1206.52,159.1a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1206.52,159.1Z"
                fill="#2f6840"
              />
              <path
                d="M1204.56,157.14c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1204.56,157.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1201.5,165.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1201.5,165.78Z"
                fill="#2f6840"
              />
              <path
                d="M1201,165.44c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1201,165.44Z"
                fill="#3ba525"
              />
              <path
                d="M1201.75,165.41a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1201.75,165.41Z"
                fill="#2f6840"
              />
              <path
                d="M1205.23,164.62c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1205.23,164.62Z"
                fill="#2f6840"
              />
              <path
                d="M1203.86,167.83a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1203.86,167.83Z"
                fill="#2f6840"
              />
              <path
                d="M1201.9,165.87c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1201.9,165.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.15,160.83c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1196.15,160.83Z"
                fill="#2f6840"
              />
              <path
                d="M1195.65,160.48c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1195.65,160.48Z"
                fill="#3ba525"
              />
              <path
                d="M1196.4,160.45a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1196.4,160.45Z"
                fill="#2f6840"
              />
              <path
                d="M1199.88,159.66a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1199.88,159.66Z"
                fill="#2f6840"
              />
              <path
                d="M1198.51,162.87a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1198.51,162.87Z"
                fill="#2f6840"
              />
              <path
                d="M1196.55,160.91c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1196.55,160.91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1187.81,157.45c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1187.81,157.45Z"
                fill="#2f6840"
              />
              <path
                d="M1187.3,157.11c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1187.3,157.11Z"
                fill="#3ba525"
              />
              <path
                d="M1188.06,157.08a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1188.06,157.08Z"
                fill="#2f6840"
              />
              <path
                d="M1191.53,156.29c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1191.53,156.29Z"
                fill="#2f6840"
              />
              <path
                d="M1190.16,159.5a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1190.16,159.5Z"
                fill="#2f6840"
              />
              <path
                d="M1188.21,157.54c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1188.21,157.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1202.51,172.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1202.51,172.94Z"
                fill="#2f6840"
              />
              <path
                d="M1202,172.6c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1202,172.6Z"
                fill="#3ba525"
              />
              <path
                d="M1202.76,172.57a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1202.76,172.57Z"
                fill="#2f6840"
              />
              <path
                d="M1206.24,171.78c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1206.24,171.78Z"
                fill="#2f6840"
              />
              <path
                d="M1204.87,175a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1204.87,175Z"
                fill="#2f6840"
              />
              <path
                d="M1202.91,173c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1202.91,173Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1189.06,167.37c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1189.06,167.37Z"
                fill="#2f6840"
              />
              <path
                d="M1188.55,167c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1188.55,167Z"
                fill="#3ba525"
              />
              <path
                d="M1189.3,167a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1189.3,167Z"
                fill="#2f6840"
              />
              <path
                d="M1192.78,166.21c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1192.78,166.21Z"
                fill="#2f6840"
              />
              <path
                d="M1191.41,169.42a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1191.41,169.42Z"
                fill="#2f6840"
              />
              <path
                d="M1189.45,167.46c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1189.45,167.46Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M1196.28,405c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1196.28,405Z"
                fill="#2f6840"
              />
              <path
                d="M1195.78,404.64c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1195.78,404.64Z"
                fill="#3ba525"
              />
              <path
                d="M1196.53,404.61a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1196.53,404.61Z"
                fill="#2f6840"
              />
              <path
                d="M1200,403.81c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1200,403.81Z"
                fill="#2f6840"
              />
              <path
                d="M1198.64,407a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1198.64,407Z"
                fill="#2f6840"
              />
              <path
                d="M1196.68,405.07c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1196.68,405.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1193.62,413.71c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1193.62,413.71Z"
                fill="#2f6840"
              />
              <path
                d="M1193.12,413.36c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1193.12,413.36Z"
                fill="#3ba525"
              />
              <path
                d="M1193.87,413.34a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1193.87,413.34Z"
                fill="#2f6840"
              />
              <path
                d="M1197.35,412.54c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1197.35,412.54Z"
                fill="#2f6840"
              />
              <path
                d="M1196,415.75a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1196,415.75Z"
                fill="#2f6840"
              />
              <path
                d="M1194,413.8c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1194,413.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1188.27,408.75c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1188.27,408.75Z"
                fill="#2f6840"
              />
              <path
                d="M1187.77,408.41c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1187.77,408.41Z"
                fill="#3ba525"
              />
              <path
                d="M1188.52,408.38a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,1188.52,408.38Z"
                fill="#2f6840"
              />
              <path
                d="M1192,407.58c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1192,407.58Z"
                fill="#2f6840"
              />
              <path
                d="M1190.63,410.79a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1190.63,410.79Z"
                fill="#2f6840"
              />
              <path
                d="M1188.67,408.84a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1188.67,408.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1179.93,405.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1179.93,405.38Z"
                fill="#2f6840"
              />
              <path
                d="M1179.42,405c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1179.42,405Z"
                fill="#3ba525"
              />
              <path
                d="M1180.18,405a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1180.18,405Z"
                fill="#2f6840"
              />
              <path
                d="M1183.65,404.21c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1183.65,404.21Z"
                fill="#2f6840"
              />
              <path
                d="M1182.29,407.42a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1182.29,407.42Z"
                fill="#2f6840"
              />
              <path
                d="M1180.33,405.47a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1180.33,405.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1194.63,420.87c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1194.63,420.87Z"
                fill="#2f6840"
              />
              <path
                d="M1194.13,420.52c4.42-.25-4.33.46-4.35-.61s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1194.13,420.52Z"
                fill="#3ba525"
              />
              <path
                d="M1194.88,420.5a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1194.88,420.5Z"
                fill="#2f6840"
              />
              <path
                d="M1198.36,419.7c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1198.36,419.7Z"
                fill="#2f6840"
              />
              <path
                d="M1197,422.91a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1197,422.91Z"
                fill="#2f6840"
              />
              <path
                d="M1195,421c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1195,421Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.18,415.3c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1181.18,415.3Z"
                fill="#2f6840"
              />
              <path
                d="M1180.67,415c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1180.67,415Z"
                fill="#3ba525"
              />
              <path
                d="M1181.42,414.93a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1181.42,414.93Z"
                fill="#2f6840"
              />
              <path
                d="M1184.9,414.13c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1184.9,414.13Z"
                fill="#2f6840"
              />
              <path
                d="M1183.53,417.34a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1183.53,417.34Z"
                fill="#2f6840"
              />
              <path
                d="M1181.58,415.39a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1181.58,415.39Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1218.09,389.33c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1218.09,389.33Z"
                fill="#2f6840"
              />
              <path
                d="M1217.58,389c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1217.58,389Z"
                fill="#3ba525"
              />
              <path
                d="M1218.33,389a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1218.33,389Z"
                fill="#2f6840"
              />
              <path
                d="M1221.81,388.16c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1221.81,388.16Z"
                fill="#2f6840"
              />
              <path
                d="M1220.44,391.37a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1220.44,391.37Z"
                fill="#2f6840"
              />
              <path
                d="M1218.49,389.41c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1218.49,389.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1215.43,398.06c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1215.43,398.06Z"
                fill="#2f6840"
              />
              <path
                d="M1214.92,397.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1214.92,397.71Z"
                fill="#3ba525"
              />
              <path
                d="M1215.67,397.68a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1215.67,397.68Z"
                fill="#2f6840"
              />
              <path
                d="M1219.15,396.89c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1219.15,396.89Z"
                fill="#2f6840"
              />
              <path
                d="M1217.78,400.1a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1217.78,400.1Z"
                fill="#2f6840"
              />
              <path
                d="M1215.83,398.14c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1215.83,398.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1210.07,393.1c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1210.07,393.1Z"
                fill="#2f6840"
              />
              <path
                d="M1209.57,392.75c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1209.57,392.75Z"
                fill="#3ba525"
              />
              <path
                d="M1210.32,392.73a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1210.32,392.73Z"
                fill="#2f6840"
              />
              <path
                d="M1213.8,391.93c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1213.8,391.93Z"
                fill="#2f6840"
              />
              <path
                d="M1212.43,395.14a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1212.43,395.14Z"
                fill="#2f6840"
              />
              <path
                d="M1210.47,393.19a7,7,0,0,0-.69.15,4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1210.47,393.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1201.73,389.73c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1201.73,389.73Z"
                fill="#2f6840"
              />
              <path
                d="M1201.23,389.38c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1201.23,389.38Z"
                fill="#3ba525"
              />
              <path
                d="M1202,389.35a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1202,389.35Z"
                fill="#2f6840"
              />
              <path
                d="M1205.46,388.56c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1205.46,388.56Z"
                fill="#2f6840"
              />
              <path
                d="M1204.09,391.77a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1204.09,391.77Z"
                fill="#2f6840"
              />
              <path
                d="M1202.13,389.81c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1202.13,389.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1216.44,405.22c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1216.44,405.22Z"
                fill="#2f6840"
              />
              <path
                d="M1215.93,404.87c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1215.93,404.87Z"
                fill="#3ba525"
              />
              <path
                d="M1216.68,404.84a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1216.68,404.84Z"
                fill="#2f6840"
              />
              <path
                d="M1220.16,404.05a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1220.16,404.05Z"
                fill="#2f6840"
              />
              <path
                d="M1218.79,407.26a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1218.79,407.26Z"
                fill="#2f6840"
              />
              <path
                d="M1216.84,405.3c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1216.84,405.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1203,399.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1203,399.65Z"
                fill="#2f6840"
              />
              <path
                d="M1202.47,399.3c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1202.47,399.3Z"
                fill="#3ba525"
              />
              <path
                d="M1203.23,399.27a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1203.23,399.27Z"
                fill="#2f6840"
              />
              <path
                d="M1206.7,398.48c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1206.7,398.48Z"
                fill="#2f6840"
              />
              <path
                d="M1205.34,401.69a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1205.34,401.69Z"
                fill="#2f6840"
              />
              <path
                d="M1203.38,399.73c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1203.38,399.73Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1244.2,377.92c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1244.2,377.92Z"
                fill="#2f6840"
              />
              <path
                d="M1243.69,377.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1243.69,377.57Z"
                fill="#3ba525"
              />
              <path
                d="M1244.44,377.55a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1244.44,377.55Z"
                fill="#2f6840"
              />
              <path
                d="M1247.92,376.75c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1247.92,376.75Z"
                fill="#2f6840"
              />
              <path
                d="M1246.55,380a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1246.55,380Z"
                fill="#2f6840"
              />
              <path
                d="M1244.6,378c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1244.6,378Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1241.54,386.65c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1241.54,386.65Z"
                fill="#2f6840"
              />
              <path
                d="M1241,386.3c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1241,386.3Z"
                fill="#3ba525"
              />
              <path
                d="M1241.78,386.27a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1241.78,386.27Z"
                fill="#2f6840"
              />
              <path
                d="M1245.26,385.48a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1245.26,385.48Z"
                fill="#2f6840"
              />
              <path
                d="M1243.89,388.69a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1243.89,388.69Z"
                fill="#2f6840"
              />
              <path
                d="M1241.94,386.73c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1241.94,386.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1236.19,381.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1236.19,381.69Z"
                fill="#2f6840"
              />
              <path
                d="M1235.68,381.34c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1235.68,381.34Z"
                fill="#3ba525"
              />
              <path
                d="M1236.43,381.32a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1236.43,381.32Z"
                fill="#2f6840"
              />
              <path
                d="M1239.91,380.52c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1239.91,380.52Z"
                fill="#2f6840"
              />
              <path
                d="M1238.54,383.73a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.83,1.83,0,0,1,.4.57A.94.94,0,0,1,1238.54,383.73Z"
                fill="#2f6840"
              />
              <path
                d="M1236.58,381.78a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1236.58,381.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1227.84,378.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1227.84,378.32Z"
                fill="#2f6840"
              />
              <path
                d="M1227.34,378c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1227.34,378Z"
                fill="#3ba525"
              />
              <path
                d="M1228.09,377.94a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1228.09,377.94Z"
                fill="#2f6840"
              />
              <path
                d="M1231.57,377.15c-.26,0-.49,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1231.57,377.15Z"
                fill="#2f6840"
              />
              <path
                d="M1230.2,380.36a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1230.2,380.36Z"
                fill="#2f6840"
              />
              <path
                d="M1228.24,378.4c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1228.24,378.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1242.55,393.81c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1242.55,393.81Z"
                fill="#2f6840"
              />
              <path
                d="M1242,393.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1242,393.46Z"
                fill="#3ba525"
              />
              <path
                d="M1242.79,393.43a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1242.79,393.43Z"
                fill="#2f6840"
              />
              <path
                d="M1246.27,392.64a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1246.27,392.64Z"
                fill="#2f6840"
              />
              <path
                d="M1244.9,395.85a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1244.9,395.85Z"
                fill="#2f6840"
              />
              <path
                d="M1243,393.89c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1243,393.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1229.09,388.24c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1229.09,388.24Z"
                fill="#2f6840"
              />
              <path
                d="M1228.58,387.89c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S1223.86,389,1224,389A14.55,14.55,0,0,1,1228.58,387.89Z"
                fill="#3ba525"
              />
              <path
                d="M1229.34,387.86a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1229.34,387.86Z"
                fill="#2f6840"
              />
              <path
                d="M1232.82,387.07c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1232.82,387.07Z"
                fill="#2f6840"
              />
              <path
                d="M1231.45,390.28a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1231.45,390.28Z"
                fill="#2f6840"
              />
              <path
                d="M1229.49,388.32c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1229.49,388.32Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1269.74,365.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1269.74,365.47Z"
                fill="#2f6840"
              />
              <path
                d="M1269.24,365.12c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1269.24,365.12Z"
                fill="#3ba525"
              />
              <path
                d="M1270,365.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1270,365.09Z"
                fill="#2f6840"
              />
              <path
                d="M1273.47,364.3a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1273.47,364.3Z"
                fill="#2f6840"
              />
              <path
                d="M1272.1,367.51a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1272.1,367.51Z"
                fill="#2f6840"
              />
              <path
                d="M1270.14,365.55c-.24.06-.47.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1270.14,365.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1267.08,374.2c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1267.08,374.2Z"
                fill="#2f6840"
              />
              <path
                d="M1266.58,373.85c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1266.58,373.85Z"
                fill="#3ba525"
              />
              <path
                d="M1267.33,373.82a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1267.33,373.82Z"
                fill="#2f6840"
              />
              <path
                d="M1270.81,373c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1270.81,373Z"
                fill="#2f6840"
              />
              <path
                d="M1269.44,376.24a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1269.44,376.24Z"
                fill="#2f6840"
              />
              <path
                d="M1267.48,374.28c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1267.48,374.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1261.73,369.24c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1261.73,369.24Z"
                fill="#2f6840"
              />
              <path
                d="M1261.23,368.89c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1261.23,368.89Z"
                fill="#3ba525"
              />
              <path
                d="M1262,368.86a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1262,368.86Z"
                fill="#2f6840"
              />
              <path
                d="M1265.46,368.07a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53A2.4,2.4,0,0,1,1264,368,2.07,2.07,0,0,1,1265.46,368.07Z"
                fill="#2f6840"
              />
              <path
                d="M1264.09,371.28a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1264.09,371.28Z"
                fill="#2f6840"
              />
              <path
                d="M1262.13,369.32c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1262.13,369.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1253.39,365.87c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1253.39,365.87Z"
                fill="#2f6840"
              />
              <path
                d="M1252.88,365.52c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1252.88,365.52Z"
                fill="#3ba525"
              />
              <path
                d="M1253.64,365.49a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1253.64,365.49Z"
                fill="#2f6840"
              />
              <path
                d="M1257.11,364.7c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1257.11,364.7Z"
                fill="#2f6840"
              />
              <path
                d="M1255.75,367.91a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1255.75,367.91Z"
                fill="#2f6840"
              />
              <path
                d="M1253.79,366c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1253.79,366Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1268.09,381.35c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1268.09,381.35Z"
                fill="#2f6840"
              />
              <path
                d="M1267.59,381c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1267.59,381Z"
                fill="#3ba525"
              />
              <path
                d="M1268.34,381a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1268.34,381Z"
                fill="#2f6840"
              />
              <path
                d="M1271.82,380.19c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1271.82,380.19Z"
                fill="#2f6840"
              />
              <path
                d="M1270.45,383.4a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1270.45,383.4Z"
                fill="#2f6840"
              />
              <path
                d="M1268.49,381.44c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1268.49,381.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1254.64,375.79c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1254.64,375.79Z"
                fill="#2f6840"
              />
              <path
                d="M1254.13,375.44c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1254.13,375.44Z"
                fill="#3ba525"
              />
              <path
                d="M1254.88,375.41a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1254.88,375.41Z"
                fill="#2f6840"
              />
              <path
                d="M1258.36,374.62c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,9.91,9.91,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1258.36,374.62Z"
                fill="#2f6840"
              />
              <path
                d="M1257,377.83a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1257,377.83Z"
                fill="#2f6840"
              />
              <path
                d="M1255,375.87c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1255,375.87Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1278.09,340c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1278.09,340Z"
                fill="#2f6840"
              />
              <path
                d="M1277.59,339.61c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1277.59,339.61Z"
                fill="#3ba525"
              />
              <path
                d="M1278.34,339.58a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1278.34,339.58Z"
                fill="#2f6840"
              />
              <path
                d="M1281.82,338.79c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.44,2.44,0,0,1,1.24-.86A2.07,2.07,0,0,1,1281.82,338.79Z"
                fill="#2f6840"
              />
              <path
                d="M1280.45,342a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1280.45,342Z"
                fill="#2f6840"
              />
              <path
                d="M1278.49,340c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1278.49,340Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1275.43,348.68c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1275.43,348.68Z"
                fill="#2f6840"
              />
              <path
                d="M1274.93,348.34c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1274.93,348.34Z"
                fill="#3ba525"
              />
              <path
                d="M1275.68,348.31a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1275.68,348.31Z"
                fill="#2f6840"
              />
              <path
                d="M1279.16,347.52c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1279.16,347.52Z"
                fill="#2f6840"
              />
              <path
                d="M1277.79,350.73a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1277.79,350.73Z"
                fill="#2f6840"
              />
              <path
                d="M1275.83,348.77c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1275.83,348.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1270.08,343.73c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1270.08,343.73Z"
                fill="#2f6840"
              />
              <path
                d="M1269.58,343.38c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1269.58,343.38Z"
                fill="#3ba525"
              />
              <path
                d="M1270.33,343.35a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1270.33,343.35Z"
                fill="#2f6840"
              />
              <path
                d="M1273.81,342.56a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1273.81,342.56Z"
                fill="#2f6840"
              />
              <path
                d="M1272.44,345.77a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1272.44,345.77Z"
                fill="#2f6840"
              />
              <path
                d="M1270.48,343.81c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1270.48,343.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1261.74,340.35c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1261.74,340.35Z"
                fill="#2f6840"
              />
              <path
                d="M1261.23,340c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1261.23,340Z"
                fill="#3ba525"
              />
              <path
                d="M1262,340a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1262,340Z"
                fill="#2f6840"
              />
              <path
                d="M1265.46,339.19c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1265.46,339.19Z"
                fill="#2f6840"
              />
              <path
                d="M1264.1,342.4a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1264.1,342.4Z"
                fill="#2f6840"
              />
              <path
                d="M1262.14,340.44c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1262.14,340.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1276.44,355.84c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1276.44,355.84Z"
                fill="#2f6840"
              />
              <path
                d="M1275.94,355.5c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1275.94,355.5Z"
                fill="#3ba525"
              />
              <path
                d="M1276.69,355.47a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1276.69,355.47Z"
                fill="#2f6840"
              />
              <path
                d="M1280.17,354.68c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1280.17,354.68Z"
                fill="#2f6840"
              />
              <path
                d="M1278.8,357.89a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1278.8,357.89Z"
                fill="#2f6840"
              />
              <path
                d="M1276.84,355.93c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1276.84,355.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1263,350.27c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1263,350.27Z"
                fill="#2f6840"
              />
              <path
                d="M1262.48,349.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1262.48,349.93Z"
                fill="#3ba525"
              />
              <path
                d="M1263.23,349.9a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1263.23,349.9Z"
                fill="#2f6840"
              />
              <path
                d="M1266.71,349.11c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1266.71,349.11Z"
                fill="#2f6840"
              />
              <path
                d="M1265.34,352.32a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1265.34,352.32Z"
                fill="#2f6840"
              />
              <path
                d="M1263.39,350.36c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1263.39,350.36Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1273.68,311.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1273.68,311.8Z"
                fill="#2f6840"
              />
              <path
                d="M1273.18,311.46c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1273.18,311.46Z"
                fill="#3ba525"
              />
              <path
                d="M1273.93,311.43a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1273.93,311.43Z"
                fill="#2f6840"
              />
              <path
                d="M1277.41,310.64c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1277.41,310.64Z"
                fill="#2f6840"
              />
              <path
                d="M1276,313.85a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1276,313.85Z"
                fill="#2f6840"
              />
              <path
                d="M1274.08,311.89c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1274.08,311.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1271,320.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1271,320.53Z"
                fill="#2f6840"
              />
              <path
                d="M1270.52,320.19c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1270.52,320.19Z"
                fill="#3ba525"
              />
              <path
                d="M1271.27,320.16a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1271.27,320.16Z"
                fill="#2f6840"
              />
              <path
                d="M1274.75,319.36c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1274.75,319.36Z"
                fill="#2f6840"
              />
              <path
                d="M1273.38,322.57a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1273.38,322.57Z"
                fill="#2f6840"
              />
              <path
                d="M1271.42,320.62c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1271.42,320.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1265.67,315.57c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1265.67,315.57Z"
                fill="#2f6840"
              />
              <path
                d="M1265.16,315.23c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1265.16,315.23Z"
                fill="#3ba525"
              />
              <path
                d="M1265.92,315.2a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1265.92,315.2Z"
                fill="#2f6840"
              />
              <path
                d="M1269.4,314.41c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1269.4,314.41Z"
                fill="#2f6840"
              />
              <path
                d="M1268,317.62a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1268,317.62Z"
                fill="#2f6840"
              />
              <path
                d="M1266.07,315.66c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1266.07,315.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1257.33,312.2c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1257.33,312.2Z"
                fill="#2f6840"
              />
              <path
                d="M1256.82,311.86c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1256.82,311.86Z"
                fill="#3ba525"
              />
              <path
                d="M1257.58,311.83a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1257.58,311.83Z"
                fill="#2f6840"
              />
              <path
                d="M1261.05,311c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1261.05,311Z"
                fill="#2f6840"
              />
              <path
                d="M1259.68,314.25a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1259.68,314.25Z"
                fill="#2f6840"
              />
              <path
                d="M1257.73,312.29c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1257.73,312.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1272,327.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1272,327.69Z"
                fill="#2f6840"
              />
              <path
                d="M1271.53,327.35c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1271.53,327.35Z"
                fill="#3ba525"
              />
              <path
                d="M1272.28,327.32a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1272.28,327.32Z"
                fill="#2f6840"
              />
              <path
                d="M1275.76,326.52c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1275.76,326.52Z"
                fill="#2f6840"
              />
              <path
                d="M1274.39,329.73a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1274.39,329.73Z"
                fill="#2f6840"
              />
              <path
                d="M1272.43,327.78c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1272.43,327.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1258.58,322.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1258.58,322.12Z"
                fill="#2f6840"
              />
              <path
                d="M1258.07,321.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1258.07,321.78Z"
                fill="#3ba525"
              />
              <path
                d="M1258.82,321.75a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1258.82,321.75Z"
                fill="#2f6840"
              />
              <path
                d="M1262.3,321c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1262.3,321Z"
                fill="#2f6840"
              />
              <path
                d="M1260.93,324.17a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1260.93,324.17Z"
                fill="#2f6840"
              />
              <path
                d="M1259,322.21c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1259,322.21Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1253.75,296.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1253.75,296.8Z"
                fill="#2f6840"
              />
              <path
                d="M1253.24,296.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1253.24,296.46Z"
                fill="#3ba525"
              />
              <path
                d="M1254,296.43a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.35,2.35,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1254,296.43Z"
                fill="#2f6840"
              />
              <path
                d="M1257.47,295.63c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1257.47,295.63Z"
                fill="#2f6840"
              />
              <path
                d="M1256.1,298.84a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1256.1,298.84Z"
                fill="#2f6840"
              />
              <path
                d="M1254.15,296.89c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1254.15,296.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1251.09,305.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1251.09,305.53Z"
                fill="#2f6840"
              />
              <path
                d="M1250.58,305.19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1250.58,305.19Z"
                fill="#3ba525"
              />
              <path
                d="M1251.33,305.16a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1251.33,305.16Z"
                fill="#2f6840"
              />
              <path
                d="M1254.81,304.36c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1254.81,304.36Z"
                fill="#2f6840"
              />
              <path
                d="M1253.44,307.57a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1253.44,307.57Z"
                fill="#2f6840"
              />
              <path
                d="M1251.49,305.62a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1251.49,305.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1245.73,300.57c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1245.73,300.57Z"
                fill="#2f6840"
              />
              <path
                d="M1245.23,300.23c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1245.23,300.23Z"
                fill="#3ba525"
              />
              <path
                d="M1246,300.2a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1246,300.2Z"
                fill="#2f6840"
              />
              <path
                d="M1249.46,299.4c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1249.46,299.4Z"
                fill="#2f6840"
              />
              <path
                d="M1248.09,302.61a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1248.09,302.61Z"
                fill="#2f6840"
              />
              <path
                d="M1246.13,300.66c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1246.13,300.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1237.39,297.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1237.39,297.2Z"
                fill="#2f6840"
              />
              <path
                d="M1236.89,296.86c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1236.89,296.86Z"
                fill="#3ba525"
              />
              <path
                d="M1237.64,296.83a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1237.64,296.83Z"
                fill="#2f6840"
              />
              <path
                d="M1241.12,296c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1241.12,296Z"
                fill="#2f6840"
              />
              <path
                d="M1239.75,299.24a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1239.75,299.24Z"
                fill="#2f6840"
              />
              <path
                d="M1237.79,297.29a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1237.79,297.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1252.1,312.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1252.1,312.69Z"
                fill="#2f6840"
              />
              <path
                d="M1251.59,312.35c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1251.59,312.35Z"
                fill="#3ba525"
              />
              <path
                d="M1252.34,312.32a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1252.34,312.32Z"
                fill="#2f6840"
              />
              <path
                d="M1255.82,311.52c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1255.82,311.52Z"
                fill="#2f6840"
              />
              <path
                d="M1254.45,314.73a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1254.45,314.73Z"
                fill="#2f6840"
              />
              <path
                d="M1252.5,312.78a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1252.5,312.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.64,307.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1238.64,307.12Z"
                fill="#2f6840"
              />
              <path
                d="M1238.13,306.78c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1238.13,306.78Z"
                fill="#3ba525"
              />
              <path
                d="M1238.89,306.75a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1238.89,306.75Z"
                fill="#2f6840"
              />
              <path
                d="M1242.36,306c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1242.36,306Z"
                fill="#2f6840"
              />
              <path
                d="M1241,309.16a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1241,309.16Z"
                fill="#2f6840"
              />
              <path
                d="M1239,307.21a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1239,307.21Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1225.27,295.85c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1225.27,295.85Z"
                fill="#2f6840"
              />
              <path
                d="M1224.76,295.51c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1224.76,295.51Z"
                fill="#3ba525"
              />
              <path
                d="M1225.51,295.48a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1225.51,295.48Z"
                fill="#2f6840"
              />
              <path
                d="M1229,294.68c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1229,294.68Z"
                fill="#2f6840"
              />
              <path
                d="M1227.62,297.89a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1227.62,297.89Z"
                fill="#2f6840"
              />
              <path
                d="M1225.67,295.94a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1225.67,295.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1222.61,304.58c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1222.61,304.58Z"
                fill="#2f6840"
              />
              <path
                d="M1222.1,304.23c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1222.1,304.23Z"
                fill="#3ba525"
              />
              <path
                d="M1222.86,304.21a2.18,2.18,0,0,0-.8-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1222.86,304.21Z"
                fill="#2f6840"
              />
              <path
                d="M1226.33,303.41c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1226.33,303.41Z"
                fill="#2f6840"
              />
              <path
                d="M1225,306.62a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1225,306.62Z"
                fill="#2f6840"
              />
              <path
                d="M1223,304.67a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1223,304.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1217.26,299.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1217.26,299.62Z"
                fill="#2f6840"
              />
              <path
                d="M1216.75,299.28c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1216.75,299.28Z"
                fill="#3ba525"
              />
              <path
                d="M1217.5,299.25a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1217.5,299.25Z"
                fill="#2f6840"
              />
              <path
                d="M1221,298.45c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1221,298.45Z"
                fill="#2f6840"
              />
              <path
                d="M1219.61,301.66a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1219.61,301.66Z"
                fill="#2f6840"
              />
              <path
                d="M1217.65,299.71a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1217.65,299.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1208.91,296.25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1208.91,296.25Z"
                fill="#2f6840"
              />
              <path
                d="M1208.41,295.91c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1208.41,295.91Z"
                fill="#3ba525"
              />
              <path
                d="M1209.16,295.88a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1209.16,295.88Z"
                fill="#2f6840"
              />
              <path
                d="M1212.64,295.08c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1212.64,295.08Z"
                fill="#2f6840"
              />
              <path
                d="M1211.27,298.29a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1211.27,298.29Z"
                fill="#2f6840"
              />
              <path
                d="M1209.31,296.34c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1209.31,296.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1223.62,311.74c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1223.62,311.74Z"
                fill="#2f6840"
              />
              <path
                d="M1223.11,311.39c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.77,14.77,0,0,1,1223.11,311.39Z"
                fill="#3ba525"
              />
              <path
                d="M1223.86,311.37a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1223.86,311.37Z"
                fill="#2f6840"
              />
              <path
                d="M1227.34,310.57c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1227.34,310.57Z"
                fill="#2f6840"
              />
              <path
                d="M1226,313.78a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1226,313.78Z"
                fill="#2f6840"
              />
              <path
                d="M1224,311.83a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1224,311.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1210.16,306.17c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1210.16,306.17Z"
                fill="#2f6840"
              />
              <path
                d="M1209.66,305.83c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1209.66,305.83Z"
                fill="#3ba525"
              />
              <path
                d="M1210.41,305.8a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1210.41,305.8Z"
                fill="#2f6840"
              />
              <path
                d="M1213.89,305c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1213.89,305Z"
                fill="#2f6840"
              />
              <path
                d="M1212.52,308.21a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1212.52,308.21Z"
                fill="#2f6840"
              />
              <path
                d="M1210.56,306.26a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1210.56,306.26Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1197.71,292.11c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1197.71,292.11Z"
                fill="#2f6840"
              />
              <path
                d="M1197.21,291.76c4.42-.25-4.33.46-4.35-.61s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1197.21,291.76Z"
                fill="#3ba525"
              />
              <path
                d="M1198,291.74a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1198,291.74Z"
                fill="#2f6840"
              />
              <path
                d="M1201.44,290.94c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1201.44,290.94Z"
                fill="#2f6840"
              />
              <path
                d="M1200.07,294.15a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1200.07,294.15Z"
                fill="#2f6840"
              />
              <path
                d="M1198.11,292.2c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1198.11,292.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.05,300.84c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1195.05,300.84Z"
                fill="#2f6840"
              />
              <path
                d="M1194.55,300.49c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1194.55,300.49Z"
                fill="#3ba525"
              />
              <path
                d="M1195.3,300.46a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1195.3,300.46Z"
                fill="#2f6840"
              />
              <path
                d="M1198.78,299.67c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1198.78,299.67Z"
                fill="#2f6840"
              />
              <path
                d="M1197.41,302.88a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1197.41,302.88Z"
                fill="#2f6840"
              />
              <path
                d="M1195.45,300.92c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1195.45,300.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1189.7,295.88c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1189.7,295.88Z"
                fill="#2f6840"
              />
              <path
                d="M1189.2,295.54c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1189.2,295.54Z"
                fill="#3ba525"
              />
              <path
                d="M1190,295.51a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,1190,295.51Z"
                fill="#2f6840"
              />
              <path
                d="M1193.43,294.71c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1193.43,294.71Z"
                fill="#2f6840"
              />
              <path
                d="M1192.06,297.92a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1192.06,297.92Z"
                fill="#2f6840"
              />
              <path
                d="M1190.1,296a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1190.1,296Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.36,292.51c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1181.36,292.51Z"
                fill="#2f6840"
              />
              <path
                d="M1180.85,292.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1180.85,292.16Z"
                fill="#3ba525"
              />
              <path
                d="M1181.61,292.13a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1181.61,292.13Z"
                fill="#2f6840"
              />
              <path
                d="M1185.08,291.34c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1185.08,291.34Z"
                fill="#2f6840"
              />
              <path
                d="M1183.72,294.55a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1183.72,294.55Z"
                fill="#2f6840"
              />
              <path
                d="M1181.76,292.59c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1181.76,292.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.06,308c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1196.06,308Z"
                fill="#2f6840"
              />
              <path
                d="M1195.56,307.65c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1195.56,307.65Z"
                fill="#3ba525"
              />
              <path
                d="M1196.31,307.62a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1196.31,307.62Z"
                fill="#2f6840"
              />
              <path
                d="M1199.79,306.83c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1199.79,306.83Z"
                fill="#2f6840"
              />
              <path
                d="M1198.42,310a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1198.42,310Z"
                fill="#2f6840"
              />
              <path
                d="M1196.46,308.08c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1196.46,308.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182.61,302.43c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1182.61,302.43Z"
                fill="#2f6840"
              />
              <path
                d="M1182.1,302.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1182.1,302.08Z"
                fill="#3ba525"
              />
              <path
                d="M1182.85,302.05a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1182.85,302.05Z"
                fill="#2f6840"
              />
              <path
                d="M1186.33,301.26c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1186.33,301.26Z"
                fill="#2f6840"
              />
              <path
                d="M1185,304.47a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1185,304.47Z"
                fill="#2f6840"
              />
              <path
                d="M1183,302.51c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1183,302.51Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1193.2,270.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1193.2,270.15Z"
                fill="#2f6840"
              />
              <path
                d="M1192.69,269.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1192.69,269.8Z"
                fill="#3ba525"
              />
              <path
                d="M1193.45,269.78a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1193.45,269.78Z"
                fill="#2f6840"
              />
              <path
                d="M1196.92,269c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1196.92,269Z"
                fill="#2f6840"
              />
              <path
                d="M1195.56,272.19a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1195.56,272.19Z"
                fill="#2f6840"
              />
              <path
                d="M1193.6,270.23c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1193.6,270.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1190.54,278.88c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1190.54,278.88Z"
                fill="#2f6840"
              />
              <path
                d="M1190,278.53c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1190,278.53Z"
                fill="#3ba525"
              />
              <path
                d="M1190.79,278.5a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1190.79,278.5Z"
                fill="#2f6840"
              />
              <path
                d="M1194.26,277.71a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1194.26,277.71Z"
                fill="#2f6840"
              />
              <path
                d="M1192.9,280.92a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1192.9,280.92Z"
                fill="#2f6840"
              />
              <path
                d="M1190.94,279c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1190.94,279Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1185.19,273.92c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1185.19,273.92Z"
                fill="#2f6840"
              />
              <path
                d="M1184.68,273.57c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1184.68,273.57Z"
                fill="#3ba525"
              />
              <path
                d="M1185.43,273.55a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1185.43,273.55Z"
                fill="#2f6840"
              />
              <path
                d="M1188.91,272.75c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1188.91,272.75Z"
                fill="#2f6840"
              />
              <path
                d="M1187.54,276a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1187.54,276Z"
                fill="#2f6840"
              />
              <path
                d="M1185.59,274a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1185.59,274Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1176.84,270.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1176.84,270.55Z"
                fill="#2f6840"
              />
              <path
                d="M1176.34,270.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1176.34,270.2Z"
                fill="#3ba525"
              />
              <path
                d="M1177.09,270.17a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1177.09,270.17Z"
                fill="#2f6840"
              />
              <path
                d="M1180.57,269.38c-.26,0-.49,0-.72.1a3,3,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1180.57,269.38Z"
                fill="#2f6840"
              />
              <path
                d="M1179.2,272.59a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1179.2,272.59Z"
                fill="#2f6840"
              />
              <path
                d="M1177.24,270.63c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1177.24,270.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1191.55,286c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1191.55,286Z"
                fill="#2f6840"
              />
              <path
                d="M1191,285.69c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1191,285.69Z"
                fill="#3ba525"
              />
              <path
                d="M1191.8,285.66a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1191.8,285.66Z"
                fill="#2f6840"
              />
              <path
                d="M1195.27,284.87a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1195.27,284.87Z"
                fill="#2f6840"
              />
              <path
                d="M1193.91,288.08a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1193.91,288.08Z"
                fill="#2f6840"
              />
              <path
                d="M1192,286.12c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1192,286.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1178.09,280.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1178.09,280.47Z"
                fill="#2f6840"
              />
              <path
                d="M1177.59,280.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1177.59,280.12Z"
                fill="#3ba525"
              />
              <path
                d="M1178.34,280.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1178.34,280.09Z"
                fill="#2f6840"
              />
              <path
                d="M1181.82,279.3c-.26,0-.49,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1181.82,279.3Z"
                fill="#2f6840"
              />
              <path
                d="M1180.45,282.51a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1180.45,282.51Z"
                fill="#2f6840"
              />
              <path
                d="M1178.49,280.55c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1178.49,280.55Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1221.32,267.9c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.86,14.86,0,0,1,1221.32,267.9Z"
                fill="#2f6840"
              />
              <path
                d="M1220.82,267.56c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1220.82,267.56Z"
                fill="#3ba525"
              />
              <path
                d="M1221.57,267.53a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1221.57,267.53Z"
                fill="#2f6840"
              />
              <path
                d="M1225.05,266.74c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1225.05,266.74Z"
                fill="#2f6840"
              />
              <path
                d="M1223.68,270a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1223.68,270Z"
                fill="#2f6840"
              />
              <path
                d="M1221.72,268c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1221.72,268Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1218.67,276.63c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1218.67,276.63Z"
                fill="#2f6840"
              />
              <path
                d="M1218.16,276.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1218.16,276.29Z"
                fill="#3ba525"
              />
              <path
                d="M1218.91,276.26a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1218.91,276.26Z"
                fill="#2f6840"
              />
              <path
                d="M1222.39,275.47c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1222.39,275.47Z"
                fill="#2f6840"
              />
              <path
                d="M1221,278.68a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1221,278.68Z"
                fill="#2f6840"
              />
              <path
                d="M1219.06,276.72c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1219.06,276.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1213.31,271.68c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1213.31,271.68Z"
                fill="#2f6840"
              />
              <path
                d="M1212.81,271.33c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1212.81,271.33Z"
                fill="#3ba525"
              />
              <path
                d="M1213.56,271.3a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1213.56,271.3Z"
                fill="#2f6840"
              />
              <path
                d="M1217,270.51a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1217,270.51Z"
                fill="#2f6840"
              />
              <path
                d="M1215.67,273.72a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1215.67,273.72Z"
                fill="#2f6840"
              />
              <path
                d="M1213.71,271.76c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1213.71,271.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1205,268.3c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1205,268.3Z"
                fill="#2f6840"
              />
              <path
                d="M1204.46,268c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1204.46,268Z"
                fill="#3ba525"
              />
              <path
                d="M1205.22,267.93a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1205.22,267.93Z"
                fill="#2f6840"
              />
              <path
                d="M1208.7,267.14c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1208.7,267.14Z"
                fill="#2f6840"
              />
              <path
                d="M1207.33,270.35a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1207.33,270.35Z"
                fill="#2f6840"
              />
              <path
                d="M1205.37,268.39c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1205.37,268.39Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1219.68,283.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1219.68,283.79Z"
                fill="#2f6840"
              />
              <path
                d="M1219.17,283.45c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1219.17,283.45Z"
                fill="#3ba525"
              />
              <path
                d="M1219.92,283.42a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1219.92,283.42Z"
                fill="#2f6840"
              />
              <path
                d="M1223.4,282.63c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1223.4,282.63Z"
                fill="#2f6840"
              />
              <path
                d="M1222,285.84a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1222,285.84Z"
                fill="#2f6840"
              />
              <path
                d="M1220.07,283.88c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1220.07,283.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1206.22,278.22c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1206.22,278.22Z"
                fill="#2f6840"
              />
              <path
                d="M1205.71,277.88c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1205.71,277.88Z"
                fill="#3ba525"
              />
              <path
                d="M1206.47,277.85a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1206.47,277.85Z"
                fill="#2f6840"
              />
              <path
                d="M1209.94,277.06c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1209.94,277.06Z"
                fill="#2f6840"
              />
              <path
                d="M1208.58,280.27a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1208.58,280.27Z"
                fill="#2f6840"
              />
              <path
                d="M1206.62,278.31c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1206.62,278.31Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1249.18,263.05c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1249.18,263.05Z"
                fill="#2f6840"
              />
              <path
                d="M1248.67,262.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1248.67,262.71Z"
                fill="#3ba525"
              />
              <path
                d="M1249.43,262.68a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1249.43,262.68Z"
                fill="#2f6840"
              />
              <path
                d="M1252.9,261.88c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1252.9,261.88Z"
                fill="#2f6840"
              />
              <path
                d="M1251.54,265.09a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1251.54,265.09Z"
                fill="#2f6840"
              />
              <path
                d="M1249.58,263.14c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1249.58,263.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1246.52,271.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1246.52,271.78Z"
                fill="#2f6840"
              />
              <path
                d="M1246,271.44c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1246,271.44Z"
                fill="#3ba525"
              />
              <path
                d="M1246.77,271.41a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1246.77,271.41Z"
                fill="#2f6840"
              />
              <path
                d="M1250.24,270.61c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1250.24,270.61Z"
                fill="#2f6840"
              />
              <path
                d="M1248.88,273.82a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1248.88,273.82Z"
                fill="#2f6840"
              />
              <path
                d="M1246.92,271.87c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1246.92,271.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1241.17,266.82c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1241.17,266.82Z"
                fill="#2f6840"
              />
              <path
                d="M1240.66,266.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1240.66,266.48Z"
                fill="#3ba525"
              />
              <path
                d="M1241.41,266.45a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1241.41,266.45Z"
                fill="#2f6840"
              />
              <path
                d="M1244.89,265.66c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1244.89,265.66Z"
                fill="#2f6840"
              />
              <path
                d="M1243.52,268.87a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1243.52,268.87Z"
                fill="#2f6840"
              />
              <path
                d="M1241.57,266.91c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1241.57,266.91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1232.82,263.45c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1232.82,263.45Z"
                fill="#2f6840"
              />
              <path
                d="M1232.32,263.11c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1232.32,263.11Z"
                fill="#3ba525"
              />
              <path
                d="M1233.07,263.08a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1233.07,263.08Z"
                fill="#2f6840"
              />
              <path
                d="M1236.55,262.28c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1236.55,262.28Z"
                fill="#2f6840"
              />
              <path
                d="M1235.18,265.49a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1235.18,265.49Z"
                fill="#2f6840"
              />
              <path
                d="M1233.22,263.54c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1233.22,263.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1247.53,278.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1247.53,278.94Z"
                fill="#2f6840"
              />
              <path
                d="M1247,278.6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1247,278.6Z"
                fill="#3ba525"
              />
              <path
                d="M1247.78,278.57a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1247.78,278.57Z"
                fill="#2f6840"
              />
              <path
                d="M1251.25,277.77c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1251.25,277.77Z"
                fill="#2f6840"
              />
              <path
                d="M1249.89,281a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1249.89,281Z"
                fill="#2f6840"
              />
              <path
                d="M1247.93,279c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1247.93,279Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1234.07,273.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1234.07,273.37Z"
                fill="#2f6840"
              />
              <path
                d="M1233.57,273c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1233.57,273Z"
                fill="#3ba525"
              />
              <path
                d="M1234.32,273a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1234.32,273Z"
                fill="#2f6840"
              />
              <path
                d="M1237.8,272.2c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1237.8,272.2Z"
                fill="#2f6840"
              />
              <path
                d="M1236.43,275.41a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1236.43,275.41Z"
                fill="#2f6840"
              />
              <path
                d="M1234.47,273.46c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1234.47,273.46Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1240.4,243c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1240.4,243Z"
                fill="#2f6840"
              />
              <path
                d="M1239.89,242.61c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1239.89,242.61Z"
                fill="#3ba525"
              />
              <path
                d="M1240.65,242.58a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1240.65,242.58Z"
                fill="#2f6840"
              />
              <path
                d="M1244.12,241.79c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1244.12,241.79Z"
                fill="#2f6840"
              />
              <path
                d="M1242.76,245a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1242.76,245Z"
                fill="#2f6840"
              />
              <path
                d="M1240.8,243c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1240.8,243Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1237.74,251.69c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1237.74,251.69Z"
                fill="#2f6840"
              />
              <path
                d="M1237.23,251.34c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1237.23,251.34Z"
                fill="#3ba525"
              />
              <path
                d="M1238,251.31a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1238,251.31Z"
                fill="#2f6840"
              />
              <path
                d="M1241.46,250.52a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1241.46,250.52Z"
                fill="#2f6840"
              />
              <path
                d="M1240.1,253.73a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1240.1,253.73Z"
                fill="#2f6840"
              />
              <path
                d="M1238.14,251.77c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1238.14,251.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1232.39,246.73c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1232.39,246.73Z"
                fill="#2f6840"
              />
              <path
                d="M1231.88,246.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.88,246.38Z"
                fill="#3ba525"
              />
              <path
                d="M1232.63,246.36a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1232.63,246.36Z"
                fill="#2f6840"
              />
              <path
                d="M1236.11,245.56c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1236.11,245.56Z"
                fill="#2f6840"
              />
              <path
                d="M1234.74,248.77a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1234.74,248.77Z"
                fill="#2f6840"
              />
              <path
                d="M1232.79,246.81c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1232.79,246.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1224.05,243.36c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1224.05,243.36Z"
                fill="#2f6840"
              />
              <path
                d="M1223.54,243c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1223.54,243Z"
                fill="#3ba525"
              />
              <path
                d="M1224.29,243a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1224.29,243Z"
                fill="#2f6840"
              />
              <path
                d="M1227.77,242.19a5.21,5.21,0,0,0-.72.1,3.08,3.08,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1227.77,242.19Z"
                fill="#2f6840"
              />
              <path
                d="M1226.4,245.4a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1226.4,245.4Z"
                fill="#2f6840"
              />
              <path
                d="M1224.44,243.44c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1224.44,243.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.75,258.85c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1238.75,258.85Z"
                fill="#2f6840"
              />
              <path
                d="M1238.24,258.5c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1238.24,258.5Z"
                fill="#3ba525"
              />
              <path
                d="M1239,258.47a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1239,258.47Z"
                fill="#2f6840"
              />
              <path
                d="M1242.47,257.68a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1242.47,257.68Z"
                fill="#2f6840"
              />
              <path
                d="M1241.11,260.89a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1241.11,260.89Z"
                fill="#2f6840"
              />
              <path
                d="M1239.15,258.93c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1239.15,258.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1225.29,253.28c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1225.29,253.28Z"
                fill="#2f6840"
              />
              <path
                d="M1224.79,252.93c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1224.79,252.93Z"
                fill="#3ba525"
              />
              <path
                d="M1225.54,252.9a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1225.54,252.9Z"
                fill="#2f6840"
              />
              <path
                d="M1229,252.11a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1229,252.11Z"
                fill="#2f6840"
              />
              <path
                d="M1227.65,255.32a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1227.65,255.32Z"
                fill="#2f6840"
              />
              <path
                d="M1225.69,253.36c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1225.69,253.36Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1221.16,221.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1221.16,221.94Z"
                fill="#2f6840"
              />
              <path
                d="M1220.65,221.6c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1220.65,221.6Z"
                fill="#3ba525"
              />
              <path
                d="M1221.41,221.57a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1221.41,221.57Z"
                fill="#2f6840"
              />
              <path
                d="M1224.89,220.77c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1224.89,220.77Z"
                fill="#2f6840"
              />
              <path
                d="M1223.52,224a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1223.52,224Z"
                fill="#2f6840"
              />
              <path
                d="M1221.56,222c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1221.56,222Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1218.5,230.67c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1218.5,230.67Z"
                fill="#2f6840"
              />
              <path
                d="M1218,230.33c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1218,230.33Z"
                fill="#3ba525"
              />
              <path
                d="M1218.75,230.3a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1218.75,230.3Z"
                fill="#2f6840"
              />
              <path
                d="M1222.23,229.5c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1222.23,229.5Z"
                fill="#2f6840"
              />
              <path
                d="M1220.86,232.71a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1220.86,232.71Z"
                fill="#2f6840"
              />
              <path
                d="M1218.9,230.76a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1218.9,230.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1213.15,225.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1213.15,225.71Z"
                fill="#2f6840"
              />
              <path
                d="M1212.64,225.37c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1212.64,225.37Z"
                fill="#3ba525"
              />
              <path
                d="M1213.4,225.34a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1213.4,225.34Z"
                fill="#2f6840"
              />
              <path
                d="M1216.87,224.54c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1216.87,224.54Z"
                fill="#2f6840"
              />
              <path
                d="M1215.51,227.75a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1215.51,227.75Z"
                fill="#2f6840"
              />
              <path
                d="M1213.55,225.8c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.31,8.31,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1213.55,225.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1204.81,222.34c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1204.81,222.34Z"
                fill="#2f6840"
              />
              <path
                d="M1204.3,222c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1204.3,222Z"
                fill="#3ba525"
              />
              <path
                d="M1205.05,222a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1205.05,222Z"
                fill="#2f6840"
              />
              <path
                d="M1208.53,221.17c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1208.53,221.17Z"
                fill="#2f6840"
              />
              <path
                d="M1207.16,224.38a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1207.16,224.38Z"
                fill="#2f6840"
              />
              <path
                d="M1205.21,222.43a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,1205.21,222.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1219.51,237.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1219.51,237.83Z"
                fill="#2f6840"
              />
              <path
                d="M1219,237.49c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1219,237.49Z"
                fill="#3ba525"
              />
              <path
                d="M1219.76,237.46a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1219.76,237.46Z"
                fill="#2f6840"
              />
              <path
                d="M1223.24,236.66c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1223.24,236.66Z"
                fill="#2f6840"
              />
              <path
                d="M1221.87,239.87a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1221.87,239.87Z"
                fill="#2f6840"
              />
              <path
                d="M1219.91,237.92a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1219.91,237.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1206.05,232.26c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1206.05,232.26Z"
                fill="#2f6840"
              />
              <path
                d="M1205.55,231.92c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1205.55,231.92Z"
                fill="#3ba525"
              />
              <path
                d="M1206.3,231.89a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1206.3,231.89Z"
                fill="#2f6840"
              />
              <path
                d="M1209.78,231.09c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1209.78,231.09Z"
                fill="#2f6840"
              />
              <path
                d="M1208.41,234.3a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1208.41,234.3Z"
                fill="#2f6840"
              />
              <path
                d="M1206.45,232.35a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1206.45,232.35Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1198.19,206c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1198.19,206Z"
                fill="#2f6840"
              />
              <path
                d="M1197.68,205.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1197.68,205.68Z"
                fill="#3ba525"
              />
              <path
                d="M1198.43,205.65a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1198.43,205.65Z"
                fill="#2f6840"
              />
              <path
                d="M1201.91,204.86c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1201.91,204.86Z"
                fill="#2f6840"
              />
              <path
                d="M1200.54,208.07a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1200.54,208.07Z"
                fill="#2f6840"
              />
              <path
                d="M1198.58,206.11c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1198.58,206.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.53,214.75c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1195.53,214.75Z"
                fill="#2f6840"
              />
              <path
                d="M1195,214.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1195,214.41Z"
                fill="#3ba525"
              />
              <path
                d="M1195.77,214.38a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1195.77,214.38Z"
                fill="#2f6840"
              />
              <path
                d="M1199.25,213.59c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1199.25,213.59Z"
                fill="#2f6840"
              />
              <path
                d="M1197.88,216.8a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1197.88,216.8Z"
                fill="#2f6840"
              />
              <path
                d="M1195.92,214.84c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1195.92,214.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1190.17,209.8c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1190.17,209.8Z"
                fill="#2f6840"
              />
              <path
                d="M1189.67,209.45c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1189.67,209.45Z"
                fill="#3ba525"
              />
              <path
                d="M1190.42,209.42a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1190.42,209.42Z"
                fill="#2f6840"
              />
              <path
                d="M1193.9,208.63c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.44,2.44,0,0,1,1.24-.86A2.07,2.07,0,0,1,1193.9,208.63Z"
                fill="#2f6840"
              />
              <path
                d="M1192.53,211.84a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1192.53,211.84Z"
                fill="#2f6840"
              />
              <path
                d="M1190.57,209.88c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1190.57,209.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.83,206.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1181.83,206.42Z"
                fill="#2f6840"
              />
              <path
                d="M1181.32,206.08c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1181.32,206.08Z"
                fill="#3ba525"
              />
              <path
                d="M1182.08,206.05a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1182.08,206.05Z"
                fill="#2f6840"
              />
              <path
                d="M1185.56,205.26c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1185.56,205.26Z"
                fill="#2f6840"
              />
              <path
                d="M1184.19,208.47a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1184.19,208.47Z"
                fill="#2f6840"
              />
              <path
                d="M1182.23,206.51c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1182.23,206.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.54,221.91c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1196.54,221.91Z"
                fill="#2f6840"
              />
              <path
                d="M1196,221.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1196,221.57Z"
                fill="#3ba525"
              />
              <path
                d="M1196.78,221.54a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1196.78,221.54Z"
                fill="#2f6840"
              />
              <path
                d="M1200.26,220.74c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1200.26,220.74Z"
                fill="#2f6840"
              />
              <path
                d="M1198.89,224a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1198.89,224Z"
                fill="#2f6840"
              />
              <path
                d="M1196.93,222c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1196.93,222Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1183.08,216.34c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1183.08,216.34Z"
                fill="#2f6840"
              />
              <path
                d="M1182.57,216c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1182.57,216Z"
                fill="#3ba525"
              />
              <path
                d="M1183.33,216a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1183.33,216Z"
                fill="#2f6840"
              />
              <path
                d="M1186.8,215.18c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1186.8,215.18Z"
                fill="#2f6840"
              />
              <path
                d="M1185.44,218.39a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1185.44,218.39Z"
                fill="#2f6840"
              />
              <path
                d="M1183.48,216.43c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1183.48,216.43Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1171.2,208.73c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1171.2,208.73Z"
                fill="#2f6840"
              />
              <path
                d="M1170.7,208.39c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1170.7,208.39Z"
                fill="#3ba525"
              />
              <path
                d="M1171.45,208.36a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1171.45,208.36Z"
                fill="#2f6840"
              />
              <path
                d="M1174.93,207.57c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1174.93,207.57Z"
                fill="#2f6840"
              />
              <path
                d="M1173.56,210.78a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1173.56,210.78Z"
                fill="#2f6840"
              />
              <path
                d="M1171.6,208.82c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1171.6,208.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1168.54,217.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1168.54,217.46Z"
                fill="#2f6840"
              />
              <path
                d="M1168,217.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1168,217.12Z"
                fill="#3ba525"
              />
              <path
                d="M1168.79,217.09a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.79,217.09Z"
                fill="#2f6840"
              />
              <path
                d="M1172.27,216.29c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1172.27,216.29Z"
                fill="#2f6840"
              />
              <path
                d="M1170.9,219.5a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1170.9,219.5Z"
                fill="#2f6840"
              />
              <path
                d="M1168.94,217.55c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1168.94,217.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1163.19,212.5c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1163.19,212.5Z"
                fill="#2f6840"
              />
              <path
                d="M1162.69,212.16c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1162.69,212.16Z"
                fill="#3ba525"
              />
              <path
                d="M1163.44,212.13a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1163.44,212.13Z"
                fill="#2f6840"
              />
              <path
                d="M1166.92,211.34c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1166.92,211.34Z"
                fill="#2f6840"
              />
              <path
                d="M1165.55,214.55a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1165.55,214.55Z"
                fill="#2f6840"
              />
              <path
                d="M1163.59,212.59c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1163.59,212.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1154.85,209.13c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1154.85,209.13Z"
                fill="#2f6840"
              />
              <path
                d="M1154.34,208.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1154.34,208.79Z"
                fill="#3ba525"
              />
              <path
                d="M1155.1,208.76a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1155.1,208.76Z"
                fill="#2f6840"
              />
              <path
                d="M1158.57,208c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1158.57,208Z"
                fill="#2f6840"
              />
              <path
                d="M1157.2,211.17a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1157.2,211.17Z"
                fill="#2f6840"
              />
              <path
                d="M1155.25,209.22c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1155.25,209.22Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1169.55,224.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1169.55,224.62Z"
                fill="#2f6840"
              />
              <path
                d="M1169.05,224.28c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1169.05,224.28Z"
                fill="#3ba525"
              />
              <path
                d="M1169.8,224.25a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1169.8,224.25Z"
                fill="#2f6840"
              />
              <path
                d="M1173.28,223.45c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1173.28,223.45Z"
                fill="#2f6840"
              />
              <path
                d="M1171.91,226.66a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1171.91,226.66Z"
                fill="#2f6840"
              />
              <path
                d="M1170,224.71c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1170,224.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156.1,219.05c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1156.1,219.05Z"
                fill="#2f6840"
              />
              <path
                d="M1155.59,218.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1155.59,218.71Z"
                fill="#3ba525"
              />
              <path
                d="M1156.34,218.68a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1156.34,218.68Z"
                fill="#2f6840"
              />
              <path
                d="M1159.82,217.88c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1159.82,217.88Z"
                fill="#2f6840"
              />
              <path
                d="M1158.45,221.09a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1158.45,221.09Z"
                fill="#2f6840"
              />
              <path
                d="M1156.49,219.14c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1156.49,219.14Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1146.13,222.07c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1146.13,222.07Z"
                fill="#2f6840"
              />
              <path
                d="M1145.63,221.73c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1145.63,221.73Z"
                fill="#3ba525"
              />
              <path
                d="M1146.38,221.7a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1146.38,221.7Z"
                fill="#2f6840"
              />
              <path
                d="M1149.86,220.9c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1149.86,220.9Z"
                fill="#2f6840"
              />
              <path
                d="M1148.49,224.11a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1148.49,224.11Z"
                fill="#2f6840"
              />
              <path
                d="M1146.53,222.16c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1146.53,222.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1143.47,230.8c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1143.47,230.8Z"
                fill="#2f6840"
              />
              <path
                d="M1143,230.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1143,230.46Z"
                fill="#3ba525"
              />
              <path
                d="M1143.72,230.43a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1143.72,230.43Z"
                fill="#2f6840"
              />
              <path
                d="M1147.2,229.63c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1147.2,229.63Z"
                fill="#2f6840"
              />
              <path
                d="M1145.83,232.84a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1145.83,232.84Z"
                fill="#2f6840"
              />
              <path
                d="M1143.87,230.89c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1143.87,230.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1138.12,225.84c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1138.12,225.84Z"
                fill="#2f6840"
              />
              <path
                d="M1137.62,225.5c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1137.62,225.5Z"
                fill="#3ba525"
              />
              <path
                d="M1138.37,225.47a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1138.37,225.47Z"
                fill="#2f6840"
              />
              <path
                d="M1141.85,224.67c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1141.85,224.67Z"
                fill="#2f6840"
              />
              <path
                d="M1140.48,227.88a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1140.48,227.88Z"
                fill="#2f6840"
              />
              <path
                d="M1138.52,225.93c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1138.52,225.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1129.78,222.47c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1129.78,222.47Z"
                fill="#2f6840"
              />
              <path
                d="M1129.27,222.13c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1129.27,222.13Z"
                fill="#3ba525"
              />
              <path
                d="M1130,222.1a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1130,222.1Z"
                fill="#2f6840"
              />
              <path
                d="M1133.5,221.3c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1133.5,221.3Z"
                fill="#2f6840"
              />
              <path
                d="M1132.14,224.51a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1132.14,224.51Z"
                fill="#2f6840"
              />
              <path
                d="M1130.18,222.56c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1130.18,222.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1144.48,238c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1144.48,238Z"
                fill="#2f6840"
              />
              <path
                d="M1144,237.62c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1144,237.62Z"
                fill="#3ba525"
              />
              <path
                d="M1144.73,237.59a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1144.73,237.59Z"
                fill="#2f6840"
              />
              <path
                d="M1148.21,236.79c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1148.21,236.79Z"
                fill="#2f6840"
              />
              <path
                d="M1146.84,240a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1146.84,240Z"
                fill="#2f6840"
              />
              <path
                d="M1144.88,238.05c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1144.88,238.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1131,232.39c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1131,232.39Z"
                fill="#2f6840"
              />
              <path
                d="M1130.52,232.05c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.08-2.36A14.65,14.65,0,0,1,1130.52,232.05Z"
                fill="#3ba525"
              />
              <path
                d="M1131.27,232a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1131.27,232Z"
                fill="#2f6840"
              />
              <path
                d="M1134.75,231.22c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1134.75,231.22Z"
                fill="#2f6840"
              />
              <path
                d="M1133.38,234.43a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1133.38,234.43Z"
                fill="#2f6840"
              />
              <path
                d="M1131.43,232.48c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1131.43,232.48Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1117.83,222.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1117.83,222.65Z"
                fill="#2f6840"
              />
              <path
                d="M1117.32,222.3c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1117.32,222.3Z"
                fill="#3ba525"
              />
              <path
                d="M1118.08,222.27a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1118.08,222.27Z"
                fill="#2f6840"
              />
              <path
                d="M1121.55,221.48a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1121.55,221.48Z"
                fill="#2f6840"
              />
              <path
                d="M1120.19,224.69a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1120.19,224.69Z"
                fill="#2f6840"
              />
              <path
                d="M1118.23,222.73c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1118.23,222.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1115.17,231.38c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1115.17,231.38Z"
                fill="#2f6840"
              />
              <path
                d="M1114.66,231c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1114.66,231Z"
                fill="#3ba525"
              />
              <path
                d="M1115.42,231a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1115.42,231Z"
                fill="#2f6840"
              />
              <path
                d="M1118.89,230.21a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1118.89,230.21Z"
                fill="#2f6840"
              />
              <path
                d="M1117.53,233.42a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1117.53,233.42Z"
                fill="#2f6840"
              />
              <path
                d="M1115.57,231.46c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1115.57,231.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1109.82,226.42c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1109.82,226.42Z"
                fill="#2f6840"
              />
              <path
                d="M1109.31,226.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1109.31,226.07Z"
                fill="#3ba525"
              />
              <path
                d="M1110.06,226a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1110.06,226Z"
                fill="#2f6840"
              />
              <path
                d="M1113.54,225.25c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1113.54,225.25Z"
                fill="#2f6840"
              />
              <path
                d="M1112.17,228.46a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1112.17,228.46Z"
                fill="#2f6840"
              />
              <path
                d="M1110.22,226.5c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1110.22,226.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1101.48,223.05c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1101.48,223.05Z"
                fill="#2f6840"
              />
              <path
                d="M1101,222.7c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1101,222.7Z"
                fill="#3ba525"
              />
              <path
                d="M1101.72,222.67a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1101.72,222.67Z"
                fill="#2f6840"
              />
              <path
                d="M1105.2,221.88a5.21,5.21,0,0,0-.72.1,3.08,3.08,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1105.2,221.88Z"
                fill="#2f6840"
              />
              <path
                d="M1103.83,225.09a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1103.83,225.09Z"
                fill="#2f6840"
              />
              <path
                d="M1101.87,223.13c-.24.06-.47.09-.69.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1101.87,223.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1116.18,238.54c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1116.18,238.54Z"
                fill="#2f6840"
              />
              <path
                d="M1115.67,238.19c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1115.67,238.19Z"
                fill="#3ba525"
              />
              <path
                d="M1116.43,238.16a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1116.43,238.16Z"
                fill="#2f6840"
              />
              <path
                d="M1119.9,237.37a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1119.9,237.37Z"
                fill="#2f6840"
              />
              <path
                d="M1118.54,240.58a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1118.54,240.58Z"
                fill="#2f6840"
              />
              <path
                d="M1116.58,238.62c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1116.58,238.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1102.72,233c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1102.72,233Z"
                fill="#2f6840"
              />
              <path
                d="M1102.22,232.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1102.22,232.62Z"
                fill="#3ba525"
              />
              <path
                d="M1103,232.59a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1103,232.59Z"
                fill="#2f6840"
              />
              <path
                d="M1106.45,231.8a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1106.45,231.8Z"
                fill="#2f6840"
              />
              <path
                d="M1105.08,235a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1105.08,235Z"
                fill="#2f6840"
              />
              <path
                d="M1103.12,233.05c-.24.06-.47.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1103.12,233.05Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1090.79,214.37c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1090.79,214.37Z"
                fill="#2f6840"
              />
              <path
                d="M1090.28,214c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1090.28,214Z"
                fill="#3ba525"
              />
              <path
                d="M1091,214a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1091,214Z"
                fill="#2f6840"
              />
              <path
                d="M1094.51,213.2c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1094.51,213.2Z"
                fill="#2f6840"
              />
              <path
                d="M1093.14,216.41a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1093.14,216.41Z"
                fill="#2f6840"
              />
              <path
                d="M1091.18,214.46a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1091.18,214.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1088.13,223.1c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1088.13,223.1Z"
                fill="#2f6840"
              />
              <path
                d="M1087.62,222.75c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1087.62,222.75Z"
                fill="#3ba525"
              />
              <path
                d="M1088.37,222.72a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1088.37,222.72Z"
                fill="#2f6840"
              />
              <path
                d="M1091.85,221.93c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1091.85,221.93Z"
                fill="#2f6840"
              />
              <path
                d="M1090.48,225.14a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1090.48,225.14Z"
                fill="#2f6840"
              />
              <path
                d="M1088.53,223.18c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1088.53,223.18Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1082.77,218.14c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1082.77,218.14Z"
                fill="#2f6840"
              />
              <path
                d="M1082.27,217.8c4.42-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1082.27,217.8Z"
                fill="#3ba525"
              />
              <path
                d="M1083,217.77a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1083,217.77Z"
                fill="#2f6840"
              />
              <path
                d="M1086.5,217c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1086.5,217Z"
                fill="#2f6840"
              />
              <path
                d="M1085.13,220.18a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1085.13,220.18Z"
                fill="#2f6840"
              />
              <path
                d="M1083.17,218.23a7,7,0,0,0-.69.15,4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1083.17,218.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.43,214.77c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1074.43,214.77Z"
                fill="#2f6840"
              />
              <path
                d="M1073.93,214.42c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1073.93,214.42Z"
                fill="#3ba525"
              />
              <path
                d="M1074.68,214.4a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1074.68,214.4Z"
                fill="#2f6840"
              />
              <path
                d="M1078.16,213.6c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1078.16,213.6Z"
                fill="#2f6840"
              />
              <path
                d="M1076.79,216.81a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1076.79,216.81Z"
                fill="#2f6840"
              />
              <path
                d="M1074.83,214.85c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1074.83,214.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1089.14,230.26c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1089.14,230.26Z"
                fill="#2f6840"
              />
              <path
                d="M1088.63,229.91c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.63,229.91Z"
                fill="#3ba525"
              />
              <path
                d="M1089.38,229.88a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1089.38,229.88Z"
                fill="#2f6840"
              />
              <path
                d="M1092.86,229.09c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1092.86,229.09Z"
                fill="#2f6840"
              />
              <path
                d="M1091.49,232.3a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1091.49,232.3Z"
                fill="#2f6840"
              />
              <path
                d="M1089.54,230.34c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1089.54,230.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1075.68,224.69c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1075.68,224.69Z"
                fill="#2f6840"
              />
              <path
                d="M1075.17,224.34c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1075.17,224.34Z"
                fill="#3ba525"
              />
              <path
                d="M1075.93,224.32a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1075.93,224.32Z"
                fill="#2f6840"
              />
              <path
                d="M1079.4,223.52c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1079.4,223.52Z"
                fill="#2f6840"
              />
              <path
                d="M1078,226.73a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1078,226.73Z"
                fill="#2f6840"
              />
              <path
                d="M1076.08,224.77c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1076.08,224.77Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1183.43,173.6l3,1.85a1,1,0,0,0,.91.06l7.17-3.2a1,1,0,0,0,.23-1.62h0a1,1,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,1183.43,173.6Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1188.72 166.18 1184.68 167.04 1181.12 169.78 1187.09 172.17 1194.39 169.18 1188.72 166.18"
              fill="#ffedc8"
            />
            <polygon
              points="1181.12 169.78 1181.12 172.17 1186.85 174.62 1194.55 171.49 1194.39 169.18 1187.09 172.17 1181.12 169.78"
              fill="#ccae79"
            />
            <polygon
              points="1187.09 172.17 1186.85 174.62 1194.55 171.49 1194.39 169.18 1187.09 172.17"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1182.83,170.46a1.09,1.09,0,0,1,0,1.23c.27-.39.33-1.1.45-1.05Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.34,171.47a3.38,3.38,0,0,0,1.51-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1190.11,170.93a1.11,1.11,0,0,1,.59,1l-.18-1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1192.78,168.32a7.14,7.14,0,0,1-2.38,0,3.37,3.37,0,0,1-1.72.12s1.26-.12,1.72.31A10.52,10.52,0,0,1,1192.78,168.32Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1106.54,234.37l6.43,4a2.08,2.08,0,0,0,2,.14l15.43-6.9a2.09,2.09,0,0,0,.51-3.49h0a2.08,2.08,0,0,0-1.64-.49l-21.85,2.91A2.08,2.08,0,0,0,1106.54,234.37Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1117.95 218.42 1109.25 220.26 1101.58 226.15 1114.42 231.3 1130.15 224.86 1117.95 218.42"
              fill="#ffedc8"
            />
            <polygon
              points="1101.58 226.15 1101.58 231.3 1113.91 236.58 1130.49 229.85 1130.15 224.86 1114.42 231.3 1101.58 226.15"
              fill="#ccae79"
            />
            <polygon
              points="1114.42 231.3 1113.91 236.58 1130.49 229.85 1130.15 224.86 1114.42 231.3"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1105.25,227.62a2.31,2.31,0,0,1,0,2.64c.58-.83.71-2.35,1-2.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1110.67,229.79a7.34,7.34,0,0,0,3.24-3.29l-2.33,3.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1120.92,228.64a2.37,2.37,0,0,1,1.28,2.08l-.38-2.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1126.67,223c-.17-.09-3.25.62-5.11,0a7.3,7.3,0,0,1-3.72.26s2.73-.27,3.72.66A22.29,22.29,0,0,1,1126.67,223Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1153.57,229.81l2.22,1.38a.72.72,0,0,0,.68.05l5.33-2.39a.71.71,0,0,0,.18-1.2h0a.69.69,0,0,0-.57-.17l-7.55,1A.72.72,0,0,0,1153.57,229.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1157.51 224.29 1154.51 224.93 1151.86 226.97 1156.3 228.75 1161.74 226.52 1157.51 224.29"
              fill="#ffedc8"
            />
            <polygon
              points="1151.86 226.97 1151.86 228.75 1156.12 230.57 1161.85 228.25 1161.74 226.52 1156.3 228.75 1151.86 226.97"
              fill="#ccae79"
            />
            <polygon
              points="1156.3 228.75 1156.12 230.57 1161.85 228.25 1161.74 226.52 1156.3 228.75"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1153.12,227.48a.79.79,0,0,1,0,.91c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155,228.23a2.6,2.6,0,0,0,1.12-1.14l-.81,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1158.54,227.83a.84.84,0,0,1,.45.72l-.14-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.53,225.88a5.19,5.19,0,0,1-1.77,0,2.4,2.4,0,0,1-1.28.09s.94-.09,1.28.23A7.93,7.93,0,0,1,1160.53,225.88Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1137.63,234.18l2.22,1.38a.74.74,0,0,0,.68,0l5.33-2.38A.72.72,0,0,0,1146,232h0a.76.76,0,0,0-.57-.17l-7.55,1A.72.72,0,0,0,1137.63,234.18Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1141.58 228.66 1138.57 229.3 1135.92 231.33 1140.36 233.11 1145.8 230.89 1141.58 228.66"
              fill="#ffedc8"
            />
            <polygon
              points="1135.92 231.33 1135.92 233.11 1140.18 234.94 1145.91 232.61 1145.8 230.89 1140.36 233.11 1135.92 231.33"
              fill="#ccae79"
            />
            <polygon
              points="1140.36 233.11 1140.18 234.94 1145.91 232.61 1145.8 230.89 1140.36 233.11"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1137.18,231.84a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1139.06,232.59a2.53,2.53,0,0,0,1.12-1.14l-.81,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1142.6,232.19a.82.82,0,0,1,.45.72l-.14-.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144.59,230.25a5.13,5.13,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.94-.09,1.29.23A7.78,7.78,0,0,1,1144.59,230.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1153.14,217.81l2.22,1.38a.74.74,0,0,0,.68,0l5.33-2.38a.73.73,0,0,0,.18-1.21h0a.78.78,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1153.14,217.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1157.08 212.29 1154.07 212.93 1151.42 214.96 1155.87 216.74 1161.3 214.52 1157.08 212.29"
              fill="#ffedc8"
            />
            <polygon
              points="1151.42 214.96 1151.42 216.74 1155.69 218.57 1161.42 216.24 1161.3 214.52 1155.87 216.74 1151.42 214.96"
              fill="#ccae79"
            />
            <polygon
              points="1155.87 216.74 1155.69 218.57 1161.42 216.24 1161.3 214.52 1155.87 216.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1152.69,215.47a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1154.57,216.22a2.53,2.53,0,0,0,1.12-1.14l-.81,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1158.11,215.82a.82.82,0,0,1,.44.72l-.13-.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.1,213.88a5.19,5.19,0,0,1-1.77,0,2.53,2.53,0,0,1-1.28.09s.94-.09,1.28.23A7.93,7.93,0,0,1,1160.1,213.88Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1189.12,219.35l4.71,2.93a1.54,1.54,0,0,0,1.43.09l11.3-5.05a1.53,1.53,0,0,0,.38-2.55h0a1.51,1.51,0,0,0-1.2-.36l-16,2.13A1.53,1.53,0,0,0,1189.12,219.35Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1197.48 207.66 1191.1 209.01 1185.49 213.33 1194.9 217.1 1206.42 212.38 1197.48 207.66"
              fill="#ffedc8"
            />
            <polygon
              points="1185.49 213.33 1185.49 217.1 1194.52 220.97 1206.67 216.04 1206.42 212.38 1194.9 217.1 1185.49 213.33"
              fill="#ccae79"
            />
            <polygon
              points="1194.9 217.1 1194.52 220.97 1206.67 216.04 1206.42 212.38 1194.9 217.1"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1188.18,214.4a1.72,1.72,0,0,1,0,1.94c.42-.61.52-1.73.72-1.65Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1192.14,216a5.38,5.38,0,0,0,2.38-2.42l-1.71,2.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199.66,215.15a1.74,1.74,0,0,1,.93,1.52l-.28-1.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1203.87,211c-.12-.06-2.38.46-3.74,0a5.38,5.38,0,0,1-2.73.19s2-.19,2.73.49A16.48,16.48,0,0,1,1203.87,211Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1212.46,223.45l4.65,2.88a1.5,1.5,0,0,0,1.41.1l11.17-5a1.52,1.52,0,0,0,.37-2.53h0a1.5,1.5,0,0,0-1.19-.35l-15.81,2.1A1.52,1.52,0,0,0,1212.46,223.45Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1220.71 211.89 1214.42 213.23 1208.87 217.49 1218.16 221.22 1229.55 216.56 1220.71 211.89"
              fill="#ffedc8"
            />
            <polygon
              points="1208.87 217.49 1208.87 221.22 1217.79 225.04 1229.8 220.17 1229.55 216.56 1218.16 221.22 1208.87 217.49"
              fill="#ccae79"
            />
            <polygon
              points="1218.16 221.22 1217.79 225.04 1229.8 220.17 1229.55 216.56 1218.16 221.22"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1211.52,218.56a1.67,1.67,0,0,1,0,1.91c.42-.6.52-1.71.71-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1215.44,220.13a5.33,5.33,0,0,0,2.35-2.38l-1.69,2.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1222.87,219.29a1.73,1.73,0,0,1,.92,1.51l-.27-1.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1227,215.22c-.12-.06-2.35.46-3.7,0a5.23,5.23,0,0,1-2.69.19s2-.19,2.69.49A16.16,16.16,0,0,1,1227,215.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1234.37,240.72l-4,2.46a1.28,1.28,0,0,1-1.2.09L1219.7,239a1.28,1.28,0,0,1-.32-2.14h0a1.26,1.26,0,0,1,1-.31l13.47,1.79A1.29,1.29,0,0,1,1234.37,240.72Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1227.34 230.89 1232.7 232.02 1237.43 235.65 1229.51 238.83 1219.82 234.86 1227.34 230.89"
              fill="#ffedc8"
            />
            <polygon
              points="1237.43 235.65 1237.43 238.83 1229.83 242.08 1219.61 237.93 1219.82 234.86 1229.51 238.83 1237.43 235.65"
              fill="#ccae79"
            />
            <polygon
              points="1229.51 238.83 1229.83 242.08 1219.61 237.93 1219.82 234.86 1229.51 238.83"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1235.17,236.56a1.43,1.43,0,0,0,0,1.63c-.36-.51-.44-1.45-.61-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1231.83,237.9a4.53,4.53,0,0,1-2-2l1.44,2.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1225.51,237.19a1.45,1.45,0,0,0-.79,1.28L1225,237Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1222,233.72a9.14,9.14,0,0,0,3.14,0,4.43,4.43,0,0,0,2.3.16s-1.69-.16-2.3.42A13.56,13.56,0,0,0,1222,233.72Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1224.38,251.45l3,1.88a1,1,0,0,0,.92.06l7.28-3.25a1,1,0,0,0,.24-1.65h0a1,1,0,0,0-.77-.23l-10.31,1.37A1,1,0,0,0,1224.38,251.45Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1229.76 243.92 1225.65 244.79 1222.04 247.57 1228.1 250 1235.52 246.96 1229.76 243.92"
              fill="#ffedc8"
            />
            <polygon
              points="1222.04 247.57 1222.04 250 1227.85 252.49 1235.68 249.31 1235.52 246.96 1228.1 250 1222.04 247.57"
              fill="#ccae79"
            />
            <polygon
              points="1228.1 250 1227.85 252.49 1235.68 249.31 1235.52 246.96 1228.1 250"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1223.77,248.26a1.1,1.1,0,0,1,0,1.25c.27-.39.34-1.11.46-1.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1226.33,249.29a3.47,3.47,0,0,0,1.52-1.56l-1.1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1231.16,248.74a1.12,1.12,0,0,1,.61,1l-.19-1.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1233.87,246.09a7,7,0,0,1-2.41,0,3.36,3.36,0,0,1-1.75.12s1.29-.12,1.75.32A10.4,10.4,0,0,1,1233.87,246.09Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1208.89,276l3.82,2.37a1.23,1.23,0,0,0,1.16.08l9.17-4.1a1.24,1.24,0,0,0,.3-2.07h0a1.24,1.24,0,0,0-1-.29l-13,1.72A1.25,1.25,0,0,0,1208.89,276Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1215.67 266.49 1210.5 267.58 1205.95 271.08 1213.58 274.14 1222.92 270.31 1215.67 266.49"
              fill="#ffedc8"
            />
            <polygon
              points="1205.95 271.08 1205.95 274.14 1213.27 277.28 1223.12 273.28 1222.92 270.31 1213.58 274.14 1205.95 271.08"
              fill="#ccae79"
            />
            <polygon
              points="1213.58 274.14 1213.27 277.28 1223.12 273.28 1222.92 270.31 1213.58 274.14"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1208.12,272a1.38,1.38,0,0,1,0,1.57c.35-.5.43-1.4.59-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1211.34,273.25a4.35,4.35,0,0,0,1.93-2l-1.39,2.17Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1217.43,272.56a1.41,1.41,0,0,1,.76,1.24l-.22-1.46Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1220.85,269.22a9,9,0,0,1-3,0,4.36,4.36,0,0,1-2.21.16s1.62-.16,2.21.39A13.14,13.14,0,0,1,1220.85,269.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1199.19,271.27l2.26,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.76.76,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1199.19,271.27Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1203.2 265.67 1200.15 266.32 1197.45 268.38 1201.96 270.19 1207.49 267.93 1203.2 265.67"
              fill="#ffedc8"
            />
            <polygon
              points="1197.45 268.38 1197.45 270.19 1201.78 272.05 1207.61 269.68 1207.49 267.93 1201.96 270.19 1197.45 268.38"
              fill="#ccae79"
            />
            <polygon
              points="1201.96 270.19 1201.78 272.05 1207.61 269.68 1207.49 267.93 1201.96 270.19"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1198.74,268.9a.82.82,0,0,1,0,.93c.21-.29.25-.83.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1200.64,269.66a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1204.25,269.26a.82.82,0,0,1,.44.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1206.26,267.28a5.31,5.31,0,0,1-1.79,0,2.59,2.59,0,0,1-1.31.1s1-.1,1.31.23A7.66,7.66,0,0,1,1206.26,267.28Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1182.78,301.54l5.23,3.25a1.72,1.72,0,0,0,1.59.1l12.56-5.61a1.71,1.71,0,0,0,.42-2.84h0a1.72,1.72,0,0,0-1.34-.4l-17.79,2.37A1.7,1.7,0,0,0,1182.78,301.54Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1192.06 288.55 1184.98 290.05 1178.75 294.84 1189.2 299.03 1202 293.79 1192.06 288.55"
              fill="#ffedc8"
            />
            <polygon
              points="1178.75 294.84 1178.75 299.03 1188.78 303.33 1202.28 297.85 1202 293.79 1189.2 299.03 1178.75 294.84"
              fill="#ccae79"
            />
            <polygon
              points="1189.2 299.03 1188.78 303.33 1202.28 297.85 1202 293.79 1189.2 299.03"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1181.73,296a1.89,1.89,0,0,1,0,2.15c.47-.67.58-1.92.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1186.14,297.81a6,6,0,0,0,2.64-2.68l-1.9,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1194.48,296.87a1.94,1.94,0,0,1,1,1.69l-.32-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199.16,292.29c-.13-.06-2.64.51-4.15,0a6,6,0,0,1-3,.22s2.22-.22,3,.54A18,18,0,0,1,1199.16,292.29Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1234.12,386.63l5,3.08a1.62,1.62,0,0,0,1.51.11l11.91-5.33a1.61,1.61,0,0,0,.4-2.69h0a1.63,1.63,0,0,0-1.27-.38l-16.87,2.24A1.61,1.61,0,0,0,1234.12,386.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1242.92 374.31 1236.21 375.74 1230.29 380.28 1240.2 384.26 1252.35 379.28 1242.92 374.31"
              fill="#ffedc8"
            />
            <polygon
              points="1230.29 380.28 1230.29 384.26 1239.81 388.33 1252.61 383.14 1252.35 379.28 1240.2 384.26 1230.29 380.28"
              fill="#ccae79"
            />
            <polygon
              points="1240.2 384.26 1239.81 388.33 1252.61 383.14 1252.35 379.28 1240.2 384.26"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1233.12,381.42a1.8,1.8,0,0,1,0,2c.45-.64.55-1.82.76-1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1237.3,383.09a5.65,5.65,0,0,0,2.51-2.54l-1.8,2.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1245.22,382.2a1.85,1.85,0,0,1,1,1.61l-.3-1.89Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1249.66,377.86c-.13-.06-2.51.49-3.94,0a5.63,5.63,0,0,1-2.88.2s2.11-.2,2.88.52A17.2,17.2,0,0,1,1249.66,377.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1231.32,394.91l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.74.74,0,0,0-.57-.17l-7.68,1A.73.73,0,0,0,1231.32,394.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1235.33 389.31 1232.27 389.96 1229.58 392.02 1234.09 393.83 1239.61 391.57 1235.33 389.31"
              fill="#ffedc8"
            />
            <polygon
              points="1229.58 392.02 1229.58 393.83 1233.91 395.69 1239.73 393.32 1239.61 391.57 1234.09 393.83 1229.58 392.02"
              fill="#ccae79"
            />
            <polygon
              points="1234.09 393.83 1233.91 395.69 1239.73 393.32 1239.61 391.57 1234.09 393.83"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1230.87,392.54a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1232.77,393.3a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1236.37,392.9a.83.83,0,0,1,.45.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.39,390.92a5.32,5.32,0,0,1-1.79,0,2.59,2.59,0,0,1-1.31.1s1-.1,1.31.23A7.66,7.66,0,0,1,1238.39,390.92Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1214.07,404.48l2.25,1.4a.77.77,0,0,0,.69.05l5.42-2.43a.73.73,0,0,0,.18-1.22h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1214.07,404.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1218.07 398.87 1215.02 399.52 1212.33 401.59 1216.84 403.4 1222.36 401.13 1218.07 398.87"
              fill="#ffedc8"
            />
            <polygon
              points="1212.33 401.59 1212.33 403.4 1216.65 405.25 1222.48 402.89 1222.36 401.13 1216.84 403.4 1212.33 401.59"
              fill="#ccae79"
            />
            <polygon
              points="1216.84 403.4 1216.65 405.25 1222.48 402.89 1222.36 401.13 1216.84 403.4"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1213.61,402.1a.83.83,0,0,1,0,.93c.21-.29.25-.82.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1215.52,402.87a2.58,2.58,0,0,0,1.13-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1219.12,402.46a.86.86,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1221.13,400.49a5.31,5.31,0,0,1-1.79,0,2.6,2.6,0,0,1-1.3.09s1-.09,1.3.23A8,8,0,0,1,1221.13,400.49Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1198.75,406.22l2.25,1.4a.73.73,0,0,0,.69,0l5.42-2.42a.73.73,0,0,0,.18-1.22h0a.76.76,0,0,0-.58-.18l-7.67,1A.73.73,0,0,0,1198.75,406.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1202.75 400.61 1199.7 401.26 1197.01 403.33 1201.52 405.14 1207.04 402.87 1202.75 400.61"
              fill="#ffedc8"
            />
            <polygon
              points="1197.01 403.33 1197.01 405.14 1201.34 406.99 1207.16 404.63 1207.04 402.87 1201.52 405.14 1197.01 403.33"
              fill="#ccae79"
            />
            <polygon
              points="1201.52 405.14 1201.34 406.99 1207.16 404.63 1207.04 402.87 1201.52 405.14"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1198.3,403.84a.83.83,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1200.2,404.61a2.62,2.62,0,0,0,1.14-1.16l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1203.8,404.2a.84.84,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1205.82,402.23a5.37,5.37,0,0,1-1.8,0,2.6,2.6,0,0,1-1.3.09s1-.09,1.3.23A8.19,8.19,0,0,1,1205.82,402.23Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1199,397.74l5.23,3.25a1.69,1.69,0,0,0,1.59.11l12.55-5.61a1.7,1.7,0,0,0,.41-2.84h0a1.69,1.69,0,0,0-1.33-.4l-17.78,2.37A1.69,1.69,0,0,0,1199,397.74Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1208.27 384.76 1201.19 386.26 1194.96 391.05 1205.4 395.24 1218.2 390 1208.27 384.76"
              fill="#ffedc8"
            />
            <polygon
              points="1194.96 391.05 1194.96 395.24 1204.98 399.54 1218.47 394.06 1218.2 390 1205.4 395.24 1194.96 391.05"
              fill="#ccae79"
            />
            <polygon
              points="1205.4 395.24 1204.98 399.54 1218.47 394.06 1218.2 390 1205.4 395.24"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1197.94,392.25a1.89,1.89,0,0,1,0,2.15c.47-.68.58-1.92.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1202.35,394a5.92,5.92,0,0,0,2.63-2.68l-1.89,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1210.69,393.08a1.93,1.93,0,0,1,1,1.69l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1215.36,388.51c-.13-.07-2.64.51-4.15,0a6,6,0,0,1-3,.21s2.22-.22,3,.54A17.87,17.87,0,0,1,1215.36,388.51Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1184.89,406.42l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1184.89,406.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1188.89 400.81 1185.84 401.46 1183.15 403.53 1187.66 405.34 1193.18 403.08 1188.89 400.81"
              fill="#ffedc8"
            />
            <polygon
              points="1183.15 403.53 1183.15 405.34 1187.47 407.19 1193.3 404.83 1193.18 403.08 1187.66 405.34 1183.15 403.53"
              fill="#ccae79"
            />
            <polygon
              points="1187.66 405.34 1187.47 407.19 1193.3 404.83 1193.18 403.08 1187.66 405.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1184.43,404.05a.8.8,0,0,1,0,.93c.21-.3.26-.83.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1186.34,404.81a2.58,2.58,0,0,0,1.13-1.16l-.81,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1189.94,404.4a.85.85,0,0,1,.45.74l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1192,402.43a5.37,5.37,0,0,1-1.8,0,2.47,2.47,0,0,1-1.3.09s1-.09,1.3.24A7.72,7.72,0,0,1,1192,402.43Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1186.73,416.81l-2.25,1.4a.74.74,0,0,1-.69.05l-5.42-2.42a.74.74,0,0,1-.18-1.23h0a.76.76,0,0,1,.58-.17l7.67,1A.73.73,0,0,1,1186.73,416.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1182.73 411.21 1185.78 411.86 1188.47 413.92 1183.96 415.73 1178.44 413.47 1182.73 411.21"
              fill="#ffedc8"
            />
            <polygon
              points="1188.47 413.92 1188.47 415.73 1184.15 417.59 1178.32 415.22 1178.44 413.47 1183.96 415.73 1188.47 413.92"
              fill="#ccae79"
            />
            <polygon
              points="1183.96 415.73 1184.15 417.59 1178.32 415.22 1178.44 413.47 1183.96 415.73"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1187.19,414.44a.8.8,0,0,0,0,.93c-.21-.29-.25-.83-.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.28,415.2a2.58,2.58,0,0,1-1.13-1.15l.81,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1181.68,414.8a.83.83,0,0,0-.45.73l.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1179.66,412.82a5.37,5.37,0,0,0,1.8,0,2.55,2.55,0,0,0,1.3.1s-1-.1-1.3.23A7.72,7.72,0,0,0,1179.66,412.82Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1172.24,281.93l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1172.24,281.93Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1176.24 276.32 1173.19 276.97 1170.5 279.04 1175.01 280.85 1180.53 278.59 1176.24 276.32"
              fill="#ffedc8"
            />
            <polygon
              points="1170.5 279.04 1170.5 280.85 1174.83 282.7 1180.65 280.34 1180.53 278.59 1175.01 280.85 1170.5 279.04"
              fill="#ccae79"
            />
            <polygon
              points="1175.01 280.85 1174.83 282.7 1180.65 280.34 1180.53 278.59 1175.01 280.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1171.79,279.56a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1173.69,280.32a2.57,2.57,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1177.29,279.91a.85.85,0,0,1,.45.74l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1179.31,277.94a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1179.31,277.94Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1225.24,306.33l6.06,3.76a2,2,0,0,0,1.85.13l14.55-6.5a2,2,0,0,0,.48-3.29h0a2,2,0,0,0-1.55-.47L1226,302.71A2,2,0,0,0,1225.24,306.33Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1236 291.28 1227.8 293.02 1220.57 298.58 1232.68 303.43 1247.51 297.36 1236 291.28"
              fill="#ffedc8"
            />
            <polygon
              points="1220.57 298.58 1220.57 303.43 1232.19 308.41 1247.83 302.06 1247.51 297.36 1232.68 303.43 1220.57 298.58"
              fill="#ccae79"
            />
            <polygon
              points="1232.68 303.43 1232.19 308.41 1247.83 302.06 1247.51 297.36 1232.68 303.43"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1224,300a2.18,2.18,0,0,1,0,2.49c.54-.78.67-2.22.92-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1229.14,302a7,7,0,0,0,3-3.1l-2.2,3.44Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.81,300.92a2.24,2.24,0,0,1,1.2,2l-.36-2.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1244.22,295.62c-.15-.08-3.06.59-4.81,0a7,7,0,0,1-3.51.25s2.58-.25,3.51.63A20.75,20.75,0,0,1,1244.22,295.62Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1255.21,324.73l6.06,3.76a2,2,0,0,0,1.84.13l14.55-6.51a2,2,0,0,0,.48-3.28h0a2,2,0,0,0-1.55-.47L1256,321.1A2,2,0,0,0,1255.21,324.73Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1265.96 309.68 1257.76 311.42 1250.53 316.97 1262.64 321.83 1277.47 315.75 1265.96 309.68"
              fill="#ffedc8"
            />
            <polygon
              points="1250.53 316.97 1250.53 321.83 1262.15 326.81 1277.79 320.46 1277.47 315.75 1262.64 321.83 1250.53 316.97"
              fill="#ccae79"
            />
            <polygon
              points="1262.64 321.83 1262.15 326.81 1277.79 320.46 1277.47 315.75 1262.64 321.83"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1254,318.36a2.18,2.18,0,0,1,0,2.49c.55-.78.67-2.22.93-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1259.1,320.41a6.89,6.89,0,0,0,3.05-3.11l-2.19,3.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1268.77,319.32a2.22,2.22,0,0,1,1.2,2l-.36-2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1274.19,314c-.16-.08-3.07.59-4.82,0a7,7,0,0,1-3.51.25s2.58-.25,3.51.62A21.18,21.18,0,0,1,1274.19,314Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1266.92,334.63l3.31,1.59a1.38,1.38,0,0,0,1,0l7.94-2.74c.72-.25.86-1,.27-1.39h0a1.28,1.28,0,0,0-.85-.19l-11.24,1.15C1266.35,333.2,1266.06,334.22,1266.92,334.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1272.79 328.28 1268.31 329.02 1264.37 331.36 1270.98 333.41 1279.07 330.85 1272.79 328.28"
              fill="#ffedc8"
            />
            <polygon
              points="1264.37 331.36 1264.37 333.41 1270.71 335.51 1279.25 332.83 1279.07 330.85 1270.98 333.41 1264.37 331.36"
              fill="#ccae79"
            />
            <polygon
              points="1270.98 333.41 1270.71 335.51 1279.25 332.83 1279.07 330.85 1270.98 333.41"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1266.26,331.94a.77.77,0,0,1,0,1.06c.29-.33.36-.94.5-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1269,332.81a3.62,3.62,0,0,0,1.67-1.31l-1.2,1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1274.32,332.35s.72.29.66.83l-.2-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1277.28,330.11a9.87,9.87,0,0,1-2.63,0,4.82,4.82,0,0,1-1.91.11,4,4,0,0,1,1.91.26A14.39,14.39,0,0,1,1277.28,330.11Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1257.85,344.38l3.3,1.59a1.41,1.41,0,0,0,1,0l7.94-2.74c.72-.25.86-1,.27-1.39h0a1.32,1.32,0,0,0-.85-.2l-11.25,1.16C1257.27,343,1257,344,1257.85,344.38Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1263.72 338.03 1259.24 338.76 1255.29 341.11 1261.9 343.15 1270 340.59 1263.72 338.03"
              fill="#ffedc8"
            />
            <polygon
              points="1255.29 341.11 1255.29 343.15 1261.64 345.26 1270.17 342.58 1270 340.59 1261.9 343.15 1255.29 341.11"
              fill="#ccae79"
            />
            <polygon
              points="1261.9 343.15 1261.64 345.26 1270.17 342.58 1270 340.59 1261.9 343.15"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1257.18,341.69a.76.76,0,0,1,0,1.05c.3-.33.37-.93.51-.89Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1260,342.56a3.62,3.62,0,0,0,1.67-1.31l-1.2,1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1265.25,342.1s.71.28.66.82l-.2-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1268.21,339.86a9.9,9.9,0,0,1-2.63,0,4.73,4.73,0,0,1-1.92.1,4.11,4.11,0,0,1,1.92.27A14.39,14.39,0,0,1,1268.21,339.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1182.5,286.22l4.68,2.91a1.52,1.52,0,0,0,1.42.09l11.25-5a1.52,1.52,0,0,0,.37-2.54h0a1.48,1.48,0,0,0-1.19-.36l-15.93,2.12A1.52,1.52,0,0,0,1182.5,286.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1190.81 274.59 1184.47 275.93 1178.89 280.23 1188.24 283.98 1199.7 279.28 1190.81 274.59"
              fill="#ffedc8"
            />
            <polygon
              points="1178.89 280.23 1178.89 283.98 1187.87 287.82 1199.95 282.92 1199.7 279.28 1188.24 283.98 1178.89 280.23"
              fill="#ccae79"
            />
            <polygon
              points="1188.24 283.98 1187.87 287.82 1199.95 282.92 1199.7 279.28 1188.24 283.98"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1181.56,281.3a1.68,1.68,0,0,1,0,1.92c.42-.6.52-1.72.71-1.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.51,282.88a5.36,5.36,0,0,0,2.36-2.4l-1.7,2.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1193,282a1.73,1.73,0,0,1,.93,1.51l-.28-1.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1197.16,277.94c-.11-.06-2.36.46-3.71,0a5.34,5.34,0,0,1-2.72.19s2-.19,2.72.49A16.22,16.22,0,0,1,1197.16,277.94Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1168,211.08l5.72,3.56a1.88,1.88,0,0,0,1.74.12l13.76-6.15a1.87,1.87,0,0,0,.46-3.11h0a1.88,1.88,0,0,0-1.47-.44l-19.48,2.59A1.86,1.86,0,0,0,1168,211.08Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1178.14 196.86 1170.39 198.5 1163.56 203.75 1175 208.34 1189.02 202.6 1178.14 196.86"
              fill="#ffedc8"
            />
            <polygon
              points="1163.56 203.75 1163.56 208.34 1174.54 213.05 1189.33 207.05 1189.02 202.6 1175 208.34 1163.56 203.75"
              fill="#ccae79"
            />
            <polygon
              points="1175 208.34 1174.54 213.05 1189.33 207.05 1189.02 202.6 1175 208.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1166.83,205.06a2.09,2.09,0,0,1,0,2.36c.51-.74.63-2.1.87-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1171.65,207a6.5,6.5,0,0,0,2.89-2.94l-2.07,3.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1180.79,206a2.1,2.1,0,0,1,1.14,1.85l-.34-2.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.91,201c-.14-.08-2.89.56-4.54,0a6.47,6.47,0,0,1-3.32.23s2.43-.23,3.32.6A19.74,19.74,0,0,1,1185.91,201Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1168.9,174.11l2.22,1.38a.74.74,0,0,0,.68,0l5.34-2.38a.73.73,0,0,0,.18-1.21h0a.75.75,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1168.9,174.11Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1172.85 168.59 1169.84 169.23 1167.19 171.26 1171.63 173.04 1177.07 170.82 1172.85 168.59"
              fill="#ffedc8"
            />
            <polygon
              points="1167.19 171.26 1167.19 173.04 1171.45 174.87 1177.19 172.54 1177.07 170.82 1171.63 173.04 1167.19 171.26"
              fill="#ccae79"
            />
            <polygon
              points="1171.63 173.04 1171.45 174.87 1177.19 172.54 1177.07 170.82 1171.63 173.04"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168.46,171.77a.83.83,0,0,1,0,.92c.2-.29.24-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.33,172.52a2.48,2.48,0,0,0,1.12-1.14l-.8,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1173.88,172.12a.82.82,0,0,1,.44.72l-.13-.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1175.86,170.18a5.13,5.13,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s1-.09,1.29.23A7.78,7.78,0,0,1,1175.86,170.18Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1149.14,171.3l3,1.85a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,1149.14,171.3Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1154.43 163.89 1150.39 164.75 1146.83 167.48 1152.8 169.87 1160.1 166.88 1154.43 163.89"
              fill="#ffedc8"
            />
            <polygon
              points="1146.83 167.48 1146.83 169.87 1152.56 172.32 1160.26 169.2 1160.1 166.88 1152.8 169.87 1146.83 167.48"
              fill="#ccae79"
            />
            <polygon
              points="1152.8 169.87 1152.56 172.32 1160.26 169.2 1160.1 166.88 1152.8 169.87"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1148.54,168.16a1.09,1.09,0,0,1,0,1.23c.27-.39.33-1.09.45-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1151.05,169.17a3.38,3.38,0,0,0,1.51-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.82,168.64a1.09,1.09,0,0,1,.59,1l-.18-1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1158.48,166a6.79,6.79,0,0,1-2.37,0,3.32,3.32,0,0,1-1.72.13s1.26-.13,1.72.31A10.09,10.09,0,0,1,1158.48,166Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1147.12,185.42l5.15,3.2a1.68,1.68,0,0,0,1.57.1l12.36-5.52a1.68,1.68,0,0,0,.41-2.8h0a1.7,1.7,0,0,0-1.32-.39l-17.51,2.33A1.67,1.67,0,0,0,1147.12,185.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1156.26 172.63 1149.29 174.11 1143.15 178.83 1153.44 182.95 1166.04 177.79 1156.26 172.63"
              fill="#ffedc8"
            />
            <polygon
              points="1143.15 178.83 1143.15 182.95 1153.02 187.19 1166.31 181.79 1166.04 177.79 1153.44 182.95 1143.15 178.83"
              fill="#ccae79"
            />
            <polygon
              points="1153.44 182.95 1153.02 187.19 1166.31 181.79 1166.04 177.79 1153.44 182.95"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1146.09,180a1.85,1.85,0,0,1,0,2.11c.46-.66.57-1.88.79-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1150.43,181.75a5.86,5.86,0,0,0,2.59-2.64l-1.86,2.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1158.64,180.82a1.9,1.9,0,0,1,1,1.67l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.25,176.32c-.13-.07-2.6.5-4.09,0a5.82,5.82,0,0,1-3,.21s2.18-.21,3,.53A17.73,17.73,0,0,1,1163.25,176.32Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1076.65,225.76l5.29,3.28a1.68,1.68,0,0,0,1.61.11l12.69-5.67a1.72,1.72,0,0,0,.42-2.87h0a1.7,1.7,0,0,0-1.35-.4l-18,2.39A1.72,1.72,0,0,0,1076.65,225.76Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1086.03 212.64 1078.88 214.16 1072.58 219 1083.14 223.23 1096.08 217.94 1086.03 212.64"
              fill="#ffedc8"
            />
            <polygon
              points="1072.58 219 1072.58 223.23 1082.71 227.58 1096.35 222.04 1096.08 217.94 1083.14 223.23 1072.58 219"
              fill="#ccae79"
            />
            <polygon
              points="1083.14 223.23 1082.71 227.58 1096.35 222.04 1096.08 217.94 1083.14 223.23"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1075.59,220.21a1.91,1.91,0,0,1,0,2.17c.48-.68.59-1.94.81-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1080.05,222a6,6,0,0,0,2.66-2.7l-1.91,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1088.48,221a2,2,0,0,1,1,1.72l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1093.21,216.42c-.14-.07-2.67.52-4.2,0a6.07,6.07,0,0,1-3.06.22s2.24-.22,3.06.54A18.43,18.43,0,0,1,1093.21,216.42Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1131.44,176.74l2.86,1.78a1,1,0,0,0,.87.06l6.88-3.08a.93.93,0,0,0,.23-1.55h0a.89.89,0,0,0-.73-.22l-9.74,1.29A.94.94,0,0,0,1131.44,176.74Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1136.52 169.63 1132.64 170.45 1129.23 173.07 1134.95 175.37 1141.96 172.5 1136.52 169.63"
              fill="#ffedc8"
            />
            <polygon
              points="1129.23 173.07 1129.23 175.37 1134.72 177.72 1142.12 174.72 1141.96 172.5 1134.95 175.37 1129.23 173.07"
              fill="#ccae79"
            />
            <polygon
              points="1134.95 175.37 1134.72 177.72 1142.12 174.72 1141.96 172.5 1134.95 175.37"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1130.86,173.73a1,1,0,0,1,0,1.18c.26-.37.32-1,.44-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1133.28,174.7a3.25,3.25,0,0,0,1.44-1.47l-1,1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1137.85,174.18a1.05,1.05,0,0,1,.57.93l-.17-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1140.41,171.68a6.77,6.77,0,0,1-2.27,0,3.33,3.33,0,0,1-1.66.11s1.21-.12,1.66.3A9.82,9.82,0,0,1,1140.41,171.68Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1172.26,163.12l6,3.73a2,2,0,0,0,1.83.12l14.41-6.44a2,2,0,0,0,.48-3.25h0a1.92,1.92,0,0,0-1.54-.46L1173,159.53A2,2,0,0,0,1172.26,163.12Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1182.91 148.22 1174.79 149.94 1167.63 155.44 1179.63 160.25 1194.32 154.24 1182.91 148.22"
              fill="#ffedc8"
            />
            <polygon
              points="1167.63 155.44 1167.63 160.25 1179.14 165.18 1194.63 158.9 1194.32 154.24 1179.63 160.25 1167.63 155.44"
              fill="#ccae79"
            />
            <polygon
              points="1179.63 160.25 1179.14 165.18 1194.63 158.9 1194.32 154.24 1179.63 160.25"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1171.06,156.82a2.15,2.15,0,0,1,0,2.46c.54-.77.66-2.2.91-2.1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1176.12,158.84a6.82,6.82,0,0,0,3-3.07l-2.17,3.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.69,157.77a2.22,2.22,0,0,1,1.2,1.94l-.36-2.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.06,152.52c-.15-.08-3,.58-4.77,0a6.86,6.86,0,0,1-3.47.24s2.55-.25,3.47.62A20.61,20.61,0,0,1,1191.06,152.52Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1192.17,160.79s1,2.07,2.49,2.42,3.64-1.09,3.3.1,2.74,1.73,4,1.41,4.22-3.15,4.2-4S1192.17,160.79,1192.17,160.79Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1192.12,159.09l.05,1.7,2.49,1.74,3.24-.08.77,1.24s2.24,1,3.73-.1a12.15,12.15,0,0,0,2.61-3.14l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1194.72,157.92l-2.6,1.17,2.68,1.74,3.09-.09,1,1.28s3,.82,3.42-.1a18.64,18.64,0,0,1,2.62-3.17l-2.44-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1194.8 160.82 1194.66 162.53 1197.9 162.44 1197.89 160.74 1194.8 160.82"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1201.58,162.33s.53,1.55,0,1.66a7.44,7.44,0,0,0,3.39-3.54l0-1.7S1202.29,162.32,1201.58,162.33Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1199.49,162.15l.61.11s-.38-.1-.29.61A1.61,1.61,0,0,0,1199.49,162.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1200.89,162.36c-.07,0,.12,0,.67-.57a3.71,3.71,0,0,0,.76-1.17s-1.32,1.52-1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1193.69,160.11a10.65,10.65,0,0,1,0,1.23s-.07-.93.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1198.44,157.82l1.24,0c.09,0-1,0-1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1193.43,158.5l.65-.29s-.37.24-.22.28.72.28,1,.16a1,1,0,0,1,.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1126.21,220.37s2,4,4.77,4.63,7-2.09,6.32.19,5.23,3.3,7.74,2.68,8-6,8-7.72S1126.21,220.37,1126.21,220.37Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1126.12,217.12l.09,3.25,4.78,3.33,6.19-.17,1.47,2.38s4.28,2,7.12-.19a23.16,23.16,0,0,0,5-6l-.09-3.24Z"
              fill="#ccae79"
            />
            <path
              d="M1131.1,214.88l-5,2.24,5.13,3.31,5.92-.16,2,2.44s5.82,1.57,6.53-.18,5-6.07,5-6.07l-4.66-2Z"
              fill="#ffedc8"
            />
            <polygon
              points="1131.25 220.43 1130.99 223.7 1137.18 223.53 1137.17 220.27 1131.25 220.43"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1144.21,223.32s1,3,.08,3.16a14.24,14.24,0,0,0,6.49-6.78l-.09-3.24S1145.57,223.3,1144.21,223.32Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1140.21,223l1.18.21s-.73-.19-.56,1.18A3.24,3.24,0,0,0,1140.21,223Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1142.9,223.37c-.13,0,.23,0,1.28-1.09a7.05,7.05,0,0,0,1.44-2.24s-2.51,2.91-1.89,3.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1129.12,219.06a20.78,20.78,0,0,1,.07,2.35s-.14-1.77.35-2.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1138.22,214.69l2.35-.07c.17,0-1.85,0-2.32,1.11l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.63,216l1.24-.56s-.7.45-.42.54,1.38.54,1.82.3a1.83,1.83,0,0,1,1.18,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1160.76,220.48s1.56,3.11,3.74,3.64,5.47-1.64,5,.15,4.11,2.59,6.08,2.1,6.33-4.72,6.3-6.06S1160.76,220.48,1160.76,220.48Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1160.69,217.93l.07,2.55,3.75,2.62,4.86-.14,1.16,1.87s3.35,1.57,5.59-.15a18.17,18.17,0,0,0,3.93-4.72l-.07-2.55Z"
              fill="#ccae79"
            />
            <path
              d="M1164.6,216.17l-3.91,1.76,4,2.6,4.65-.12,1.56,1.91s4.57,1.23,5.12-.14,3.94-4.77,3.94-4.77l-3.66-1.56Z"
              fill="#ffedc8"
            />
            <polygon
              points="1164.71 220.53 1164.51 223.09 1169.37 222.96 1169.36 220.41 1164.71 220.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1174.89,222.8s.8,2.32.07,2.48a11.2,11.2,0,0,0,5.09-5.32l-.07-2.55S1176,222.78,1174.89,222.8Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1171.75,222.51l.92.17s-.57-.15-.43.93A2.67,2.67,0,0,0,1171.75,222.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1173.86,222.84c-.1,0,.18,0,1-.86a5.53,5.53,0,0,0,1.13-1.75s-2,2.28-1.49,2.6Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163,219.45a14.48,14.48,0,0,1,0,1.85s-.11-1.39.28-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.18,216,1172,216c.14,0-1.45,0-1.82.87l0-.82"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.66,217.05l1-.44s-.55.35-.33.42,1.08.42,1.43.24a1.4,1.4,0,0,1,.93,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1223.87,270.63s1.84,3.65,4.39,4.27,6.42-1.93,5.82.17,4.81,3,7.13,2.47,7.41-5.53,7.38-7.1S1223.87,270.63,1223.87,270.63Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1223.79,267.64l.08,3,4.4,3.07,5.7-.16,1.36,2.2s3.93,1.83,6.55-.18a21.28,21.28,0,0,0,4.61-5.54l-.08-3Z"
              fill="#ccae79"
            />
            <path
              d="M1228.37,265.58l-4.58,2.06,4.72,3.05,5.45-.14,1.83,2.24s5.36,1.44,6-.16,4.61-5.6,4.61-5.6l-4.29-1.82Z"
              fill="#ffedc8"
            />
            <polygon
              points="1228.51 270.69 1228.27 273.7 1233.97 273.55 1233.96 270.55 1228.51 270.69"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1240.44,273.35s.94,2.72.08,2.91a13.11,13.11,0,0,0,6-6.24l-.08-3S1241.7,273.33,1240.44,273.35Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1236.76,273l1.08.2s-.67-.18-.5,1.08A3,3,0,0,0,1236.76,273Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1239.23,273.4c-.11,0,.22,0,1.19-1a6.23,6.23,0,0,0,1.32-2.05s-2.31,2.67-1.74,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1226.55,269.43a18.65,18.65,0,0,1,.06,2.16s-.13-1.63.33-1.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1234.93,265.4l2.16-.06c.16,0-1.7,0-2.14,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1226.1,266.6l1.14-.51s-.64.41-.39.49,1.27.5,1.68.28a1.64,1.64,0,0,1,1.09,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1215.33,229.67s-1.26,2.5-3,2.92-4.4-1.32-4,.12-3.3,2.09-4.89,1.7-5.09-3.8-5.07-4.88S1215.33,229.67,1215.33,229.67Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1215.38,227.62l-.05,2-3,2.1-3.92-.1-.92,1.5s-2.7,1.26-4.5-.12a14.52,14.52,0,0,1-3.16-3.8l0-2.05Z"
              fill="#ccae79"
            />
            <path
              d="M1212.24,226.2l3.14,1.42-3.24,2.09-3.73-.1-1.26,1.54s-3.68,1-4.12-.11-3.17-3.84-3.17-3.84l2.94-1.25Z"
              fill="#ffedc8"
            />
            <polygon
              points="1212.14 229.71 1212.31 231.77 1208.39 231.67 1208.4 229.61 1212.14 229.71"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1204,231.53s-.65,1.87-.06,2a9,9,0,0,1-4.09-4.28l0-2.05S1203.1,231.52,1204,231.53Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1206.48,231.31l-.74.13s.46-.12.35.75A2.06,2.06,0,0,1,1206.48,231.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1204.78,231.57c.09,0-.14,0-.81-.69a4.55,4.55,0,0,1-.91-1.42s1.59,1.84,1.2,2.1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1213.49,228.84a11.73,11.73,0,0,0,0,1.49s.08-1.12-.23-1.32Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1207.74,226.08l-1.49,0c-.11,0,1.17,0,1.47.7l0-.66"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1213.8,226.9l-.78-.35s.44.29.26.34-.87.34-1.15.19a1.14,1.14,0,0,0-.75,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1192.32,269.71s-1,2.08-2.5,2.43-3.65-1.1-3.31.1-2.74,1.73-4.06,1.4-4.22-3.15-4.2-4S1192.32,269.71,1192.32,269.71Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1192.37,268l0,1.7-2.5,1.75-3.25-.09-.77,1.25s-2.24,1-3.73-.11a12,12,0,0,1-2.62-3.15l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1189.76,266.83l2.61,1.18-2.69,1.73-3.1-.08-1,1.28s-3,.82-3.42-.09a18.51,18.51,0,0,0-2.63-3.19l2.44-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1189.68 269.74 1189.82 271.46 1186.57 271.37 1186.58 269.66 1189.68 269.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1182.89,271.26s-.54,1.55-.05,1.65a7.39,7.39,0,0,1-3.39-3.55l0-1.7S1182.18,271.25,1182.89,271.26Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1185,271.07l-.61.11s.38-.1.29.62A1.7,1.7,0,0,1,1185,271.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1183.58,271.29c.06,0-.12,0-.68-.58a3.56,3.56,0,0,1-.75-1.17s1.31,1.52,1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1190.8,269a9.91,9.91,0,0,0,0,1.24s.08-.93-.18-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1186,266.73l-1.23,0c-.09,0,1,0,1.21.58l0-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.06,267.42l-.65-.3s.36.24.22.28-.73.29-1,.16a1,1,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1230.17,387.32s-1,2.08-2.5,2.43-3.65-1.1-3.31.1-2.74,1.73-4.06,1.4-4.22-3.15-4.2-4S1230.17,387.32,1230.17,387.32Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1230.22,385.62l0,1.7-2.5,1.74-3.25-.08-.77,1.24s-2.24,1-3.73-.1a12,12,0,0,1-2.62-3.15l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1227.61,384.44l2.61,1.18-2.69,1.73-3.1-.08-1,1.28s-3.05.82-3.42-.1a18.75,18.75,0,0,0-2.63-3.18l2.44-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1227.53 387.35 1227.67 389.06 1224.42 388.98 1224.43 387.27 1227.53 387.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1220.74,388.86s-.54,1.56,0,1.66a7.39,7.39,0,0,1-3.39-3.55l0-1.7S1220,388.85,1220.74,388.86Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1222.84,388.68l-.62.11s.38-.1.29.62A1.69,1.69,0,0,1,1222.84,388.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1221.43,388.9c.06,0-.12,0-.68-.58a3.56,3.56,0,0,1-.75-1.17s1.32,1.52,1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1228.65,386.63a10.65,10.65,0,0,0,0,1.23s.07-.92-.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1223.88,384.34l-1.23,0c-.09,0,1,0,1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1228.91,385l-.65-.29s.36.24.22.28-.73.29-1,.16a1,1,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1220.43,419.88s-1.79,3.57-4.29,4.17-6.26-1.88-5.68.17-4.71,3-7,2.41-7.25-5.41-7.22-6.94S1220.43,419.88,1220.43,419.88Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1220.51,417l-.08,2.92-4.3,3-5.57-.15-1.32,2.14s-3.85,1.79-6.41-.17a20.81,20.81,0,0,1-4.5-5.42l.08-2.92Z"
              fill="#ccae79"
            />
            <path
              d="M1216,414.94l4.47,2-4.61,3-5.32-.15-1.79,2.2s-5.24,1.41-5.87-.16-4.51-5.47-4.51-5.47l4.19-1.78Z"
              fill="#ffedc8"
            />
            <polygon
              points="1215.9 419.94 1216.13 422.88 1210.56 422.73 1210.58 419.79 1215.9 419.94"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1204.24,422.53s-.92,2.67-.08,2.85a12.79,12.79,0,0,1-5.83-6.1l.08-2.92S1203,422.52,1204.24,422.53Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1207.84,422.21l-1.06.19s.66-.17.5,1.06A3,3,0,0,1,1207.84,422.21Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1205.42,422.59c.12,0-.21,0-1.16-1a6.28,6.28,0,0,1-1.29-2s2.26,2.61,1.7,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1217.82,418.7a17.89,17.89,0,0,0-.06,2.12s.12-1.6-.32-1.87Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1209.63,414.77l-2.12-.06c-.15,0,1.67,0,2.1,1l0-.94"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1218.26,415.94l-1.11-.5s.62.4.37.48-1.24.49-1.64.27a1.62,1.62,0,0,0-1.06,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M256.12,230.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,256.12,230.66Z"
                fill="#2f6840"
              />
              <path
                d="M255.61,230.32c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,255.61,230.32Z"
                fill="#3ba525"
              />
              <path
                d="M256.37,230.29a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,256.37,230.29Z"
                fill="#2f6840"
              />
              <path
                d="M259.85,229.49c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,259.85,229.49Z"
                fill="#2f6840"
              />
              <path
                d="M258.48,232.7a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,258.48,232.7Z"
                fill="#2f6840"
              />
              <path
                d="M256.52,230.75c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,256.52,230.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M253.46,239.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,253.46,239.39Z"
                fill="#2f6840"
              />
              <path
                d="M253,239.05c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,253,239.05Z"
                fill="#3ba525"
              />
              <path
                d="M253.71,239a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,253.71,239Z"
                fill="#2f6840"
              />
              <path
                d="M257.19,238.22c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,257.19,238.22Z"
                fill="#2f6840"
              />
              <path
                d="M255.82,241.43a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,255.82,241.43Z"
                fill="#2f6840"
              />
              <path
                d="M253.86,239.48c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,253.86,239.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M248.11,234.43c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,248.11,234.43Z"
                fill="#2f6840"
              />
              <path
                d="M247.6,234.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,247.6,234.09Z"
                fill="#3ba525"
              />
              <path
                d="M248.36,234.06a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,248.36,234.06Z"
                fill="#2f6840"
              />
              <path
                d="M251.83,233.27c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,251.83,233.27Z"
                fill="#2f6840"
              />
              <path
                d="M250.47,236.48a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,250.47,236.48Z"
                fill="#2f6840"
              />
              <path
                d="M248.51,234.52c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,248.51,234.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M239.77,231.06c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,239.77,231.06Z"
                fill="#2f6840"
              />
              <path
                d="M239.26,230.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,239.26,230.72Z"
                fill="#3ba525"
              />
              <path
                d="M240,230.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,240,230.69Z"
                fill="#2f6840"
              />
              <path
                d="M243.49,229.89c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,243.49,229.89Z"
                fill="#2f6840"
              />
              <path
                d="M242.12,233.1a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,242.12,233.1Z"
                fill="#2f6840"
              />
              <path
                d="M240.16,231.15c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,240.16,231.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M254.47,246.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,254.47,246.55Z"
                fill="#2f6840"
              />
              <path
                d="M254,246.21c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,254,246.21Z"
                fill="#3ba525"
              />
              <path
                d="M254.72,246.18a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,254.72,246.18Z"
                fill="#2f6840"
              />
              <path
                d="M258.2,245.38c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,258.2,245.38Z"
                fill="#2f6840"
              />
              <path
                d="M256.83,248.59a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,256.83,248.59Z"
                fill="#2f6840"
              />
              <path
                d="M254.87,246.64c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,254.87,246.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M241,241c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,241,241Z"
                fill="#2f6840"
              />
              <path
                d="M240.51,240.64c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,240.51,240.64Z"
                fill="#3ba525"
              />
              <path
                d="M241.26,240.61a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,241.26,240.61Z"
                fill="#2f6840"
              />
              <path
                d="M244.74,239.81c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,244.74,239.81Z"
                fill="#2f6840"
              />
              <path
                d="M243.37,243a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,243.37,243Z"
                fill="#2f6840"
              />
              <path
                d="M241.41,241.07c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,241.41,241.07Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M283.46,236.22c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,283.46,236.22Z"
                fill="#2f6840"
              />
              <path
                d="M283,235.88c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.67,14.67,0,0,1,283,235.88Z"
                fill="#3ba525"
              />
              <path
                d="M283.71,235.85a2.24,2.24,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,283.71,235.85Z"
                fill="#2f6840"
              />
              <path
                d="M287.18,235.05c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,287.18,235.05Z"
                fill="#2f6840"
              />
              <path
                d="M285.82,238.26a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,285.82,238.26Z"
                fill="#2f6840"
              />
              <path
                d="M283.86,236.31a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,283.86,236.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M280.8,245c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,280.8,245Z"
                fill="#2f6840"
              />
              <path
                d="M280.29,244.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,280.29,244.6Z"
                fill="#3ba525"
              />
              <path
                d="M281.05,244.58a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,281.05,244.58Z"
                fill="#2f6840"
              />
              <path
                d="M284.52,243.78c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,284.52,243.78Z"
                fill="#2f6840"
              />
              <path
                d="M283.16,247a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,283.16,247Z"
                fill="#2f6840"
              />
              <path
                d="M281.2,245c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,281.2,245Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M275.45,240c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,275.45,240Z"
                fill="#2f6840"
              />
              <path
                d="M274.94,239.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,274.94,239.65Z"
                fill="#3ba525"
              />
              <path
                d="M275.69,239.62a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,275.69,239.62Z"
                fill="#2f6840"
              />
              <path
                d="M279.17,238.82c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,279.17,238.82Z"
                fill="#2f6840"
              />
              <path
                d="M277.8,242a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,277.8,242Z"
                fill="#2f6840"
              />
              <path
                d="M275.85,240.08a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,275.85,240.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M267.1,236.62c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,267.1,236.62Z"
                fill="#2f6840"
              />
              <path
                d="M266.6,236.27c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,266.6,236.27Z"
                fill="#3ba525"
              />
              <path
                d="M267.35,236.25a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,267.35,236.25Z"
                fill="#2f6840"
              />
              <path
                d="M270.83,235.45c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,270.83,235.45Z"
                fill="#2f6840"
              />
              <path
                d="M269.46,238.66a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,269.46,238.66Z"
                fill="#2f6840"
              />
              <path
                d="M267.5,236.71c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,267.5,236.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M281.81,252.11c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,281.81,252.11Z"
                fill="#2f6840"
              />
              <path
                d="M281.3,251.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,281.3,251.76Z"
                fill="#3ba525"
              />
              <path
                d="M282.06,251.74a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,282.06,251.74Z"
                fill="#2f6840"
              />
              <path
                d="M285.53,250.94c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,285.53,250.94Z"
                fill="#2f6840"
              />
              <path
                d="M284.17,254.15a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,284.17,254.15Z"
                fill="#2f6840"
              />
              <path
                d="M282.21,252.19c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,282.21,252.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M268.35,246.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,268.35,246.54Z"
                fill="#2f6840"
              />
              <path
                d="M267.85,246.19c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,267.85,246.19Z"
                fill="#3ba525"
              />
              <path
                d="M268.6,246.17a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,268.6,246.17Z"
                fill="#2f6840"
              />
              <path
                d="M272.08,245.37c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,272.08,245.37Z"
                fill="#2f6840"
              />
              <path
                d="M270.71,248.58a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,270.71,248.58Z"
                fill="#2f6840"
              />
              <path
                d="M268.75,246.63a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,268.75,246.63Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M305.78,253.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,305.78,253.23Z"
                fill="#2f6840"
              />
              <path
                d="M305.28,252.89c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,305.28,252.89Z"
                fill="#3ba525"
              />
              <path
                d="M306,252.86a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,306,252.86Z"
                fill="#2f6840"
              />
              <path
                d="M309.51,252.07c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.38,2.38,0,0,1,308,252,2.07,2.07,0,0,1,309.51,252.07Z"
                fill="#2f6840"
              />
              <path
                d="M308.14,255.28a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,308.14,255.28Z"
                fill="#2f6840"
              />
              <path
                d="M306.18,253.32c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,306.18,253.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M303.12,262c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,303.12,262Z"
                fill="#2f6840"
              />
              <path
                d="M302.62,261.62c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,302.62,261.62Z"
                fill="#3ba525"
              />
              <path
                d="M303.37,261.59a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,303.37,261.59Z"
                fill="#2f6840"
              />
              <path
                d="M306.85,260.79c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,306.85,260.79Z"
                fill="#2f6840"
              />
              <path
                d="M305.48,264a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,305.48,264Z"
                fill="#2f6840"
              />
              <path
                d="M303.52,262.05c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,303.52,262.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M297.77,257c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,297.77,257Z"
                fill="#2f6840"
              />
              <path
                d="M297.27,256.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,297.27,256.66Z"
                fill="#3ba525"
              />
              <path
                d="M298,256.63a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,298,256.63Z"
                fill="#2f6840"
              />
              <path
                d="M301.5,255.84c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,301.5,255.84Z"
                fill="#2f6840"
              />
              <path
                d="M300.13,259.05a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,300.13,259.05Z"
                fill="#2f6840"
              />
              <path
                d="M298.17,257.09c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,298.17,257.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M289.43,253.63c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,289.43,253.63Z"
                fill="#2f6840"
              />
              <path
                d="M288.92,253.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,288.92,253.29Z"
                fill="#3ba525"
              />
              <path
                d="M289.68,253.26a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,289.68,253.26Z"
                fill="#2f6840"
              />
              <path
                d="M293.15,252.46c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,293.15,252.46Z"
                fill="#2f6840"
              />
              <path
                d="M291.79,255.67a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,291.79,255.67Z"
                fill="#2f6840"
              />
              <path
                d="M289.83,253.72c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,289.83,253.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M304.13,269.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,304.13,269.12Z"
                fill="#2f6840"
              />
              <path
                d="M303.63,268.78c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,303.63,268.78Z"
                fill="#3ba525"
              />
              <path
                d="M304.38,268.75a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,304.38,268.75Z"
                fill="#2f6840"
              />
              <path
                d="M307.86,268c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,307.86,268Z"
                fill="#2f6840"
              />
              <path
                d="M306.49,271.16a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,306.49,271.16Z"
                fill="#2f6840"
              />
              <path
                d="M304.53,269.21c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,304.53,269.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M290.68,263.55c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,290.68,263.55Z"
                fill="#2f6840"
              />
              <path
                d="M290.17,263.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,290.17,263.21Z"
                fill="#3ba525"
              />
              <path
                d="M290.92,263.18a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,290.92,263.18Z"
                fill="#2f6840"
              />
              <path
                d="M294.4,262.38c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,294.4,262.38Z"
                fill="#2f6840"
              />
              <path
                d="M293,265.59a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,293,265.59Z"
                fill="#2f6840"
              />
              <path
                d="M291.08,263.64c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,291.08,263.64Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M321.89,276.58c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,321.89,276.58Z"
                fill="#2f6840"
              />
              <path
                d="M321.38,276.24c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,321.38,276.24Z"
                fill="#3ba525"
              />
              <path
                d="M322.14,276.21a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,322.14,276.21Z"
                fill="#2f6840"
              />
              <path
                d="M325.61,275.41c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,325.61,275.41Z"
                fill="#2f6840"
              />
              <path
                d="M324.25,278.62a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,324.25,278.62Z"
                fill="#2f6840"
              />
              <path
                d="M322.29,276.67a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,322.29,276.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M319.23,285.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,319.23,285.31Z"
                fill="#2f6840"
              />
              <path
                d="M318.72,285c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,318.72,285Z"
                fill="#3ba525"
              />
              <path
                d="M319.48,284.94a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,319.48,284.94Z"
                fill="#2f6840"
              />
              <path
                d="M323,284.14c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,323,284.14Z"
                fill="#2f6840"
              />
              <path
                d="M321.59,287.35a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,321.59,287.35Z"
                fill="#2f6840"
              />
              <path
                d="M319.63,285.4a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,319.63,285.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M313.88,280.35c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,313.88,280.35Z"
                fill="#2f6840"
              />
              <path
                d="M313.37,280c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,313.37,280Z"
                fill="#3ba525"
              />
              <path
                d="M314.12,280a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,314.12,280Z"
                fill="#2f6840"
              />
              <path
                d="M317.6,279.18c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,317.6,279.18Z"
                fill="#2f6840"
              />
              <path
                d="M316.23,282.39a1.94,1.94,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,316.23,282.39Z"
                fill="#2f6840"
              />
              <path
                d="M314.28,280.44a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,314.28,280.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M305.54,277c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,305.54,277Z"
                fill="#2f6840"
              />
              <path
                d="M305,276.64c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,305,276.64Z"
                fill="#3ba525"
              />
              <path
                d="M305.78,276.61a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,305.78,276.61Z"
                fill="#2f6840"
              />
              <path
                d="M309.26,275.81c-.26,0-.49.05-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,309.26,275.81Z"
                fill="#2f6840"
              />
              <path
                d="M307.89,279a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,307.89,279Z"
                fill="#2f6840"
              />
              <path
                d="M305.93,277.07a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,305.93,277.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M320.24,292.47c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,320.24,292.47Z"
                fill="#2f6840"
              />
              <path
                d="M319.73,292.12c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,319.73,292.12Z"
                fill="#3ba525"
              />
              <path
                d="M320.49,292.1a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,320.49,292.1Z"
                fill="#2f6840"
              />
              <path
                d="M324,291.3c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,324,291.3Z"
                fill="#2f6840"
              />
              <path
                d="M322.6,294.51a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,322.6,294.51Z"
                fill="#2f6840"
              />
              <path
                d="M320.64,292.56a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,320.64,292.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M306.78,286.9c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,306.78,286.9Z"
                fill="#2f6840"
              />
              <path
                d="M306.28,286.56c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,306.28,286.56Z"
                fill="#3ba525"
              />
              <path
                d="M307,286.53a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,307,286.53Z"
                fill="#2f6840"
              />
              <path
                d="M310.51,285.73c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,310.51,285.73Z"
                fill="#2f6840"
              />
              <path
                d="M309.14,288.94a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,309.14,288.94Z"
                fill="#2f6840"
              />
              <path
                d="M307.18,287c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,307.18,287Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M343,295c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,343,295Z"
                fill="#2f6840"
              />
              <path
                d="M342.44,294.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,342.44,294.65Z"
                fill="#3ba525"
              />
              <path
                d="M343.19,294.62a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,343.19,294.62Z"
                fill="#2f6840"
              />
              <path
                d="M346.67,293.83a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,346.67,293.83Z"
                fill="#2f6840"
              />
              <path
                d="M345.3,297a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,345.3,297Z"
                fill="#2f6840"
              />
              <path
                d="M343.34,295.08c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,343.34,295.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M340.29,303.73c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,340.29,303.73Z"
                fill="#2f6840"
              />
              <path
                d="M339.78,303.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,339.78,303.38Z"
                fill="#3ba525"
              />
              <path
                d="M340.53,303.35a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,340.53,303.35Z"
                fill="#2f6840"
              />
              <path
                d="M344,302.56a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,344,302.56Z"
                fill="#2f6840"
              />
              <path
                d="M342.64,305.77a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,342.64,305.77Z"
                fill="#2f6840"
              />
              <path
                d="M340.69,303.81c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,340.69,303.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M334.93,298.77c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,334.93,298.77Z"
                fill="#2f6840"
              />
              <path
                d="M334.43,298.42c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,334.43,298.42Z"
                fill="#3ba525"
              />
              <path
                d="M335.18,298.39a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,335.18,298.39Z"
                fill="#2f6840"
              />
              <path
                d="M338.66,297.6c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,338.66,297.6Z"
                fill="#2f6840"
              />
              <path
                d="M337.29,300.81a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,337.29,300.81Z"
                fill="#2f6840"
              />
              <path
                d="M335.33,298.85c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,335.33,298.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M326.59,295.4c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,326.59,295.4Z"
                fill="#2f6840"
              />
              <path
                d="M326.09,295.05c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,326.09,295.05Z"
                fill="#3ba525"
              />
              <path
                d="M326.84,295a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,326.84,295Z"
                fill="#2f6840"
              />
              <path
                d="M330.32,294.23a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,330.32,294.23Z"
                fill="#2f6840"
              />
              <path
                d="M329,297.44a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,329,297.44Z"
                fill="#2f6840"
              />
              <path
                d="M327,295.48c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,327,295.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M341.3,310.89c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,341.3,310.89Z"
                fill="#2f6840"
              />
              <path
                d="M340.79,310.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,340.79,310.54Z"
                fill="#3ba525"
              />
              <path
                d="M341.54,310.51a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,341.54,310.51Z"
                fill="#2f6840"
              />
              <path
                d="M345,309.72c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,345,309.72Z"
                fill="#2f6840"
              />
              <path
                d="M343.65,312.93a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,343.65,312.93Z"
                fill="#2f6840"
              />
              <path
                d="M341.7,311c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,341.7,311Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M327.84,305.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,327.84,305.32Z"
                fill="#2f6840"
              />
              <path
                d="M327.33,305c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,327.33,305Z"
                fill="#3ba525"
              />
              <path
                d="M328.09,304.94a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,328.09,304.94Z"
                fill="#2f6840"
              />
              <path
                d="M331.56,304.15a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,331.56,304.15Z"
                fill="#2f6840"
              />
              <path
                d="M330.2,307.36a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,330.2,307.36Z"
                fill="#2f6840"
              />
              <path
                d="M328.24,305.4c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,328.24,305.4Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M21.46,197.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72S22,198,22,198s-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,21.46,197.16Z"
                fill="#2f6840"
              />
              <path
                d="M21,196.82c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,21,196.82Z"
                fill="#3ba525"
              />
              <path
                d="M21.71,196.79a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,21.71,196.79Z"
                fill="#2f6840"
              />
              <path
                d="M25.19,196c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,25.19,196Z"
                fill="#2f6840"
              />
              <path
                d="M23.82,199.2a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,23.82,199.2Z"
                fill="#2f6840"
              />
              <path
                d="M21.86,197.25c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,21.86,197.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M18.8,205.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55S14.08,207,14.26,207A14.55,14.55,0,0,1,18.8,205.89Z"
                fill="#2f6840"
              />
              <path
                d="M18.3,205.54c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S26,206.13,25.07,206s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,18.3,205.54Z"
                fill="#3ba525"
              />
              <path
                d="M19.05,205.52a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,19.05,205.52Z"
                fill="#2f6840"
              />
              <path
                d="M22.53,204.72c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,22.53,204.72Z"
                fill="#2f6840"
              />
              <path
                d="M21.16,207.93a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,21.16,207.93Z"
                fill="#2f6840"
              />
              <path
                d="M19.2,206a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,19.2,206Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M13.45,200.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55S8.72,202.08,8.9,202A14.65,14.65,0,0,1,13.45,200.93Z"
                fill="#2f6840"
              />
              <path
                d="M12.94,200.59c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,12.94,200.59Z"
                fill="#3ba525"
              />
              <path
                d="M13.7,200.56a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,13.7,200.56Z"
                fill="#2f6840"
              />
              <path
                d="M17.17,199.76c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,17.17,199.76Z"
                fill="#2f6840"
              />
              <path
                d="M15.81,203a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,15.81,203Z"
                fill="#2f6840"
              />
              <path
                d="M13.85,201a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,13.85,201Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M5.11,197.56c4.42-.25-4.33.46-4.36-.61S5.1,194.32,6,194.49s.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S.38,198.71.56,198.62A14.56,14.56,0,0,1,5.11,197.56Z"
                fill="#2f6840"
              />
              <path
                d="M4.6,197.21C9,197,.27,197.67.25,196.6S4.6,194,5.53,194.15s.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,4.6,197.21Z"
                fill="#3ba525"
              />
              <path
                d="M5.35,197.19a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,5.35,197.19Z"
                fill="#2f6840"
              />
              <path
                d="M8.83,196.39c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,8.83,196.39Z"
                fill="#2f6840"
              />
              <path
                d="M7.46,199.6a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,7.46,199.6Z"
                fill="#2f6840"
              />
              <path
                d="M5.51,197.65a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,5.51,197.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M19.81,213.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.46,14.46,0,0,1,19.81,213.05Z"
                fill="#2f6840"
              />
              <path
                d="M19.31,212.7c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,19.31,212.7Z"
                fill="#3ba525"
              />
              <path
                d="M20.06,212.68a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45A2.16,2.16,0,0,1,20,212,1,1,0,0,1,20.06,212.68Z"
                fill="#2f6840"
              />
              <path
                d="M23.54,211.88c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,23.54,211.88Z"
                fill="#2f6840"
              />
              <path
                d="M22.17,215.09a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,22.17,215.09Z"
                fill="#2f6840"
              />
              <path
                d="M20.21,213.14a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,20.21,213.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M6.36,207.48c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,6.36,207.48Z"
                fill="#2f6840"
              />
              <path
                d="M5.85,207.13c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71S6.38,208,6.38,208s-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,5.85,207.13Z"
                fill="#3ba525"
              />
              <path
                d="M6.6,207.11a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,6.6,207.11Z"
                fill="#2f6840"
              />
              <path
                d="M10.08,206.31c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,10.08,206.31Z"
                fill="#2f6840"
              />
              <path
                d="M8.71,209.52a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,8.71,209.52Z"
                fill="#2f6840"
              />
              <path
                d="M6.75,207.57a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,6.75,207.57Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M48.5,202.57c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,48.5,202.57Z"
                fill="#2f6840"
              />
              <path
                d="M48,202.23c4.42-.25-4.33.46-4.35-.61S48,199,48.93,199.17s.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,48,202.23Z"
                fill="#3ba525"
              />
              <path
                d="M48.75,202.2a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,48.75,202.2Z"
                fill="#2f6840"
              />
              <path
                d="M52.23,201.41c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,52.23,201.41Z"
                fill="#2f6840"
              />
              <path
                d="M50.86,204.62a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,50.86,204.62Z"
                fill="#2f6840"
              />
              <path
                d="M48.9,202.66c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,48.9,202.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M45.84,211.3c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,45.84,211.3Z"
                fill="#2f6840"
              />
              <path
                d="M45.34,211c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,45.34,211Z"
                fill="#3ba525"
              />
              <path
                d="M46.09,210.93a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,46.09,210.93Z"
                fill="#2f6840"
              />
              <path
                d="M49.57,210.13c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,49.57,210.13Z"
                fill="#2f6840"
              />
              <path
                d="M48.2,213.34a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,48.2,213.34Z"
                fill="#2f6840"
              />
              <path
                d="M46.24,211.39c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,46.24,211.39Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M40.49,206.34c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55S35.77,207.5,36,207.4A14.86,14.86,0,0,1,40.49,206.34Z"
                fill="#2f6840"
              />
              <path
                d="M40,206c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,40,206Z"
                fill="#3ba525"
              />
              <path
                d="M40.74,206a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,40.74,206Z"
                fill="#2f6840"
              />
              <path
                d="M44.22,205.18c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,44.22,205.18Z"
                fill="#2f6840"
              />
              <path
                d="M42.85,208.39a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,42.85,208.39Z"
                fill="#2f6840"
              />
              <path
                d="M40.89,206.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,40.89,206.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M32.15,203c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,32.15,203Z"
                fill="#2f6840"
              />
              <path
                d="M31.64,202.63c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,31.64,202.63Z"
                fill="#3ba525"
              />
              <path
                d="M32.4,202.6a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,32.4,202.6Z"
                fill="#2f6840"
              />
              <path
                d="M35.87,201.81c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,35.87,201.81Z"
                fill="#2f6840"
              />
              <path
                d="M34.51,205a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,34.51,205Z"
                fill="#2f6840"
              />
              <path
                d="M32.55,203.06c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,32.55,203.06Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M46.85,218.46c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,46.85,218.46Z"
                fill="#2f6840"
              />
              <path
                d="M46.35,218.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,46.35,218.12Z"
                fill="#3ba525"
              />
              <path
                d="M47.1,218.09a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,47.1,218.09Z"
                fill="#2f6840"
              />
              <path
                d="M50.58,217.29c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,50.58,217.29Z"
                fill="#2f6840"
              />
              <path
                d="M49.21,220.5a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,49.21,220.5Z"
                fill="#2f6840"
              />
              <path
                d="M47.25,218.55c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,47.25,218.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M33.4,212.89c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S28.67,214,28.85,214A14.65,14.65,0,0,1,33.4,212.89Z"
                fill="#2f6840"
              />
              <path
                d="M32.89,212.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S35.33,209,37,209.58s3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.08-2.37A14.65,14.65,0,0,1,32.89,212.55Z"
                fill="#3ba525"
              />
              <path
                d="M33.64,212.52a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,33.64,212.52Z"
                fill="#2f6840"
              />
              <path
                d="M37.12,211.73c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,37.12,211.73Z"
                fill="#2f6840"
              />
              <path
                d="M35.75,214.94a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,35.75,214.94Z"
                fill="#2f6840"
              />
              <path
                d="M33.8,213c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,33.8,213Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M77,202.55c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,77,202.55Z"
                fill="#2f6840"
              />
              <path
                d="M76.48,202.21c4.42-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.77,14.77,0,0,1,76.48,202.21Z"
                fill="#3ba525"
              />
              <path
                d="M77.23,202.18a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,77.23,202.18Z"
                fill="#2f6840"
              />
              <path
                d="M80.71,201.38c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,80.71,201.38Z"
                fill="#2f6840"
              />
              <path
                d="M79.34,204.59a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,79.34,204.59Z"
                fill="#2f6840"
              />
              <path
                d="M77.38,202.64c-.24.05-.47.08-.7.15A4.41,4.41,0,0,0,76,203a10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,77.38,202.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M74.32,211.28c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,74.32,211.28Z"
                fill="#2f6840"
              />
              <path
                d="M73.82,210.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,73.82,210.93Z"
                fill="#3ba525"
              />
              <path
                d="M74.57,210.91a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,74.57,210.91Z"
                fill="#2f6840"
              />
              <path
                d="M78.05,210.11c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,78.05,210.11Z"
                fill="#2f6840"
              />
              <path
                d="M76.68,213.32a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,76.68,213.32Z"
                fill="#2f6840"
              />
              <path
                d="M74.72,211.36c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,74.72,211.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M69,206.32c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,69,206.32Z"
                fill="#2f6840"
              />
              <path
                d="M68.47,206c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,68.47,206Z"
                fill="#3ba525"
              />
              <path
                d="M69.22,206a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,69.22,206Z"
                fill="#2f6840"
              />
              <path
                d="M72.7,205.15c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17A14.29,14.29,0,0,0,70,206a2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,72.7,205.15Z"
                fill="#2f6840"
              />
              <path
                d="M71.33,208.36a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,71.33,208.36Z"
                fill="#2f6840"
              />
              <path
                d="M69.37,206.41a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,69.37,206.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M60.63,203c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55S55.9,204.1,56.08,204A14.65,14.65,0,0,1,60.63,203Z"
                fill="#2f6840"
              />
              <path
                d="M60.12,202.6c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,60.12,202.6Z"
                fill="#3ba525"
              />
              <path
                d="M60.88,202.58a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,60.88,202.58Z"
                fill="#2f6840"
              />
              <path
                d="M64.35,201.78c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,64.35,201.78Z"
                fill="#2f6840"
              />
              <path
                d="M63,205a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,63,205Z"
                fill="#2f6840"
              />
              <path
                d="M61,203a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,61,203Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M75.33,218.44c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,75.33,218.44Z"
                fill="#2f6840"
              />
              <path
                d="M74.83,218.09c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,74.83,218.09Z"
                fill="#3ba525"
              />
              <path
                d="M75.58,218.07a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,75.58,218.07Z"
                fill="#2f6840"
              />
              <path
                d="M79.06,217.27c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,79.06,217.27Z"
                fill="#2f6840"
              />
              <path
                d="M77.69,220.48a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,77.69,220.48Z"
                fill="#2f6840"
              />
              <path
                d="M75.73,218.52c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,75.73,218.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M61.88,212.87c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,61.88,212.87Z"
                fill="#2f6840"
              />
              <path
                d="M61.37,212.52c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,61.37,212.52Z"
                fill="#3ba525"
              />
              <path
                d="M62.12,212.5a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,62.12,212.5Z"
                fill="#2f6840"
              />
              <path
                d="M65.6,211.7c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,65.6,211.7Z"
                fill="#2f6840"
              />
              <path
                d="M64.23,214.91a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,64.23,214.91Z"
                fill="#2f6840"
              />
              <path
                d="M62.28,213a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,62.28,213Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M105.37,205c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,105.37,205Z"
                fill="#2f6840"
              />
              <path
                d="M104.87,204.65c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,104.87,204.65Z"
                fill="#3ba525"
              />
              <path
                d="M105.62,204.62a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,105.62,204.62Z"
                fill="#2f6840"
              />
              <path
                d="M109.1,203.82c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,109.1,203.82Z"
                fill="#2f6840"
              />
              <path
                d="M107.73,207a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,107.73,207Z"
                fill="#2f6840"
              />
              <path
                d="M105.77,205.08c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,105.77,205.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M102.71,213.72c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,102.71,213.72Z"
                fill="#2f6840"
              />
              <path
                d="M102.21,213.38c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15S110,214,109,213.85s-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,102.21,213.38Z"
                fill="#3ba525"
              />
              <path
                d="M103,213.35a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,103,213.35Z"
                fill="#2f6840"
              />
              <path
                d="M106.44,212.55c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,106.44,212.55Z"
                fill="#2f6840"
              />
              <path
                d="M105.07,215.76a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,105.07,215.76Z"
                fill="#2f6840"
              />
              <path
                d="M103.11,213.81c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,103.11,213.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M97.36,208.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.46,14.46,0,0,1,97.36,208.76Z"
                fill="#2f6840"
              />
              <path
                d="M96.86,208.42c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,96.86,208.42Z"
                fill="#3ba525"
              />
              <path
                d="M97.61,208.39a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,97.61,208.39Z"
                fill="#2f6840"
              />
              <path
                d="M101.09,207.6c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,101.09,207.6Z"
                fill="#2f6840"
              />
              <path
                d="M99.72,210.81a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,99.72,210.81Z"
                fill="#2f6840"
              />
              <path
                d="M97.76,208.85c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,97.76,208.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M89,205.39c4.43-.25-4.33.46-4.35-.61S89,202.15,90,202.33s.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,89,205.39Z"
                fill="#2f6840"
              />
              <path
                d="M88.51,205.05c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,88.51,205.05Z"
                fill="#3ba525"
              />
              <path
                d="M89.27,205a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,89.27,205Z"
                fill="#2f6840"
              />
              <path
                d="M92.74,204.22c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18A11.87,11.87,0,0,0,90,205a2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,92.74,204.22Z"
                fill="#2f6840"
              />
              <path
                d="M91.38,207.43a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,91.38,207.43Z"
                fill="#2f6840"
              />
              <path
                d="M89.42,205.48c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,89.42,205.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M103.72,220.88c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S99,222,99.18,221.94A14.55,14.55,0,0,1,103.72,220.88Z"
                fill="#2f6840"
              />
              <path
                d="M103.22,220.54c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15S111,221.12,110,221s-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,103.22,220.54Z"
                fill="#3ba525"
              />
              <path
                d="M104,220.51a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,104,220.51Z"
                fill="#2f6840"
              />
              <path
                d="M107.45,219.71c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,107.45,219.71Z"
                fill="#2f6840"
              />
              <path
                d="M106.08,222.92a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,106.08,222.92Z"
                fill="#2f6840"
              />
              <path
                d="M104.12,221c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,104.12,221Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M90.27,215.31c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16S98,215.9,97,215.78s-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,90.27,215.31Z"
                fill="#2f6840"
              />
              <path
                d="M89.76,215c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55S85,216.12,85.21,216A14.65,14.65,0,0,1,89.76,215Z"
                fill="#3ba525"
              />
              <path
                d="M90.51,214.94a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,90.51,214.94Z"
                fill="#2f6840"
              />
              <path
                d="M94,214.14c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,94,214.14Z"
                fill="#2f6840"
              />
              <path
                d="M92.62,217.35a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,92.62,217.35Z"
                fill="#2f6840"
              />
              <path
                d="M90.67,215.4c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,90.67,215.4Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M132.36,213.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,132.36,213.76Z"
                fill="#2f6840"
              />
              <path
                d="M131.86,213.42c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,131.86,213.42Z"
                fill="#3ba525"
              />
              <path
                d="M132.61,213.39a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,132.61,213.39Z"
                fill="#2f6840"
              />
              <path
                d="M136.09,212.59c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,136.09,212.59Z"
                fill="#2f6840"
              />
              <path
                d="M134.72,215.8a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,134.72,215.8Z"
                fill="#2f6840"
              />
              <path
                d="M132.76,213.85a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,132.76,213.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M129.7,222.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,129.7,222.49Z"
                fill="#2f6840"
              />
              <path
                d="M129.2,222.14c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,129.2,222.14Z"
                fill="#3ba525"
              />
              <path
                d="M130,222.12a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,130,222.12Z"
                fill="#2f6840"
              />
              <path
                d="M133.43,221.32c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,133.43,221.32Z"
                fill="#2f6840"
              />
              <path
                d="M132.06,224.53a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,132.06,224.53Z"
                fill="#2f6840"
              />
              <path
                d="M130.1,222.58a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,130.1,222.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M124.35,217.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,124.35,217.53Z"
                fill="#2f6840"
              />
              <path
                d="M123.84,217.19c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,123.84,217.19Z"
                fill="#3ba525"
              />
              <path
                d="M124.6,217.16a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,124.6,217.16Z"
                fill="#2f6840"
              />
              <path
                d="M128.07,216.36c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,128.07,216.36Z"
                fill="#2f6840"
              />
              <path
                d="M126.71,219.57a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,126.71,219.57Z"
                fill="#2f6840"
              />
              <path
                d="M124.75,217.62c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,124.75,217.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M116,214.16c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,116,214.16Z"
                fill="#2f6840"
              />
              <path
                d="M115.5,213.82c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,115.5,213.82Z"
                fill="#3ba525"
              />
              <path
                d="M116.25,213.79a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,116.25,213.79Z"
                fill="#2f6840"
              />
              <path
                d="M119.73,213c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,119.73,213Z"
                fill="#2f6840"
              />
              <path
                d="M118.36,216.2a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81A2.17,2.17,0,0,1,118,215a1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,118.36,216.2Z"
                fill="#2f6840"
              />
              <path
                d="M116.41,214.25a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,116.41,214.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M130.71,229.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,130.71,229.65Z"
                fill="#2f6840"
              />
              <path
                d="M130.21,229.3c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,130.21,229.3Z"
                fill="#3ba525"
              />
              <path
                d="M131,229.28a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,131,229.28Z"
                fill="#2f6840"
              />
              <path
                d="M134.44,228.48c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,134.44,228.48Z"
                fill="#2f6840"
              />
              <path
                d="M133.07,231.69a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,133.07,231.69Z"
                fill="#2f6840"
              />
              <path
                d="M131.11,229.74a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,131.11,229.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M117.25,224.08c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,117.25,224.08Z"
                fill="#2f6840"
              />
              <path
                d="M116.75,223.74c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,116.75,223.74Z"
                fill="#3ba525"
              />
              <path
                d="M117.5,223.71a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,117.5,223.71Z"
                fill="#2f6840"
              />
              <path
                d="M121,222.91c-.26,0-.49.05-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,121,222.91Z"
                fill="#2f6840"
              />
              <path
                d="M119.61,226.12a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,119.61,226.12Z"
                fill="#2f6840"
              />
              <path
                d="M117.65,224.17a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,117.65,224.17Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M157.58,227c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S160,223.4,161.7,224s3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,157.58,227Z"
                fill="#2f6840"
              />
              <path
                d="M157.07,226.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,157.07,226.65Z"
                fill="#3ba525"
              />
              <path
                d="M157.82,226.62a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,157.82,226.62Z"
                fill="#2f6840"
              />
              <path
                d="M161.3,225.83c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,161.3,225.83Z"
                fill="#2f6840"
              />
              <path
                d="M159.93,229a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,159.93,229Z"
                fill="#2f6840"
              />
              <path
                d="M158,227.08c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,158,227.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M154.92,235.72c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,154.92,235.72Z"
                fill="#2f6840"
              />
              <path
                d="M154.41,235.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,154.41,235.38Z"
                fill="#3ba525"
              />
              <path
                d="M155.16,235.35a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,155.16,235.35Z"
                fill="#2f6840"
              />
              <path
                d="M158.64,234.55c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,158.64,234.55Z"
                fill="#2f6840"
              />
              <path
                d="M157.27,237.76a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,157.27,237.76Z"
                fill="#2f6840"
              />
              <path
                d="M155.32,235.81c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,155.32,235.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M149.56,230.76c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.86,14.86,0,0,1,149.56,230.76Z"
                fill="#2f6840"
              />
              <path
                d="M149.06,230.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,149.06,230.42Z"
                fill="#3ba525"
              />
              <path
                d="M149.81,230.39a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,149.81,230.39Z"
                fill="#2f6840"
              />
              <path
                d="M153.29,229.6c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,153.29,229.6Z"
                fill="#2f6840"
              />
              <path
                d="M151.92,232.81a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,151.92,232.81Z"
                fill="#2f6840"
              />
              <path
                d="M150,230.85c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,150,230.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M141.22,227.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S149,228,148,227.87s-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,141.22,227.39Z"
                fill="#2f6840"
              />
              <path
                d="M140.72,227.05c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,140.72,227.05Z"
                fill="#3ba525"
              />
              <path
                d="M141.47,227a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,141.47,227Z"
                fill="#2f6840"
              />
              <path
                d="M145,226.23c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,145,226.23Z"
                fill="#2f6840"
              />
              <path
                d="M143.58,229.44a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,143.58,229.44Z"
                fill="#2f6840"
              />
              <path
                d="M141.62,227.48c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,141.62,227.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M155.93,242.88c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,155.93,242.88Z"
                fill="#2f6840"
              />
              <path
                d="M155.42,242.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,155.42,242.54Z"
                fill="#3ba525"
              />
              <path
                d="M156.17,242.51a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.23,2.23,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,156.17,242.51Z"
                fill="#2f6840"
              />
              <path
                d="M159.65,241.71c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,159.65,241.71Z"
                fill="#2f6840"
              />
              <path
                d="M158.28,244.92a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,158.28,244.92Z"
                fill="#2f6840"
              />
              <path
                d="M156.33,243c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,156.33,243Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M142.47,237.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,142.47,237.31Z"
                fill="#2f6840"
              />
              <path
                d="M142,237c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,142,237Z"
                fill="#3ba525"
              />
              <path
                d="M142.72,236.94a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,142.72,236.94Z"
                fill="#2f6840"
              />
              <path
                d="M146.19,236.15c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,146.19,236.15Z"
                fill="#2f6840"
              />
              <path
                d="M144.83,239.36a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,144.83,239.36Z"
                fill="#2f6840"
              />
              <path
                d="M142.87,237.4c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,142.87,237.4Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M125.25,207.41s-1.38,4.1-4,5.12-7-1.06-6.07,1.05-4.59,3.91-7.1,3.66-8.59-4.69-8.8-6.35S125.25,207.41,125.25,207.41Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M124.89,204.26l.36,3.15-4.15,3.87-6,.69-1.09,2.5s-3.85,2.51-6.9.79a22.46,22.46,0,0,1-5.65-5.11l-.37-3.15Z"
              fill="#ccae79"
            />
            <path
              d="M119.78,202.78l5.11,1.48-4.49,3.9-5.73.66-1.58,2.63s-5.41,2.31-6.33.73-5.67-5.18-5.67-5.18l4.22-2.55Z"
              fill="#ffedc8"
            />
            <polygon
              points="120.4 208.16 121.1 211.28 115.1 211.97 114.67 208.82 120.4 208.16"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M108.29,212.73s-.58,3,.35,3.06a13.87,13.87,0,0,1-7.18-5.64l-.37-3.15S107,212.9,108.29,212.73Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M112.1,211.83l-1.11.37s.68-.28.7,1.06A3.25,3.25,0,0,1,112.1,211.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M109.56,212.61c.12-.06-.22,0-1.39-.89a6.87,6.87,0,0,1-1.69-1.95s2.82,2.45,2.28,2.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M122.26,206.54a19.5,19.5,0,0,0,.26,2.28s-.11-1.73-.63-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M112.88,203.58l-2.28.26c-.16,0,1.79-.21,2.4.75l-.12-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M122.31,203.52l-1.26-.37s.73.34.47.46-1.26.71-1.71.54a1.81,1.81,0,0,0-1.14.19Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M66.05,202.62s1.86,3.54,4.38,4.1,6.25-2,5.7.08,4.76,2.9,7,2.3,7.17-5.54,7.12-7.08S66.05,202.62,66.05,202.62Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M65.93,199.69l.12,2.93,4.36,2.93,5.59-.24,1.36,2.12s3.88,1.73,6.42-.28a20.83,20.83,0,0,0,4.42-5.5l-.13-2.93Z"
              fill="#ccae79"
            />
            <path
              d="M70.38,197.59l-4.45,2.1,4.67,2.91,5.33-.23,1.83,2.17s5.27,1.32,5.89-.26,4.42-5.56,4.42-5.56L83.84,197Z"
              fill="#ffedc8"
            />
            <polygon
              points="70.6 202.6 70.42 205.55 76 205.31 75.93 202.37 70.6 202.6"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M82.33,205s1,2.65.13,2.85a12.84,12.84,0,0,0,5.74-6.21l-.13-2.93S83.56,205,82.33,205Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M78.72,204.74l1.06.18s-.66-.16-.48,1.07A2.89,2.89,0,0,0,78.72,204.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M81.15,205.08c-.12,0,.21,0,1.14-1a6.23,6.23,0,0,0,1.26-2s-2.21,2.66-1.65,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.66,201.39a17.43,17.43,0,0,1,.09,2.12s-.15-1.59.29-1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M76.8,197.31l2.12-.09c.15,0-1.67.07-2.08,1l0-.95"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.17,198.64l1.1-.52s-.62.41-.36.48,1.25.47,1.64.25a1.65,1.65,0,0,1,1.07,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M14.17,207.59l5.93,3.68a1.94,1.94,0,0,0,1.81.13L36.17,205a1.93,1.93,0,0,0,.47-3.22h0a1.91,1.91,0,0,0-1.52-.45L14.93,204A1.93,1.93,0,0,0,14.17,207.59Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="24.7 192.84 16.67 194.55 9.59 199.99 21.45 204.74 35.98 198.79 24.7 192.84"
              fill="#ffedc8"
            />
            <polygon
              points="9.59 199.99 9.59 204.74 20.97 209.62 36.3 203.4 35.98 198.79 21.45 204.74 9.59 199.99"
              fill="#ccae79"
            />
            <polygon
              points="21.45 204.74 20.97 209.62 36.3 203.4 35.98 198.79 21.45 204.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M13,201.34a2.16,2.16,0,0,1,0,2.45c.54-.77.66-2.18.91-2.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M18,203.35a6.74,6.74,0,0,0,3-3l-2.15,3.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M27.45,202.29a2.19,2.19,0,0,1,1.19,1.92L28.28,202Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M32.76,197.09c-.15-.08-3,.58-4.71,0a6.75,6.75,0,0,1-3.44.24s2.52-.24,3.44.62A20.67,20.67,0,0,1,32.76,197.09Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M28.91,219.21l4.85,3a1.62,1.62,0,0,0,1.48.1l11.65-5.21a1.58,1.58,0,0,0,.39-2.64h0a1.59,1.59,0,0,0-1.24-.37l-16.5,2.2A1.57,1.57,0,0,0,28.91,219.21Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="37.52 207.16 30.96 208.55 25.17 213 34.87 216.89 46.74 212.03 37.52 207.16"
              fill="#ffedc8"
            />
            <polygon
              points="25.17 213 25.17 216.89 34.48 220.88 47 215.79 46.74 212.03 34.87 216.89 25.17 213"
              fill="#ccae79"
            />
            <polygon
              points="34.87 216.89 34.48 220.88 47 215.79 46.74 212.03 34.87 216.89"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M27.94,214.11a1.77,1.77,0,0,1,0,2c.43-.63.54-1.78.74-1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M32,215.75a5.57,5.57,0,0,0,2.45-2.48L32.72,216Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M39.77,214.88a1.81,1.81,0,0,1,1,1.57l-.29-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M44.11,210.64c-.12-.07-2.45.47-3.85,0a5.55,5.55,0,0,1-2.81.19s2.06-.2,2.81.51A16.61,16.61,0,0,1,44.11,210.64Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M49.86,213.7l4.86,3a1.56,1.56,0,0,0,1.47.1l11.65-5.21a1.57,1.57,0,0,0,.39-2.63h0A1.55,1.55,0,0,0,67,208.6l-16.5,2.19A1.58,1.58,0,0,0,49.86,213.7Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="58.48 201.65 51.91 203.04 46.12 207.49 55.82 211.37 67.7 206.51 58.48 201.65"
              fill="#ffedc8"
            />
            <polygon
              points="46.12 207.49 46.12 211.37 55.43 215.36 67.95 210.28 67.7 206.51 55.82 211.37 46.12 207.49"
              fill="#ccae79"
            />
            <polygon
              points="55.82 211.37 55.43 215.36 67.95 210.28 67.7 206.51 55.82 211.37"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M48.89,208.6a1.73,1.73,0,0,1,0,2c.44-.62.54-1.78.74-1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M53,210.24a5.56,5.56,0,0,0,2.45-2.49l-1.76,2.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M60.72,209.36a1.79,1.79,0,0,1,1,1.58l-.29-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M65.06,205.12c-.12-.06-2.45.47-3.85,0a5.63,5.63,0,0,1-2.81.2s2.06-.2,2.81.5A16.61,16.61,0,0,1,65.06,205.12Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M66.84,218.81l2.7,1.68a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.93.93,0,0,0-.7-.21l-9.19,1.23A.87.87,0,0,0,66.84,218.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="71.63 212.1 67.97 212.88 64.75 215.36 70.15 217.52 76.77 214.81 71.63 212.1"
              fill="#ffedc8"
            />
            <polygon
              points="64.75 215.36 64.75 217.52 69.94 219.74 76.91 216.91 76.77 214.81 70.15 217.52 64.75 215.36"
              fill="#ccae79"
            />
            <polygon
              points="70.15 217.52 69.94 219.74 76.91 216.91 76.77 214.81 70.15 217.52"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M66.29,216a1,1,0,0,1,0,1.12c.25-.35.3-1,.42-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.57,216.89a3,3,0,0,0,1.36-1.39L69,217Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.88,216.4a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M75.3,214a6.61,6.61,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9,9,0,0,1,75.3,214Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M146.84,236.34l2.7,1.68a.88.88,0,0,0,.82,0l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.9.9,0,0,0-.7-.21l-9.19,1.22A.88.88,0,0,0,146.84,236.34Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="151.63 229.63 147.97 230.4 144.75 232.88 150.15 235.04 156.77 232.34 151.63 229.63"
              fill="#ffedc8"
            />
            <polygon
              points="144.75 232.88 144.75 235.04 149.93 237.27 156.91 234.44 156.77 232.34 150.15 235.04 144.75 232.88"
              fill="#ccae79"
            />
            <polygon
              points="150.15 235.04 149.93 237.27 156.91 234.44 156.77 232.34 150.15 235.04"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M146.29,233.5a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M148.57,234.41a3,3,0,0,0,1.36-1.38l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M152.88,233.93a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M155.3,231.56a6.08,6.08,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,155.3,231.56Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M151.53,227l2.7,1.67a.87.87,0,0,0,.83.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,151.53,227Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="156.33 220.31 152.67 221.09 149.45 223.57 154.85 225.73 161.46 223.02 156.33 220.31"
              fill="#ffedc8"
            />
            <polygon
              points="149.45 223.57 149.45 225.73 154.63 227.95 161.61 225.12 161.46 223.02 154.85 225.73 149.45 223.57"
              fill="#ccae79"
            />
            <polygon
              points="154.85 225.73 154.63 227.95 161.61 225.12 161.46 223.02 154.85 225.73"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M151,224.18a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M153.27,225.1a3.08,3.08,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M157.58,224.61a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M160,222.25a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.14-.11,1.56.28A9.54,9.54,0,0,1,160,222.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M249.27,238,253,240.3a1.21,1.21,0,0,0,1.14.07l9-4a1.22,1.22,0,0,0,.3-2h0a1.23,1.23,0,0,0-1-.29l-12.76,1.7A1.22,1.22,0,0,0,249.27,238Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="255.93 228.65 250.85 229.73 246.37 233.16 253.87 236.17 263.06 232.41 255.93 228.65"
              fill="#ffedc8"
            />
            <polygon
              points="246.37 233.16 246.37 236.17 253.57 239.25 263.26 235.32 263.06 232.41 253.87 236.17 246.37 233.16"
              fill="#ccae79"
            />
            <polygon
              points="253.87 236.17 253.57 239.25 263.26 235.32 263.06 232.41 253.87 236.17"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M248.52,234a1.38,1.38,0,0,1,0,1.55c.33-.49.41-1.38.57-1.32Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M251.68,235.29a4.29,4.29,0,0,0,1.89-1.92l-1.36,2.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M257.67,234.62a1.37,1.37,0,0,1,.74,1.21l-.22-1.43Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M261,231.34a9,9,0,0,1-3,0,4.26,4.26,0,0,1-2.17.15s1.59-.16,2.17.39A12.59,12.59,0,0,1,261,231.34Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M273.41,242.68l4.25,2.63a1.35,1.35,0,0,0,1.29.09l10.2-4.56a1.37,1.37,0,0,0,.34-2.3h0a1.38,1.38,0,0,0-1.08-.33L274,240.13A1.39,1.39,0,0,0,273.41,242.68Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="280.95 232.13 275.2 233.35 270.14 237.24 278.63 240.64 289.02 236.39 280.95 232.13"
              fill="#ffedc8"
            />
            <polygon
              points="270.14 237.24 270.14 240.64 278.29 244.13 289.25 239.69 289.02 236.39 278.63 240.64 270.14 237.24"
              fill="#ccae79"
            />
            <polygon
              points="278.63 240.64 278.29 244.13 289.25 239.69 289.02 236.39 278.63 240.64"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M272.56,238.21a1.53,1.53,0,0,1,0,1.75c.39-.55.47-1.56.65-1.49Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M276.14,239.65a4.83,4.83,0,0,0,2.14-2.18l-1.54,2.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M282.92,238.88a1.58,1.58,0,0,1,.85,1.38l-.26-1.62Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M286.72,235.17a10.23,10.23,0,0,1-3.37,0,4.86,4.86,0,0,1-2.46.17s1.8-.17,2.46.44A14.83,14.83,0,0,1,286.72,235.17Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M301.73,273.37l3.94,2.45a1.3,1.3,0,0,0,1.21.09l9.48-4.24a1.28,1.28,0,0,0,.31-2.14h0a1.24,1.24,0,0,0-1-.31L302.23,271A1.28,1.28,0,0,0,301.73,273.37Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="308.74 263.57 303.39 264.7 298.68 268.32 306.57 271.48 316.24 267.52 308.74 263.57"
              fill="#ffedc8"
            />
            <polygon
              points="298.68 268.32 298.68 271.48 306.25 274.73 316.44 270.59 316.24 267.52 306.57 271.48 298.68 268.32"
              fill="#ccae79"
            />
            <polygon
              points="306.57 271.48 306.25 274.73 316.44 270.59 316.24 267.52 306.57 271.48"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M300.93,269.22a1.43,1.43,0,0,1,0,1.63c.36-.51.44-1.45.61-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M304.26,270.56a4.54,4.54,0,0,0,2-2l-1.43,2.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M310.56,269.85a1.45,1.45,0,0,1,.79,1.28l-.24-1.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M314.09,266.39a9.08,9.08,0,0,1-3.13,0,4.53,4.53,0,0,1-2.29.16s1.68-.16,2.29.41A13.79,13.79,0,0,1,314.09,266.39Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M306.2,289.92l4.52,2.81a1.45,1.45,0,0,0,1.37.09L323,288a1.47,1.47,0,0,0,.36-2.45h0a1.48,1.48,0,0,0-1.16-.35l-15.37,2.05A1.47,1.47,0,0,0,306.2,289.92Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="314.22 278.7 308.1 280 302.71 284.14 311.75 287.76 322.81 283.23 314.22 278.7"
              fill="#ffedc8"
            />
            <polygon
              points="302.71 284.14 302.71 287.76 311.38 291.47 323.05 286.74 322.81 283.23 311.75 287.76 302.71 284.14"
              fill="#ccae79"
            />
            <polygon
              points="311.75 287.76 311.38 291.47 323.05 286.74 322.81 283.23 311.75 287.76"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M305.29,285.17a1.62,1.62,0,0,1,0,1.86c.41-.58.5-1.66.69-1.58Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M309.1,286.7a5.13,5.13,0,0,0,2.28-2.32L309.74,287Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M316.31,285.89a1.67,1.67,0,0,1,.9,1.46l-.26-1.72Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M320.36,281.93c-.12-.06-2.29.44-3.59,0a5.23,5.23,0,0,1-2.62.19s1.92-.19,2.62.47A15.38,15.38,0,0,1,320.36,281.93Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M326.16,296.43l4.42,2.74a1.44,1.44,0,0,0,1.35.09l10.6-4.74a1.44,1.44,0,0,0,.36-2.4h0a1.45,1.45,0,0,0-1.13-.34l-15,2A1.44,1.44,0,0,0,326.16,296.43Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="334.01 285.45 328.02 286.72 322.75 290.77 331.58 294.31 342.4 289.88 334.01 285.45"
              fill="#ffedc8"
            />
            <polygon
              points="322.75 290.77 322.75 294.31 331.23 297.94 342.63 293.31 342.4 289.88 331.58 294.31 322.75 290.77"
              fill="#ccae79"
            />
            <polygon
              points="331.58 294.31 331.23 297.94 342.63 293.31 342.4 289.88 331.58 294.31"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M325.28,291.78a1.6,1.6,0,0,1,0,1.82c.39-.57.49-1.62.67-1.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M329,293.28a5,5,0,0,0,2.23-2.27l-1.6,2.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M336.05,292.48a1.63,1.63,0,0,1,.88,1.43l-.26-1.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M340,288.62c-.11-.06-2.23.43-3.51,0a5.06,5.06,0,0,1-2.56.18s1.88-.18,2.56.46A14.93,14.93,0,0,1,340,288.62Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M338.82,304.22l2.71,1.68a.85.85,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.91.91,0,0,0-.69-.21l-9.19,1.23A.87.87,0,0,0,338.82,304.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="343.62 297.51 339.96 298.29 336.74 300.76 342.14 302.93 348.75 300.22 343.62 297.51"
              fill="#ffedc8"
            />
            <polygon
              points="336.74 300.76 336.74 302.93 341.92 305.15 348.9 302.32 348.75 300.22 342.14 302.93 336.74 300.76"
              fill="#ccae79"
            />
            <polygon
              points="342.14 302.93 341.92 305.15 348.9 302.32 348.75 300.22 342.14 302.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M338.28,301.38a1,1,0,0,1,0,1.12c.25-.35.3-1,.41-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M340.56,302.3a3.08,3.08,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M344.87,301.81a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M347.29,299.45a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9,9,0,0,1,347.29,299.45Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M132.4,231.29l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,132.4,231.29Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="137.19 224.57 133.53 225.35 130.31 227.83 135.71 229.99 142.33 227.28 137.19 224.57"
              fill="#ffedc8"
            />
            <polygon
              points="130.31 227.83 130.31 229.99 135.49 232.21 142.47 229.38 142.33 227.28 135.71 229.99 130.31 227.83"
              fill="#ccae79"
            />
            <polygon
              points="135.71 229.99 135.49 232.21 142.47 229.38 142.33 227.28 135.71 229.99"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M131.85,228.45a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M134.13,229.36a3,3,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M138.44,228.87a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M140.86,226.51a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,140.86,226.51Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M85.81,217.91l4,2.49a1.29,1.29,0,0,0,1.22.08l9.61-4.3A1.3,1.3,0,0,0,101,214h0a1.3,1.3,0,0,0-1-.3l-13.61,1.81A1.3,1.3,0,0,0,85.81,217.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="92.92 207.97 87.5 209.12 82.72 212.79 90.72 216 100.52 211.98 92.92 207.97"
              fill="#ffedc8"
            />
            <polygon
              points="82.72 212.79 82.72 216 90.4 219.29 100.73 215.09 100.52 211.98 90.72 216 82.72 212.79"
              fill="#ccae79"
            />
            <polygon
              points="90.72 216 90.4 219.29 100.73 215.09 100.52 211.98 90.72 216"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M85,213.7a1.47,1.47,0,0,1,0,1.65c.36-.52.44-1.47.61-1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M88.38,215.06a4.56,4.56,0,0,0,2-2.05L89,215.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M94.77,214.34a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M98.35,210.84a9.65,9.65,0,0,1-3.18,0,4.65,4.65,0,0,1-2.32.16s1.7-.16,2.32.42A13.87,13.87,0,0,1,98.35,210.84Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M311.33,132.13c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,311.33,132.13Z"
                fill="#2f6840"
              />
              <path
                d="M310.82,131.79c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45S312,131,312,131s1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,310.82,131.79Z"
                fill="#3ba525"
              />
              <path
                d="M311.58,131.76a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,311.58,131.76Z"
                fill="#2f6840"
              />
              <path
                d="M315.05,131c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,315.05,131Z"
                fill="#2f6840"
              />
              <path
                d="M313.69,134.18a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,313.69,134.18Z"
                fill="#2f6840"
              />
              <path
                d="M311.73,132.22c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,311.73,132.22Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M308.67,140.86c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,308.67,140.86Z"
                fill="#2f6840"
              />
              <path
                d="M308.16,140.52c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,308.16,140.52Z"
                fill="#3ba525"
              />
              <path
                d="M308.92,140.49a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,308.92,140.49Z"
                fill="#2f6840"
              />
              <path
                d="M312.4,139.69c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,312.4,139.69Z"
                fill="#2f6840"
              />
              <path
                d="M311,142.9a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,311,142.9Z"
                fill="#2f6840"
              />
              <path
                d="M309.07,141c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,309.07,141Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M303.32,135.9c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,303.32,135.9Z"
                fill="#2f6840"
              />
              <path
                d="M302.81,135.56c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,302.81,135.56Z"
                fill="#3ba525"
              />
              <path
                d="M303.57,135.53a2.15,2.15,0,0,0-.8-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,303.57,135.53Z"
                fill="#2f6840"
              />
              <path
                d="M307,134.74c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,307,134.74Z"
                fill="#2f6840"
              />
              <path
                d="M305.67,138a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,305.67,138Z"
                fill="#2f6840"
              />
              <path
                d="M303.72,136c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,303.72,136Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M295,132.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,295,132.53Z"
                fill="#2f6840"
              />
              <path
                d="M294.47,132.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,294.47,132.19Z"
                fill="#3ba525"
              />
              <path
                d="M295.22,132.16a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,295.22,132.16Z"
                fill="#2f6840"
              />
              <path
                d="M298.7,131.37c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,298.7,131.37Z"
                fill="#2f6840"
              />
              <path
                d="M297.33,134.58a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,297.33,134.58Z"
                fill="#2f6840"
              />
              <path
                d="M295.37,132.62c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,295.37,132.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M309.68,148c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,309.68,148Z"
                fill="#2f6840"
              />
              <path
                d="M309.17,147.68c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,309.17,147.68Z"
                fill="#3ba525"
              />
              <path
                d="M309.93,147.65a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,309.93,147.65Z"
                fill="#2f6840"
              />
              <path
                d="M313.4,146.85c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,313.4,146.85Z"
                fill="#2f6840"
              />
              <path
                d="M312,150.06a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,312,150.06Z"
                fill="#2f6840"
              />
              <path
                d="M310.08,148.11c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,310.08,148.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M296.22,142.45c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S304,143,303,142.93s-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,296.22,142.45Z"
                fill="#2f6840"
              />
              <path
                d="M295.72,142.11c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,295.72,142.11Z"
                fill="#3ba525"
              />
              <path
                d="M296.47,142.08a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,296.47,142.08Z"
                fill="#2f6840"
              />
              <path
                d="M300,141.29c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,300,141.29Z"
                fill="#2f6840"
              />
              <path
                d="M298.58,144.5a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,298.58,144.5Z"
                fill="#2f6840"
              />
              <path
                d="M296.62,142.54c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,296.62,142.54Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M283,129.68c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,283,129.68Z"
                fill="#2f6840"
              />
              <path
                d="M282.45,129.34c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,282.45,129.34Z"
                fill="#3ba525"
              />
              <path
                d="M283.2,129.31a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,283.2,129.31Z"
                fill="#2f6840"
              />
              <path
                d="M286.68,128.51c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,286.68,128.51Z"
                fill="#2f6840"
              />
              <path
                d="M285.31,131.72a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,285.31,131.72Z"
                fill="#2f6840"
              />
              <path
                d="M283.35,129.77c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,283.35,129.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M280.29,138.41c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,280.29,138.41Z"
                fill="#2f6840"
              />
              <path
                d="M279.79,138.06c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,279.79,138.06Z"
                fill="#3ba525"
              />
              <path
                d="M280.54,138a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,280.54,138Z"
                fill="#2f6840"
              />
              <path
                d="M284,137.24c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,284,137.24Z"
                fill="#2f6840"
              />
              <path
                d="M282.65,140.45a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,282.65,140.45Z"
                fill="#2f6840"
              />
              <path
                d="M280.69,138.5a7,7,0,0,0-.69.15,4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,280.69,138.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M274.94,133.45c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44S277,134,277,134s6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,274.94,133.45Z"
                fill="#2f6840"
              />
              <path
                d="M274.44,133.11c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71S275,134,275,134s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,274.44,133.11Z"
                fill="#3ba525"
              />
              <path
                d="M275.19,133.08a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,275.19,133.08Z"
                fill="#2f6840"
              />
              <path
                d="M278.67,132.28c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,278.67,132.28Z"
                fill="#2f6840"
              />
              <path
                d="M277.3,135.49a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,277.3,135.49Z"
                fill="#2f6840"
              />
              <path
                d="M275.34,133.54a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,275.34,133.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M266.6,130.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,266.6,130.08Z"
                fill="#2f6840"
              />
              <path
                d="M266.09,129.73c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,266.09,129.73Z"
                fill="#3ba525"
              />
              <path
                d="M266.85,129.71a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,266.85,129.71Z"
                fill="#2f6840"
              />
              <path
                d="M270.32,128.91c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,270.32,128.91Z"
                fill="#2f6840"
              />
              <path
                d="M269,132.12a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,269,132.12Z"
                fill="#2f6840"
              />
              <path
                d="M267,130.17a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,267,130.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M281.3,145.57c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,281.3,145.57Z"
                fill="#2f6840"
              />
              <path
                d="M280.8,145.22c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,280.8,145.22Z"
                fill="#3ba525"
              />
              <path
                d="M281.55,145.2a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74A2.34,2.34,0,0,1,281,144a2,2,0,0,1,.47.53A1,1,0,0,1,281.55,145.2Z"
                fill="#2f6840"
              />
              <path
                d="M285,144.4c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,285,144.4Z"
                fill="#2f6840"
              />
              <path
                d="M283.66,147.61a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,283.66,147.61Z"
                fill="#2f6840"
              />
              <path
                d="M281.7,145.65c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,281.7,145.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M267.85,140c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,267.85,140Z"
                fill="#2f6840"
              />
              <path
                d="M267.34,139.65c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,267.34,139.65Z"
                fill="#3ba525"
              />
              <path
                d="M268.09,139.63a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,268.09,139.63Z"
                fill="#2f6840"
              />
              <path
                d="M271.57,138.83c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,271.57,138.83Z"
                fill="#2f6840"
              />
              <path
                d="M270.2,142a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,270.2,142Z"
                fill="#2f6840"
              />
              <path
                d="M268.25,140.09a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,268.25,140.09Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M254.48,128.59c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,254.48,128.59Z"
                fill="#2f6840"
              />
              <path
                d="M254,128.25c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,254,128.25Z"
                fill="#3ba525"
              />
              <path
                d="M254.73,128.22a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,254.73,128.22Z"
                fill="#2f6840"
              />
              <path
                d="M258.2,127.42c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,258.2,127.42Z"
                fill="#2f6840"
              />
              <path
                d="M256.84,130.63a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,256.84,130.63Z"
                fill="#2f6840"
              />
              <path
                d="M254.88,128.68c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,254.88,128.68Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M251.82,137.32c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,251.82,137.32Z"
                fill="#2f6840"
              />
              <path
                d="M251.31,137c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,251.31,137Z"
                fill="#3ba525"
              />
              <path
                d="M252.07,137a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,252.07,137Z"
                fill="#2f6840"
              />
              <path
                d="M255.55,136.15c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.1,2.1,0,0,1,255.55,136.15Z"
                fill="#2f6840"
              />
              <path
                d="M254.18,139.36a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,254.18,139.36Z"
                fill="#2f6840"
              />
              <path
                d="M252.22,137.41a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,252.22,137.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M246.47,132.36c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,246.47,132.36Z"
                fill="#2f6840"
              />
              <path
                d="M246,132c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,246,132Z"
                fill="#3ba525"
              />
              <path
                d="M246.72,132a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,246.72,132Z"
                fill="#2f6840"
              />
              <path
                d="M250.19,131.19c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,250.19,131.19Z"
                fill="#2f6840"
              />
              <path
                d="M248.82,134.4a1.94,1.94,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,248.82,134.4Z"
                fill="#2f6840"
              />
              <path
                d="M246.87,132.45a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,246.87,132.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M238.13,129c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,238.13,129Z"
                fill="#2f6840"
              />
              <path
                d="M237.62,128.64c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,237.62,128.64Z"
                fill="#3ba525"
              />
              <path
                d="M238.37,128.62a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,238.37,128.62Z"
                fill="#2f6840"
              />
              <path
                d="M241.85,127.82c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,241.85,127.82Z"
                fill="#2f6840"
              />
              <path
                d="M240.48,131a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,240.48,131Z"
                fill="#2f6840"
              />
              <path
                d="M238.52,129.08a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,238.52,129.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M252.83,144.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,252.83,144.48Z"
                fill="#2f6840"
              />
              <path
                d="M252.32,144.13c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,252.32,144.13Z"
                fill="#3ba525"
              />
              <path
                d="M253.08,144.11a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,253.08,144.11Z"
                fill="#2f6840"
              />
              <path
                d="M256.55,143.31c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,256.55,143.31Z"
                fill="#2f6840"
              />
              <path
                d="M255.19,146.52a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,255.19,146.52Z"
                fill="#2f6840"
              />
              <path
                d="M253.23,144.57a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,253.23,144.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M239.37,138.91c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,239.37,138.91Z"
                fill="#2f6840"
              />
              <path
                d="M238.87,138.56c4.42-.25-4.33.46-4.35-.61s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,238.87,138.56Z"
                fill="#3ba525"
              />
              <path
                d="M239.62,138.54a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,239.62,138.54Z"
                fill="#2f6840"
              />
              <path
                d="M243.1,137.74c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,243.1,137.74Z"
                fill="#2f6840"
              />
              <path
                d="M241.73,141a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,241.73,141Z"
                fill="#2f6840"
              />
              <path
                d="M239.77,139c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,239.77,139Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M226.08,130.39c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,226.08,130.39Z"
                fill="#2f6840"
              />
              <path
                d="M225.57,130.05c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,225.57,130.05Z"
                fill="#3ba525"
              />
              <path
                d="M226.33,130a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,226.33,130Z"
                fill="#2f6840"
              />
              <path
                d="M229.8,129.22c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,229.8,129.22Z"
                fill="#2f6840"
              />
              <path
                d="M228.43,132.43a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,228.43,132.43Z"
                fill="#2f6840"
              />
              <path
                d="M226.48,130.48c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,226.48,130.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M223.42,139.12c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S224,140,224,140s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,223.42,139.12Z"
                fill="#2f6840"
              />
              <path
                d="M222.91,138.78c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,222.91,138.78Z"
                fill="#3ba525"
              />
              <path
                d="M223.67,138.75a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,223.67,138.75Z"
                fill="#2f6840"
              />
              <path
                d="M227.14,138c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,227.14,138Z"
                fill="#2f6840"
              />
              <path
                d="M225.78,141.16a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,225.78,141.16Z"
                fill="#2f6840"
              />
              <path
                d="M223.82,139.21a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,223.82,139.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M218.07,134.16c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,218.07,134.16Z"
                fill="#2f6840"
              />
              <path
                d="M217.56,133.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,217.56,133.82Z"
                fill="#3ba525"
              />
              <path
                d="M218.31,133.79a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,218.31,133.79Z"
                fill="#2f6840"
              />
              <path
                d="M221.79,133c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,221.79,133Z"
                fill="#2f6840"
              />
              <path
                d="M220.42,136.2a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8A2.15,2.15,0,0,1,220,135a1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,220.42,136.2Z"
                fill="#2f6840"
              />
              <path
                d="M218.47,134.25c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,218.47,134.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M209.72,130.79c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,209.72,130.79Z"
                fill="#2f6840"
              />
              <path
                d="M209.22,130.45c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16S217,131,216,130.92s-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,209.22,130.45Z"
                fill="#3ba525"
              />
              <path
                d="M210,130.42a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,210,130.42Z"
                fill="#2f6840"
              />
              <path
                d="M213.45,129.62c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,213.45,129.62Z"
                fill="#2f6840"
              />
              <path
                d="M212.08,132.83a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,212.08,132.83Z"
                fill="#2f6840"
              />
              <path
                d="M210.12,130.88c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,210.12,130.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M224.43,146.28c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,224.43,146.28Z"
                fill="#2f6840"
              />
              <path
                d="M223.92,145.94c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,223.92,145.94Z"
                fill="#3ba525"
              />
              <path
                d="M224.68,145.91a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,224.68,145.91Z"
                fill="#2f6840"
              />
              <path
                d="M228.15,145.11c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,228.15,145.11Z"
                fill="#2f6840"
              />
              <path
                d="M226.79,148.32a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,226.79,148.32Z"
                fill="#2f6840"
              />
              <path
                d="M224.83,146.37a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,224.83,146.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M211,140.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,211,140.71Z"
                fill="#2f6840"
              />
              <path
                d="M210.47,140.37c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,210.47,140.37Z"
                fill="#3ba525"
              />
              <path
                d="M211.22,140.34a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,211.22,140.34Z"
                fill="#2f6840"
              />
              <path
                d="M214.7,139.54c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,214.7,139.54Z"
                fill="#2f6840"
              />
              <path
                d="M213.33,142.75a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,213.33,142.75Z"
                fill="#2f6840"
              />
              <path
                d="M211.37,140.8c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,211.37,140.8Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M198,134.78c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,198,134.78Z"
                fill="#2f6840"
              />
              <path
                d="M197.54,134.44c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,197.54,134.44Z"
                fill="#3ba525"
              />
              <path
                d="M198.29,134.41a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,198.29,134.41Z"
                fill="#2f6840"
              />
              <path
                d="M201.77,133.61c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,201.77,133.61Z"
                fill="#2f6840"
              />
              <path
                d="M200.4,136.82a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,200.4,136.82Z"
                fill="#2f6840"
              />
              <path
                d="M198.44,134.87c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,198.44,134.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M195.38,143.51c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,195.38,143.51Z"
                fill="#2f6840"
              />
              <path
                d="M194.88,143.16c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,194.88,143.16Z"
                fill="#3ba525"
              />
              <path
                d="M195.63,143.14a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,195.63,143.14Z"
                fill="#2f6840"
              />
              <path
                d="M199.11,142.34c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,199.11,142.34Z"
                fill="#2f6840"
              />
              <path
                d="M197.74,145.55a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,197.74,145.55Z"
                fill="#2f6840"
              />
              <path
                d="M195.78,143.6c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,195.78,143.6Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M190,138.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,190,138.55Z"
                fill="#2f6840"
              />
              <path
                d="M189.53,138.21c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,189.53,138.21Z"
                fill="#3ba525"
              />
              <path
                d="M190.28,138.18a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,190.28,138.18Z"
                fill="#2f6840"
              />
              <path
                d="M193.76,137.38c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,193.76,137.38Z"
                fill="#2f6840"
              />
              <path
                d="M192.39,140.59a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,192.39,140.59Z"
                fill="#2f6840"
              />
              <path
                d="M190.43,138.64c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,190.43,138.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M181.69,135.18c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,181.69,135.18Z"
                fill="#2f6840"
              />
              <path
                d="M181.18,134.84c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,181.18,134.84Z"
                fill="#3ba525"
              />
              <path
                d="M181.94,134.81a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,181.94,134.81Z"
                fill="#2f6840"
              />
              <path
                d="M185.41,134c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,185.41,134Z"
                fill="#2f6840"
              />
              <path
                d="M184.05,137.22a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,184.05,137.22Z"
                fill="#2f6840"
              />
              <path
                d="M182.09,135.27a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,182.09,135.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M196.39,150.67c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,196.39,150.67Z"
                fill="#2f6840"
              />
              <path
                d="M195.89,150.32c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,195.89,150.32Z"
                fill="#3ba525"
              />
              <path
                d="M196.64,150.3a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,196.64,150.3Z"
                fill="#2f6840"
              />
              <path
                d="M200.12,149.5c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,200.12,149.5Z"
                fill="#2f6840"
              />
              <path
                d="M198.75,152.71a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,198.75,152.71Z"
                fill="#2f6840"
              />
              <path
                d="M196.79,150.76c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,196.79,150.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M182.94,145.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,182.94,145.1Z"
                fill="#2f6840"
              />
              <path
                d="M182.43,144.76c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,182.43,144.76Z"
                fill="#3ba525"
              />
              <path
                d="M183.18,144.73a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,183.18,144.73Z"
                fill="#2f6840"
              />
              <path
                d="M186.66,143.93c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,186.66,143.93Z"
                fill="#2f6840"
              />
              <path
                d="M185.29,147.14a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,185.29,147.14Z"
                fill="#2f6840"
              />
              <path
                d="M183.34,145.19a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,183.34,145.19Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M170.66,142.64c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,170.66,142.64Z"
                fill="#2f6840"
              />
              <path
                d="M170.15,142.3c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,170.15,142.3Z"
                fill="#3ba525"
              />
              <path
                d="M170.9,142.27a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,170.9,142.27Z"
                fill="#2f6840"
              />
              <path
                d="M174.38,141.48c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,174.38,141.48Z"
                fill="#2f6840"
              />
              <path
                d="M173,144.69a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,2,2,0,0,1,.4.57A1,1,0,0,1,173,144.69Z"
                fill="#2f6840"
              />
              <path
                d="M171.05,142.73c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,171.05,142.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M168,151.37c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,168,151.37Z"
                fill="#2f6840"
              />
              <path
                d="M167.49,151c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72S168,151.9,168,151.9s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,167.49,151Z"
                fill="#3ba525"
              />
              <path
                d="M168.24,151a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,168.24,151Z"
                fill="#2f6840"
              />
              <path
                d="M171.72,150.2c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18A11.31,11.31,0,0,0,169,151a2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,171.72,150.2Z"
                fill="#2f6840"
              />
              <path
                d="M170.35,153.41a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,170.35,153.41Z"
                fill="#2f6840"
              />
              <path
                d="M168.39,151.46c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,168.39,151.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M162.64,146.41c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,162.64,146.41Z"
                fill="#2f6840"
              />
              <path
                d="M162.14,146.07c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,162.14,146.07Z"
                fill="#3ba525"
              />
              <path
                d="M162.89,146a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,162.89,146Z"
                fill="#2f6840"
              />
              <path
                d="M166.37,145.25c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,166.37,145.25Z"
                fill="#2f6840"
              />
              <path
                d="M165,148.46a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,165,148.46Z"
                fill="#2f6840"
              />
              <path
                d="M163,146.5c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,163,146.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M154.3,143c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,154.3,143Z"
                fill="#2f6840"
              />
              <path
                d="M153.8,142.7c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,153.8,142.7Z"
                fill="#3ba525"
              />
              <path
                d="M154.55,142.67a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,154.55,142.67Z"
                fill="#2f6840"
              />
              <path
                d="M158,141.87c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,158,141.87Z"
                fill="#2f6840"
              />
              <path
                d="M156.66,145.08a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,156.66,145.08Z"
                fill="#2f6840"
              />
              <path
                d="M154.7,143.13c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,154.7,143.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M169,158.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,169,158.53Z"
                fill="#2f6840"
              />
              <path
                d="M168.5,158.19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,168.5,158.19Z"
                fill="#3ba525"
              />
              <path
                d="M169.25,158.16a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,169.25,158.16Z"
                fill="#2f6840"
              />
              <path
                d="M172.73,157.36c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,172.73,157.36Z"
                fill="#2f6840"
              />
              <path
                d="M171.36,160.57a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,171.36,160.57Z"
                fill="#2f6840"
              />
              <path
                d="M169.4,158.62c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,169.4,158.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M155.55,153c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,155.55,153Z"
                fill="#2f6840"
              />
              <path
                d="M155,152.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,155,152.62Z"
                fill="#3ba525"
              />
              <path
                d="M155.8,152.59a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,155.8,152.59Z"
                fill="#2f6840"
              />
              <path
                d="M159.27,151.79c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,159.27,151.79Z"
                fill="#2f6840"
              />
              <path
                d="M157.91,155a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,157.91,155Z"
                fill="#2f6840"
              />
              <path
                d="M156,153.05c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,156,153.05Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M144.37,153.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,144.37,153.6Z"
                fill="#2f6840"
              />
              <path
                d="M143.87,153.26c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,143.87,153.26Z"
                fill="#3ba525"
              />
              <path
                d="M144.62,153.23a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74A2.28,2.28,0,0,1,144,152a1.85,1.85,0,0,1,.47.53A1,1,0,0,1,144.62,153.23Z"
                fill="#2f6840"
              />
              <path
                d="M148.1,152.43c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,148.1,152.43Z"
                fill="#2f6840"
              />
              <path
                d="M146.73,155.64a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,146.73,155.64Z"
                fill="#2f6840"
              />
              <path
                d="M144.77,153.69c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,144.77,153.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M141.71,162.33c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,141.71,162.33Z"
                fill="#2f6840"
              />
              <path
                d="M141.21,162c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,141.21,162Z"
                fill="#3ba525"
              />
              <path
                d="M142,162a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,142,162Z"
                fill="#2f6840"
              />
              <path
                d="M145.44,161.16c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,145.44,161.16Z"
                fill="#2f6840"
              />
              <path
                d="M144.07,164.37a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,144.07,164.37Z"
                fill="#2f6840"
              />
              <path
                d="M142.11,162.42c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,142.11,162.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M136.36,157.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,136.36,157.37Z"
                fill="#2f6840"
              />
              <path
                d="M135.86,157c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,135.86,157Z"
                fill="#3ba525"
              />
              <path
                d="M136.61,157a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,136.61,157Z"
                fill="#2f6840"
              />
              <path
                d="M140.09,156.2c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,140.09,156.2Z"
                fill="#2f6840"
              />
              <path
                d="M138.72,159.41a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,138.72,159.41Z"
                fill="#2f6840"
              />
              <path
                d="M136.76,157.46c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,136.76,157.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M128,154c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,128,154Z"
                fill="#2f6840"
              />
              <path
                d="M127.51,153.66c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,127.51,153.66Z"
                fill="#3ba525"
              />
              <path
                d="M128.27,153.63a2.24,2.24,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,128.27,153.63Z"
                fill="#2f6840"
              />
              <path
                d="M131.74,152.83c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,131.74,152.83Z"
                fill="#2f6840"
              />
              <path
                d="M130.38,156a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,130.38,156Z"
                fill="#2f6840"
              />
              <path
                d="M128.42,154.09c-.25.06-.48.08-.7.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,128.42,154.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M142.72,169.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,142.72,169.49Z"
                fill="#2f6840"
              />
              <path
                d="M142.22,169.15c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.77,14.77,0,0,1,142.22,169.15Z"
                fill="#3ba525"
              />
              <path
                d="M143,169.12a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,143,169.12Z"
                fill="#2f6840"
              />
              <path
                d="M146.45,168.32c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,146.45,168.32Z"
                fill="#2f6840"
              />
              <path
                d="M145.08,171.53a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,145.08,171.53Z"
                fill="#2f6840"
              />
              <path
                d="M143.12,169.58c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,143.12,169.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M129.27,163.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,129.27,163.92Z"
                fill="#2f6840"
              />
              <path
                d="M128.76,163.58c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,128.76,163.58Z"
                fill="#3ba525"
              />
              <path
                d="M129.51,163.55a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,129.51,163.55Z"
                fill="#2f6840"
              />
              <path
                d="M133,162.75c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,133,162.75Z"
                fill="#2f6840"
              />
              <path
                d="M131.62,166a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,131.62,166Z"
                fill="#2f6840"
              />
              <path
                d="M129.67,164c-.25.06-.48.08-.7.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,129.67,164Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M116.55,159.75c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,116.55,159.75Z"
                fill="#2f6840"
              />
              <path
                d="M116.05,159.41c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,116.05,159.41Z"
                fill="#3ba525"
              />
              <path
                d="M116.8,159.38a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,116.8,159.38Z"
                fill="#2f6840"
              />
              <path
                d="M120.28,158.59c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,120.28,158.59Z"
                fill="#2f6840"
              />
              <path
                d="M118.91,161.8a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,118.91,161.8Z"
                fill="#2f6840"
              />
              <path
                d="M117,159.84c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,117,159.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M113.89,168.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,113.89,168.48Z"
                fill="#2f6840"
              />
              <path
                d="M113.39,168.14c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,113.39,168.14Z"
                fill="#3ba525"
              />
              <path
                d="M114.14,168.11a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,114.14,168.11Z"
                fill="#2f6840"
              />
              <path
                d="M117.62,167.31c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,117.62,167.31Z"
                fill="#2f6840"
              />
              <path
                d="M116.25,170.52a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,116.25,170.52Z"
                fill="#2f6840"
              />
              <path
                d="M114.29,168.57c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,114.29,168.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M108.54,163.52c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,108.54,163.52Z"
                fill="#2f6840"
              />
              <path
                d="M108,163.18c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,108,163.18Z"
                fill="#3ba525"
              />
              <path
                d="M108.79,163.15a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,108.79,163.15Z"
                fill="#2f6840"
              />
              <path
                d="M112.26,162.36c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,112.26,162.36Z"
                fill="#2f6840"
              />
              <path
                d="M110.9,165.57a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,110.9,165.57Z"
                fill="#2f6840"
              />
              <path
                d="M108.94,163.61c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,108.94,163.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M100.2,160.15c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,100.2,160.15Z"
                fill="#2f6840"
              />
              <path
                d="M99.69,159.81c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55S95,161,95.14,160.87A14.65,14.65,0,0,1,99.69,159.81Z"
                fill="#3ba525"
              />
              <path
                d="M100.44,159.78a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,100.44,159.78Z"
                fill="#2f6840"
              />
              <path
                d="M103.92,159c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,103.92,159Z"
                fill="#2f6840"
              />
              <path
                d="M102.55,162.19a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,102.55,162.19Z"
                fill="#2f6840"
              />
              <path
                d="M100.6,160.24c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,100.6,160.24Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M114.9,175.64c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.08-2.37A14.65,14.65,0,0,1,114.9,175.64Z"
                fill="#2f6840"
              />
              <path
                d="M114.4,175.3c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,114.4,175.3Z"
                fill="#3ba525"
              />
              <path
                d="M115.15,175.27a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,115.15,175.27Z"
                fill="#2f6840"
              />
              <path
                d="M118.63,174.47c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,118.63,174.47Z"
                fill="#2f6840"
              />
              <path
                d="M117.26,177.68a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,117.26,177.68Z"
                fill="#2f6840"
              />
              <path
                d="M115.3,175.73c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,115.3,175.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M101.45,170.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71S102,171,102,171s-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,101.45,170.07Z"
                fill="#2f6840"
              />
              <path
                d="M100.94,169.73c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,100.94,169.73Z"
                fill="#3ba525"
              />
              <path
                d="M101.69,169.7a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,101.69,169.7Z"
                fill="#2f6840"
              />
              <path
                d="M105.17,168.9c-.26,0-.49,0-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,105.17,168.9Z"
                fill="#2f6840"
              />
              <path
                d="M103.8,172.11a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,103.8,172.11Z"
                fill="#2f6840"
              />
              <path
                d="M101.84,170.16c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,101.84,170.16Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M88.09,158.35c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,88.09,158.35Z"
                fill="#2f6840"
              />
              <path
                d="M87.59,158c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S90,154.42,91.71,155s3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,87.59,158Z"
                fill="#3ba525"
              />
              <path
                d="M88.34,158a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,88.34,158Z"
                fill="#2f6840"
              />
              <path
                d="M91.82,157.19c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,91.82,157.19Z"
                fill="#2f6840"
              />
              <path
                d="M90.45,160.4a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,90.45,160.4Z"
                fill="#2f6840"
              />
              <path
                d="M88.49,158.44c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,88.49,158.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M85.43,167.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71S86,168,86,168s-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,85.43,167.08Z"
                fill="#2f6840"
              />
              <path
                d="M84.93,166.74c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,84.93,166.74Z"
                fill="#3ba525"
              />
              <path
                d="M85.68,166.71a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,85.68,166.71Z"
                fill="#2f6840"
              />
              <path
                d="M89.16,165.92c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,89.16,165.92Z"
                fill="#2f6840"
              />
              <path
                d="M87.79,169.13a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,87.79,169.13Z"
                fill="#2f6840"
              />
              <path
                d="M85.83,167.17c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,85.83,167.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M80.08,162.13c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,80.08,162.13Z"
                fill="#2f6840"
              />
              <path
                d="M79.57,161.78c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,79.57,161.78Z"
                fill="#3ba525"
              />
              <path
                d="M80.33,161.75a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,80.33,161.75Z"
                fill="#2f6840"
              />
              <path
                d="M83.81,161c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.1,2.1,0,0,1,83.81,161Z"
                fill="#2f6840"
              />
              <path
                d="M82.44,164.17a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,82.44,164.17Z"
                fill="#2f6840"
              />
              <path
                d="M80.48,162.21c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,80.48,162.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M71.74,158.75c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,71.74,158.75Z"
                fill="#2f6840"
              />
              <path
                d="M71.23,158.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15S79,159,78,158.88s-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,71.23,158.41Z"
                fill="#3ba525"
              />
              <path
                d="M72,158.38a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,72,158.38Z"
                fill="#2f6840"
              />
              <path
                d="M75.46,157.59c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,75.46,157.59Z"
                fill="#2f6840"
              />
              <path
                d="M74.09,160.8a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,74.09,160.8Z"
                fill="#2f6840"
              />
              <path
                d="M72.14,158.84c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,72.14,158.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M86.44,174.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,86.44,174.24Z"
                fill="#2f6840"
              />
              <path
                d="M85.94,173.9c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,85.94,173.9Z"
                fill="#3ba525"
              />
              <path
                d="M86.69,173.87a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,86.69,173.87Z"
                fill="#2f6840"
              />
              <path
                d="M90.17,173.07c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,90.17,173.07Z"
                fill="#2f6840"
              />
              <path
                d="M88.8,176.29a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,88.8,176.29Z"
                fill="#2f6840"
              />
              <path
                d="M86.84,174.33c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,86.84,174.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M73,168.67c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,73,168.67Z"
                fill="#2f6840"
              />
              <path
                d="M72.48,168.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,72.48,168.33Z"
                fill="#3ba525"
              />
              <path
                d="M73.23,168.3a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,73.23,168.3Z"
                fill="#2f6840"
              />
              <path
                d="M76.71,167.51c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,76.71,167.51Z"
                fill="#2f6840"
              />
              <path
                d="M75.34,170.72a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,75.34,170.72Z"
                fill="#2f6840"
              />
              <path
                d="M73.38,168.76c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,73.38,168.76Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M109.6,162.55s.73,2.66,2.33,3.41,4.5-.41,3.82.89,2.77,2.66,4.38,2.59,5.64-2.66,5.83-3.7S109.6,162.55,109.6,162.55Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M110,160.57l-.35,2,2.5,2.62,3.79.66.59,1.63s2.36,1.74,4.36.76a14.17,14.17,0,0,0,3.78-3l.35-2Z"
              fill="#ccae79"
            />
            <path
              d="M113.26,159.82l-3.31.75,2.71,2.64,3.62.64.9,1.73s3.35,1.67,4,.69a22.38,22.38,0,0,1,3.8-3.07l-2.58-1.78Z"
              fill="#ffedc8"
            />
            <polygon
              points="112.66 163.21 112.1 165.17 115.89 165.83 116.28 163.85 112.66 163.21"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M120.18,166.57s.26,1.92-.33,1.93a8.84,8.84,0,0,0,4.77-3.31l.35-2S121,166.73,120.18,166.57Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M117.8,165.86l.69.27s-.43-.2-.49.65A2.1,2.1,0,0,0,117.8,165.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M119.38,166.44a5.5,5.5,0,0,0,.92-.5,4.42,4.42,0,0,0,1.15-1.19s-1.89,1.46-1.56,1.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M111.54,162.11a12.25,12.25,0,0,1-.26,1.44s.14-1.09.48-1.22Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M117.61,160.58l1.44.25c.1,0-1.13-.2-1.55.39l.11-.64"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M111.62,160.19l.82-.19s-.48.19-.32.28.77.5,1.07.41a1.11,1.11,0,0,1,.71.16Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M283.32,150.15l2.7,1.68a.91.91,0,0,0,.82.06l6.49-2.91a.87.87,0,0,0,.21-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,283.32,150.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="288.11 143.44 284.45 144.22 281.23 146.69 286.63 148.86 293.25 146.15 288.11 143.44"
              fill="#ffedc8"
            />
            <polygon
              points="281.23 146.69 281.23 148.86 286.41 151.08 293.39 148.25 293.25 146.15 286.63 148.86 281.23 146.69"
              fill="#ccae79"
            />
            <polygon
              points="286.63 148.86 286.41 151.08 293.39 148.25 293.25 146.15 286.63 148.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M282.77,147.31a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M285.05,148.22a3,3,0,0,0,1.36-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M289.36,147.74a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M291.78,145.38a6.62,6.62,0,0,1-2.15,0,3,3,0,0,1-1.56.1s1.15-.11,1.56.29A9,9,0,0,1,291.78,145.38Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M277.23,141.3l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.87.87,0,0,0-.69-.2l-9.2,1.22A.88.88,0,0,0,277.23,141.3Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="282.02 134.59 278.37 135.36 275.14 137.84 280.54 140 287.16 137.29 282.02 134.59"
              fill="#ffedc8"
            />
            <polygon
              points="275.14 137.84 275.14 140 280.32 142.22 287.3 139.39 287.16 137.29 280.54 140 275.14 137.84"
              fill="#ccae79"
            />
            <polygon
              points="280.54 140 280.32 142.22 287.3 139.39 287.16 137.29 280.54 140"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M276.68,138.46a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M279,139.37a3.08,3.08,0,0,0,1.37-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M283.27,138.88a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M285.69,136.52a6.61,6.61,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,285.69,136.52Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M263.79,134.24l2.71,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,263.79,134.24Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="268.59 127.53 264.93 128.3 261.71 130.78 267.11 132.94 273.73 130.24 268.59 127.53"
              fill="#ffedc8"
            />
            <polygon
              points="261.71 130.78 261.71 132.94 266.89 135.16 273.87 132.33 273.73 130.24 267.11 132.94 261.71 130.78"
              fill="#ccae79"
            />
            <polygon
              points="267.11 132.94 266.89 135.16 273.87 132.33 273.73 130.24 267.11 132.94"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M263.25,131.4a1,1,0,0,1,0,1.11c.25-.35.3-1,.41-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M265.53,132.31a3.09,3.09,0,0,0,1.36-1.38l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M269.84,131.83a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M272.26,129.46a6.34,6.34,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,272.26,129.46Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M264.32,145l2.71,1.68a.91.91,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,264.32,145Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="269.12 138.29 265.46 139.07 262.24 141.54 267.64 143.71 274.25 141 269.12 138.29"
              fill="#ffedc8"
            />
            <polygon
              points="262.24 141.54 262.24 143.71 267.42 145.93 274.4 143.1 274.25 141 267.64 143.71 262.24 141.54"
              fill="#ccae79"
            />
            <polygon
              points="267.64 143.71 267.42 145.93 274.4 143.1 274.25 141 267.64 143.71"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M263.78,142.16a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M266.06,143.07a3.09,3.09,0,0,0,1.36-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M270.37,142.59a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M272.79,140.23a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.14-.12,1.56.28A9,9,0,0,1,272.79,140.23Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M83.43,170.14l2.71,1.67a.85.85,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,83.43,170.14Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="88.23 163.42 84.57 164.2 81.35 166.68 86.75 168.84 93.36 166.13 88.23 163.42"
              fill="#ffedc8"
            />
            <polygon
              points="81.35 166.68 81.35 168.84 86.53 171.06 93.51 168.23 93.36 166.13 86.75 168.84 81.35 166.68"
              fill="#ccae79"
            />
            <polygon
              points="86.75 168.84 86.53 171.06 93.51 168.23 93.36 166.13 86.75 168.84"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M82.89,167.29a1,1,0,0,1,0,1.12c.25-.35.3-1,.41-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M85.17,168.21a3.08,3.08,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M89.48,167.72a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M91.9,165.36a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,91.9,165.36Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M96.39,165.15l2.7,1.68a.88.88,0,0,0,.82,0l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.9.9,0,0,0-.7-.21l-9.19,1.22A.88.88,0,0,0,96.39,165.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="101.18 158.44 97.52 159.21 94.3 161.69 99.7 163.85 106.32 161.15 101.18 158.44"
              fill="#ffedc8"
            />
            <polygon
              points="94.3 161.69 94.3 163.85 99.48 166.08 106.46 163.25 106.32 161.15 99.7 163.85 94.3 161.69"
              fill="#ccae79"
            />
            <polygon
              points="99.7 163.85 99.48 166.08 106.46 163.25 106.32 161.15 99.7 163.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M95.84,162.31a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M98.12,163.22a3,3,0,0,0,1.36-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M102.43,162.74a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M104.85,160.37a6.08,6.08,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,104.85,160.37Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M100.63,172.32l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.89.89,0,0,0-.7-.21L101,170.7A.88.88,0,0,0,100.63,172.32Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="105.42 165.61 101.76 166.38 98.54 168.86 103.94 171.02 110.56 168.31 105.42 165.61"
              fill="#ffedc8"
            />
            <polygon
              points="98.54 168.86 98.54 171.02 103.72 173.25 110.7 170.41 110.56 168.31 103.94 171.02 98.54 168.86"
              fill="#ccae79"
            />
            <polygon
              points="103.94 171.02 103.72 173.25 110.7 170.41 110.56 168.31 103.94 171.02"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M100.08,169.48a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M102.36,170.39a3,3,0,0,0,1.36-1.38l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M106.67,169.91a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M109.09,167.54a6.08,6.08,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,109.09,167.54Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M155.84,152.7l2,1.25a.65.65,0,0,0,.62,0l4.83-2.16a.66.66,0,0,0,.16-1.09h0a.65.65,0,0,0-.52-.15l-6.84.91A.65.65,0,0,0,155.84,152.7Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="159.41 147.71 156.69 148.28 154.29 150.13 158.31 151.74 163.24 149.72 159.41 147.71"
              fill="#ffedc8"
            />
            <polygon
              points="154.29 150.13 154.29 151.74 158.15 153.39 163.34 151.28 163.24 149.72 158.31 151.74 154.29 150.13"
              fill="#ccae79"
            />
            <polygon
              points="158.31 151.74 158.15 153.39 163.34 151.28 163.24 149.72 158.31 151.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M155.44,150.59a.73.73,0,0,1,0,.82c.18-.25.22-.73.31-.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M157.13,151.27a2.29,2.29,0,0,0,1-1l-.73,1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M160.34,150.91a.74.74,0,0,1,.41.65l-.12-.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M162.14,149.15a5,5,0,0,1-1.59,0,2.29,2.29,0,0,1-1.17.08s.86-.09,1.17.21A6.94,6.94,0,0,1,162.14,149.15Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M162.78,147.79l1.49.93a.5.5,0,0,0,.46,0l3.6-1.61a.5.5,0,0,0,.12-.82h0a.5.5,0,0,0-.39-.11l-5.09.68A.48.48,0,0,0,162.78,147.79Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="165.44 144.07 163.41 144.5 161.62 145.88 164.62 147.08 168.28 145.58 165.44 144.07"
              fill="#ffedc8"
            />
            <polygon
              points="161.62 145.88 161.62 147.08 164.49 148.31 168.36 146.74 168.28 145.58 164.62 147.08 161.62 145.88"
              fill="#ccae79"
            />
            <polygon
              points="164.62 147.08 164.49 148.31 168.36 146.74 168.28 145.58 164.62 147.08"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M162.48,146.22a.56.56,0,0,1,0,.62c.13-.2.16-.55.22-.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M163.74,146.73a1.73,1.73,0,0,0,.75-.77l-.54.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M166.13,146.46a.57.57,0,0,1,.3.48l-.09-.57Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M167.47,145.15a3.72,3.72,0,0,1-1.19,0,1.8,1.8,0,0,1-.87.06s.64-.06.87.15A5.41,5.41,0,0,1,167.47,145.15Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M165.13,141.88l1.49.93a.47.47,0,0,0,.46,0l3.6-1.61a.49.49,0,0,0,.12-.81h0a.5.5,0,0,0-.39-.11l-5.09.67A.49.49,0,0,0,165.13,141.88Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="167.79 138.16 165.76 138.59 163.97 139.96 166.97 141.16 170.63 139.66 167.79 138.16"
              fill="#ffedc8"
            />
            <polygon
              points="163.97 139.96 163.97 141.16 166.84 142.4 170.71 140.83 170.63 139.66 166.97 141.16 163.97 139.96"
              fill="#ccae79"
            />
            <polygon
              points="166.97 141.16 166.84 142.4 170.71 140.83 170.63 139.66 166.97 141.16"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M164.83,140.31a.54.54,0,0,1,0,.61c.13-.19.16-.55.23-.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M166.09,140.81a1.67,1.67,0,0,0,.75-.76l-.54.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M168.48,140.54a.57.57,0,0,1,.3.49l-.09-.57Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M169.82,139.23a3.44,3.44,0,0,1-1.19,0,1.66,1.66,0,0,1-.87.06s.64-.06.87.16A5.12,5.12,0,0,1,169.82,139.23Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M151.14,146.09l2,1.25a.66.66,0,0,0,.61,0l4.83-2.16a.65.65,0,0,0,.16-1.09h0a.68.68,0,0,0-.51-.16l-6.85.91A.66.66,0,0,0,151.14,146.09Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="154.72 141.09 151.99 141.67 149.59 143.51 153.61 145.13 158.54 143.11 154.72 141.09"
              fill="#ffedc8"
            />
            <polygon
              points="149.59 143.51 149.59 145.13 153.45 146.78 158.65 144.67 158.54 143.11 153.61 145.13 149.59 143.51"
              fill="#ccae79"
            />
            <polygon
              points="153.61 145.13 153.45 146.78 158.65 144.67 158.54 143.11 153.61 145.13"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M150.74,144a.72.72,0,0,1,0,.83c.18-.26.22-.74.31-.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M152.44,144.65a2.3,2.3,0,0,0,1-1l-.73,1.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M155.65,144.29a.76.76,0,0,1,.4.65l-.12-.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M157.45,142.53a4.49,4.49,0,0,1-1.6,0,2.29,2.29,0,0,1-1.17.08s.86-.08,1.17.21A7,7,0,0,1,157.45,142.53Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M282.77,132.48l3.62,2.26a1.21,1.21,0,0,0,1.11.07l8.71-3.89a1.18,1.18,0,0,0,.29-2h0a1.18,1.18,0,0,0-.92-.28l-12.35,1.64A1.18,1.18,0,0,0,282.77,132.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="289.21 123.47 284.29 124.51 279.97 127.84 287.22 130.75 296.1 127.11 289.21 123.47"
              fill="#ffedc8"
            />
            <polygon
              points="279.97 127.84 279.97 130.75 286.93 133.73 296.29 129.93 296.1 127.11 287.22 130.75 279.97 127.84"
              fill="#ccae79"
            />
            <polygon
              points="287.22 130.75 286.93 133.73 296.29 129.93 296.1 127.11 287.22 130.75"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M282,128.67a1.31,1.31,0,0,1,0,1.49c.32-.47.4-1.33.55-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M285.1,129.9a4.16,4.16,0,0,0,1.83-1.86l-1.32,2.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M290.89,129.24a1.35,1.35,0,0,1,.72,1.18l-.22-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M294.13,126.07a8.7,8.7,0,0,1-2.88,0,4.13,4.13,0,0,1-2.1.15s1.54-.15,2.1.37A12.5,12.5,0,0,1,294.13,126.07Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M309.1,138.35l3.63,2.25a1.18,1.18,0,0,0,1.11.08l8.71-3.9a1.18,1.18,0,0,0,.29-2h0a1.15,1.15,0,0,0-.93-.27l-12.34,1.64A1.18,1.18,0,0,0,309.1,138.35Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="315.55 129.34 310.63 130.38 306.3 133.71 313.56 136.61 322.44 132.97 315.55 129.34"
              fill="#ffedc8"
            />
            <polygon
              points="306.3 133.71 306.3 136.61 313.26 139.6 322.63 135.79 322.44 132.97 313.56 136.61 306.3 133.71"
              fill="#ccae79"
            />
            <polygon
              points="313.56 136.61 313.26 139.6 322.63 135.79 322.44 132.97 313.56 136.61"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M308.38,134.54a1.31,1.31,0,0,1,0,1.49c.32-.47.4-1.33.55-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M311.43,135.76a4,4,0,0,0,1.83-1.86L312,136Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M317.23,135.11a1.35,1.35,0,0,1,.72,1.18l-.22-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M320.47,131.94a8.7,8.7,0,0,1-2.88,0,4.18,4.18,0,0,1-2.1.14s1.54-.15,2.1.38A12.5,12.5,0,0,1,320.47,131.94Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M290.35,143l2.47,1.53a.82.82,0,0,0,.76.05l5.94-2.65a.81.81,0,0,0,.2-1.35h0a.76.76,0,0,0-.63-.18l-8.42,1.11A.81.81,0,0,0,290.35,143Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="294.74 136.88 291.39 137.59 288.44 139.86 293.39 141.84 299.45 139.36 294.74 136.88"
              fill="#ffedc8"
            />
            <polygon
              points="288.44 139.86 288.44 141.84 293.19 143.88 299.58 141.28 299.45 139.36 293.39 141.84 288.44 139.86"
              fill="#ccae79"
            />
            <polygon
              points="293.39 141.84 293.19 143.88 299.58 141.28 299.45 139.36 293.39 141.84"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M289.85,140.42a.89.89,0,0,1,0,1c.22-.32.28-.91.38-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M291.94,141.26a2.79,2.79,0,0,0,1.25-1.27l-.9,1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M295.89,140.82a.92.92,0,0,1,.49.8l-.15-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M298.1,138.65a5.77,5.77,0,0,1-2,0,2.81,2.81,0,0,1-1.44.1s1.05-.1,1.44.26A8.5,8.5,0,0,1,298.1,138.65Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1067.56,31.29l2.7,1.68a.91.91,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.89.89,0,0,0-.7-.21l-9.19,1.22A.88.88,0,0,0,1067.56,31.29Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1072.35 24.58 1068.69 25.36 1065.47 27.83 1070.87 30 1077.49 27.29 1072.35 24.58"
            fill="#ffedc8"
          />
          <polygon
            points="1065.47 27.83 1065.47 30 1070.65 32.22 1077.63 29.39 1077.49 27.29 1070.87 30 1065.47 27.83"
            fill="#ccae79"
          />
          <polygon
            points="1070.87 30 1070.65 32.22 1077.63 29.39 1077.49 27.29 1070.87 30"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1067,28.45a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.94Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1069.29,29.36a3,3,0,0,0,1.36-1.38l-1,1.54Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1073.6,28.88a1,1,0,0,1,.54.87l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1076,26.52a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.12,1.56.28A9,9,0,0,1,1076,26.52Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1085.46,21.14l2.7,1.68a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.91.91,0,0,0-.69-.21l-9.19,1.23A.87.87,0,0,0,1085.46,21.14Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1090.26 14.43 1086.6 15.21 1083.38 17.68 1088.78 19.85 1095.39 17.14 1090.26 14.43"
            fill="#ffedc8"
          />
          <polygon
            points="1083.38 17.68 1083.38 19.85 1088.56 22.07 1095.53 19.24 1095.39 17.14 1088.78 19.85 1083.38 17.68"
            fill="#ccae79"
          />
          <polygon
            points="1088.78 19.85 1088.56 22.07 1095.53 19.24 1095.39 17.14 1088.78 19.85"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1084.92,18.3a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1087.2,19.22a3.08,3.08,0,0,0,1.36-1.39l-1,1.54Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1091.51,18.73a1,1,0,0,1,.54.88l-.17-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1093.92,16.37a6.54,6.54,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A8.93,8.93,0,0,1,1093.92,16.37Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1153.18,19.2c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1153.18,19.2Z"
              fill="#2f6840"
            />
            <path
              d="M1152.68,18.86c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1152.68,18.86Z"
              fill="#3ba525"
            />
            <path
              d="M1153.43,18.83a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1153.43,18.83Z"
              fill="#2f6840"
            />
            <path
              d="M1156.91,18c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1156.91,18Z"
              fill="#2f6840"
            />
            <path
              d="M1155.54,21.24a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1155.54,21.24Z"
              fill="#2f6840"
            />
            <path
              d="M1153.58,19.29c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1153.58,19.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1150.52,27.93c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S1145.8,29.08,1146,29A14.55,14.55,0,0,1,1150.52,27.93Z"
              fill="#2f6840"
            />
            <path
              d="M1150,27.58c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1150,27.58Z"
              fill="#3ba525"
            />
            <path
              d="M1150.77,27.56a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1150.77,27.56Z"
              fill="#2f6840"
            />
            <path
              d="M1154.25,26.76c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1154.25,26.76Z"
              fill="#2f6840"
            />
            <path
              d="M1152.88,30a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1152.88,30Z"
              fill="#2f6840"
            />
            <path
              d="M1150.92,28a7,7,0,0,0-.69.15,4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1150.92,28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1145.17,23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1145.17,23Z"
              fill="#2f6840"
            />
            <path
              d="M1144.67,22.63c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1144.67,22.63Z"
              fill="#3ba525"
            />
            <path
              d="M1145.42,22.6a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1145.42,22.6Z"
              fill="#2f6840"
            />
            <path
              d="M1148.9,21.8c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1148.9,21.8Z"
              fill="#2f6840"
            />
            <path
              d="M1147.53,25a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1147.53,25Z"
              fill="#2f6840"
            />
            <path
              d="M1145.57,23.06a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1145.57,23.06Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1136.83,19.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1136.83,19.6Z"
              fill="#2f6840"
            />
            <path
              d="M1136.32,19.25c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1136.32,19.25Z"
              fill="#3ba525"
            />
            <path
              d="M1137.08,19.23a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1137.08,19.23Z"
              fill="#2f6840"
            />
            <path
              d="M1140.55,18.43c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1140.55,18.43Z"
              fill="#2f6840"
            />
            <path
              d="M1139.19,21.64a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1139.19,21.64Z"
              fill="#2f6840"
            />
            <path
              d="M1137.23,19.69a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1137.23,19.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1151.53,35.09c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1151.53,35.09Z"
              fill="#2f6840"
            />
            <path
              d="M1151,34.74c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1151,34.74Z"
              fill="#3ba525"
            />
            <path
              d="M1151.78,34.72a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1151.78,34.72Z"
              fill="#2f6840"
            />
            <path
              d="M1155.26,33.92c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1155.26,33.92Z"
              fill="#2f6840"
            />
            <path
              d="M1153.89,37.13a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1153.89,37.13Z"
              fill="#2f6840"
            />
            <path
              d="M1151.93,35.18c-.24,0-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1151.93,35.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1138.08,29.52c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1138.08,29.52Z"
              fill="#2f6840"
            />
            <path
              d="M1137.57,29.17c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1137.57,29.17Z"
              fill="#3ba525"
            />
            <path
              d="M1138.32,29.15a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1138.32,29.15Z"
              fill="#2f6840"
            />
            <path
              d="M1141.8,28.35c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1141.8,28.35Z"
              fill="#2f6840"
            />
            <path
              d="M1140.43,31.56a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1140.43,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M1138.48,29.61a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1138.48,29.61Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1129.08,8.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1129.08,8.69Z"
              fill="#2f6840"
            />
            <path
              d="M1128.57,8.34c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1128.57,8.34Z"
              fill="#3ba525"
            />
            <path
              d="M1129.32,8.32a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1129.32,8.32Z"
              fill="#2f6840"
            />
            <path
              d="M1132.8,7.52c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1132.8,7.52Z"
              fill="#2f6840"
            />
            <path
              d="M1131.43,10.73a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1131.43,10.73Z"
              fill="#2f6840"
            />
            <path
              d="M1129.47,8.78a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1129.47,8.78Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1126.42,17.42c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1126.42,17.42Z"
              fill="#2f6840"
            />
            <path
              d="M1125.91,17.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1125.91,17.07Z"
              fill="#3ba525"
            />
            <path
              d="M1126.66,17a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1126.66,17Z"
              fill="#2f6840"
            />
            <path
              d="M1130.14,16.25c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1130.14,16.25Z"
              fill="#2f6840"
            />
            <path
              d="M1128.77,19.46a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1128.77,19.46Z"
              fill="#2f6840"
            />
            <path
              d="M1126.82,17.5c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1126.82,17.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1121.06,12.46c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1121.06,12.46Z"
              fill="#2f6840"
            />
            <path
              d="M1120.56,12.12c4.42-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1120.56,12.12Z"
              fill="#3ba525"
            />
            <path
              d="M1121.31,12.09a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1121.31,12.09Z"
              fill="#2f6840"
            />
            <path
              d="M1124.79,11.29c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1124.79,11.29Z"
              fill="#2f6840"
            />
            <path
              d="M1123.42,14.5a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1123.42,14.5Z"
              fill="#2f6840"
            />
            <path
              d="M1121.46,12.55a7,7,0,0,0-.69.15,4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1121.46,12.55Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1112.72,9.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1112.72,9.09Z"
              fill="#2f6840"
            />
            <path
              d="M1112.22,8.74c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S1120,9.33,1119,9.22s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1112.22,8.74Z"
              fill="#3ba525"
            />
            <path
              d="M1113,8.72a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1113,8.72Z"
              fill="#2f6840"
            />
            <path
              d="M1116.45,7.92c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1116.45,7.92Z"
              fill="#2f6840"
            />
            <path
              d="M1115.08,11.13a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1115.08,11.13Z"
              fill="#2f6840"
            />
            <path
              d="M1113.12,9.17c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1113.12,9.17Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1127.43,24.58c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1127.43,24.58Z"
              fill="#2f6840"
            />
            <path
              d="M1126.92,24.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1126.92,24.23Z"
              fill="#3ba525"
            />
            <path
              d="M1127.67,24.2a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1127.67,24.2Z"
              fill="#2f6840"
            />
            <path
              d="M1131.15,23.41c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1131.15,23.41Z"
              fill="#2f6840"
            />
            <path
              d="M1129.78,26.62a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1129.78,26.62Z"
              fill="#2f6840"
            />
            <path
              d="M1127.83,24.66c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1127.83,24.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1114,19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1114,19Z"
              fill="#2f6840"
            />
            <path
              d="M1113.46,18.66c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1113.46,18.66Z"
              fill="#3ba525"
            />
            <path
              d="M1114.22,18.64a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1114.22,18.64Z"
              fill="#2f6840"
            />
            <path
              d="M1117.69,17.84c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1117.69,17.84Z"
              fill="#2f6840"
            />
            <path
              d="M1116.33,21.05a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1116.33,21.05Z"
              fill="#2f6840"
            />
            <path
              d="M1114.37,19.09c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1114.37,19.09Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1104.64,3.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1104.64,3.42Z"
              fill="#2f6840"
            />
            <path
              d="M1104.14,3.08c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72S1104.67,4,1104.67,4s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1104.14,3.08Z"
              fill="#3ba525"
            />
            <path
              d="M1104.89,3.05a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1104.89,3.05Z"
              fill="#2f6840"
            />
            <path
              d="M1108.37,2.25c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1108.37,2.25Z"
              fill="#2f6840"
            />
            <path
              d="M1107,5.46a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1107,5.46Z"
              fill="#2f6840"
            />
            <path
              d="M1105,3.51c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1105,3.51Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1102,12.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1102,12.15Z"
              fill="#2f6840"
            />
            <path
              d="M1101.48,11.81c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1101.48,11.81Z"
              fill="#3ba525"
            />
            <path
              d="M1102.23,11.78a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1102.23,11.78Z"
              fill="#2f6840"
            />
            <path
              d="M1105.71,11c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1105.71,11Z"
              fill="#2f6840"
            />
            <path
              d="M1104.34,14.19a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1104.34,14.19Z"
              fill="#2f6840"
            />
            <path
              d="M1102.38,12.24c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1102.38,12.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1096.63,7.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1096.63,7.19Z"
              fill="#2f6840"
            />
            <path
              d="M1096.12,6.85c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1096.12,6.85Z"
              fill="#3ba525"
            />
            <path
              d="M1096.88,6.82a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1096.88,6.82Z"
              fill="#2f6840"
            />
            <path
              d="M1100.35,6c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1100.35,6Z"
              fill="#2f6840"
            />
            <path
              d="M1099,9.23a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1099,9.23Z"
              fill="#2f6840"
            />
            <path
              d="M1097,7.28c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1097,7.28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1088.29,3.82c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.29,3.82Z"
              fill="#2f6840"
            />
            <path
              d="M1087.78,3.48c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1087.78,3.48Z"
              fill="#3ba525"
            />
            <path
              d="M1088.53,3.45a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1088.53,3.45Z"
              fill="#2f6840"
            />
            <path
              d="M1092,2.65c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1092,2.65Z"
              fill="#2f6840"
            />
            <path
              d="M1090.64,5.86a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1090.64,5.86Z"
              fill="#2f6840"
            />
            <path
              d="M1088.69,3.91c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1088.69,3.91Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1103,19.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1103,19.31Z"
              fill="#2f6840"
            />
            <path
              d="M1102.49,19c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1102.49,19Z"
              fill="#3ba525"
            />
            <path
              d="M1103.24,18.94a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1103.24,18.94Z"
              fill="#2f6840"
            />
            <path
              d="M1106.72,18.14c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1106.72,18.14Z"
              fill="#2f6840"
            />
            <path
              d="M1105.35,21.35a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1105.35,21.35Z"
              fill="#2f6840"
            />
            <path
              d="M1103.39,19.4c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1103.39,19.4Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1089.54,13.74c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1089.54,13.74Z"
              fill="#2f6840"
            />
            <path
              d="M1089,13.4c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1089,13.4Z"
              fill="#3ba525"
            />
            <path
              d="M1089.78,13.37a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1089.78,13.37Z"
              fill="#2f6840"
            />
            <path
              d="M1093.26,12.57c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1093.26,12.57Z"
              fill="#2f6840"
            />
            <path
              d="M1091.89,15.78a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1091.89,15.78Z"
              fill="#2f6840"
            />
            <path
              d="M1089.93,13.83c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1089.93,13.83Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1079.34,16.32c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1079.34,16.32Z"
              fill="#2f6840"
            />
            <path
              d="M1078.83,16c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1078.83,16Z"
              fill="#3ba525"
            />
            <path
              d="M1079.59,16a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1079.59,16Z"
              fill="#2f6840"
            />
            <path
              d="M1083.06,15.15c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1083.06,15.15Z"
              fill="#2f6840"
            />
            <path
              d="M1081.7,18.36a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1081.7,18.36Z"
              fill="#2f6840"
            />
            <path
              d="M1079.74,16.41c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1079.74,16.41Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1076.68,25.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1076.68,25.05Z"
              fill="#2f6840"
            />
            <path
              d="M1076.17,24.71c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1076.17,24.71Z"
              fill="#3ba525"
            />
            <path
              d="M1076.93,24.68a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1076.93,24.68Z"
              fill="#2f6840"
            />
            <path
              d="M1080.4,23.88c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1080.4,23.88Z"
              fill="#2f6840"
            />
            <path
              d="M1079,27.09a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1079,27.09Z"
              fill="#2f6840"
            />
            <path
              d="M1077.08,25.14a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1077.08,25.14Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1071.33,20.09c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1071.33,20.09Z"
              fill="#2f6840"
            />
            <path
              d="M1070.82,19.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1070.82,19.75Z"
              fill="#3ba525"
            />
            <path
              d="M1071.57,19.72a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1071.57,19.72Z"
              fill="#2f6840"
            />
            <path
              d="M1075.05,18.92c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1075.05,18.92Z"
              fill="#2f6840"
            />
            <path
              d="M1073.68,22.13a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1073.68,22.13Z"
              fill="#2f6840"
            />
            <path
              d="M1071.73,20.18c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1071.73,20.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1063,16.72c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1063,16.72Z"
              fill="#2f6840"
            />
            <path
              d="M1062.48,16.38c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1062.48,16.38Z"
              fill="#3ba525"
            />
            <path
              d="M1063.23,16.35a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1063.23,16.35Z"
              fill="#2f6840"
            />
            <path
              d="M1066.71,15.55c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1066.71,15.55Z"
              fill="#2f6840"
            />
            <path
              d="M1065.34,18.76a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1065.34,18.76Z"
              fill="#2f6840"
            />
            <path
              d="M1063.38,16.81a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1063.38,16.81Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1077.69,32.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1077.69,32.21Z"
              fill="#2f6840"
            />
            <path
              d="M1077.18,31.87c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1077.18,31.87Z"
              fill="#3ba525"
            />
            <path
              d="M1077.94,31.84a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1077.94,31.84Z"
              fill="#2f6840"
            />
            <path
              d="M1081.41,31c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1081.41,31Z"
              fill="#2f6840"
            />
            <path
              d="M1080.05,34.25a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1080.05,34.25Z"
              fill="#2f6840"
            />
            <path
              d="M1078.09,32.3a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1078.09,32.3Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1064.23,26.64c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1064.23,26.64Z"
              fill="#2f6840"
            />
            <path
              d="M1063.73,26.3c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1063.73,26.3Z"
              fill="#3ba525"
            />
            <path
              d="M1064.48,26.27a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1064.48,26.27Z"
              fill="#2f6840"
            />
            <path
              d="M1068,25.47c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1068,25.47Z"
              fill="#2f6840"
            />
            <path
              d="M1066.59,28.68a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1066.59,28.68Z"
              fill="#2f6840"
            />
            <path
              d="M1064.63,26.73a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1064.63,26.73Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1133.47,30.67l1.84,1.14a.59.59,0,0,0,.56,0l4.41-2a.6.6,0,0,0,.14-1h0a.61.61,0,0,0-.47-.14l-6.24.83A.6.6,0,0,0,1133.47,30.67Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1136.73 26.11 1134.25 26.64 1132.06 28.32 1135.73 29.79 1140.22 27.95 1136.73 26.11"
            fill="#ffedc8"
          />
          <polygon
            points="1132.06 28.32 1132.06 29.79 1135.58 31.3 1140.32 29.38 1140.22 27.95 1135.73 29.79 1132.06 28.32"
            fill="#ccae79"
          />
          <polygon
            points="1135.73 29.79 1135.58 31.3 1140.32 29.38 1140.22 27.95 1135.73 29.79"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1133.1,28.74a.67.67,0,0,1,0,.76c.17-.24.21-.68.28-.65Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1134.65,29.36a2.08,2.08,0,0,0,.93-.94l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1137.58,29a.69.69,0,0,1,.37.6l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1139.22,27.43a4.4,4.4,0,0,1-1.45,0,2.1,2.1,0,0,1-1.07.07s.78-.07,1.07.19A6.26,6.26,0,0,1,1139.22,27.43Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1109.83,13.94l4,2.49a1.3,1.3,0,0,0,1.21.08l9.63-4.3A1.31,1.31,0,0,0,1125,10h0a1.34,1.34,0,0,0-1-.31l-13.64,1.82A1.3,1.3,0,0,0,1109.83,13.94Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1116.94 3.98 1111.52 5.13 1106.73 8.81 1114.75 12.02 1124.56 8 1116.94 3.98"
            fill="#ffedc8"
          />
          <polygon
            points="1106.73 8.81 1106.73 12.02 1114.42 15.31 1124.77 11.11 1124.56 8 1114.75 12.02 1106.73 8.81"
            fill="#ccae79"
          />
          <polygon
            points="1114.75 12.02 1114.42 15.31 1124.77 11.11 1124.56 8 1114.75 12.02"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1109,9.72a1.45,1.45,0,0,1,0,1.65c.36-.52.45-1.47.62-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1112.4,11.08a4.55,4.55,0,0,0,2-2.06L1113,11.31Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1118.8,10.36a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1122.38,6.85a9.37,9.37,0,0,1-3.18,0,4.5,4.5,0,0,1-2.32.16s1.7-.16,2.32.42A13.87,13.87,0,0,1,1122.38,6.85Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1116.1,31.28l3,1.86a1,1,0,0,0,.9.06l7.17-3.2a1,1,0,0,0,.24-1.62h0a.93.93,0,0,0-.76-.23l-10.16,1.35A1,1,0,0,0,1116.1,31.28Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1121.4 23.87 1117.36 24.73 1113.8 27.46 1119.76 29.85 1127.07 26.86 1121.4 23.87"
            fill="#ffedc8"
          />
          <polygon
            points="1113.8 27.46 1113.8 29.85 1119.52 32.31 1127.23 29.18 1127.07 26.86 1119.76 29.85 1113.8 27.46"
            fill="#ccae79"
          />
          <polygon
            points="1119.76 29.85 1119.52 32.31 1127.23 29.18 1127.07 26.86 1119.76 29.85"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1115.5,28.15a1.07,1.07,0,0,1,0,1.22c.27-.38.33-1.09.46-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1118,29.15a3.39,3.39,0,0,0,1.5-1.52l-1.08,1.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1122.78,28.62a1.1,1.1,0,0,1,.59,1l-.17-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1125.45,26a7.09,7.09,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,1125.45,26Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1087.29,34.94l4,2.49a1.3,1.3,0,0,0,1.21.08l9.63-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.34,1.34,0,0,0-1-.31l-13.64,1.82A1.3,1.3,0,0,0,1087.29,34.94Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1094.4 24.98 1088.98 26.13 1084.2 29.81 1092.21 33.02 1102.02 29 1094.4 24.98"
            fill="#ffedc8"
          />
          <polygon
            points="1084.2 29.81 1084.2 33.02 1091.88 36.31 1102.23 32.11 1102.02 29 1092.21 33.02 1084.2 29.81"
            fill="#ccae79"
          />
          <polygon
            points="1092.21 33.02 1091.88 36.31 1102.23 32.11 1102.02 29 1092.21 33.02"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1086.48,30.72a1.45,1.45,0,0,1,0,1.65c.36-.52.45-1.47.62-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1089.86,32.08a4.55,4.55,0,0,0,2-2.06l-1.45,2.29Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1096.26,31.36a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1099.84,27.85a9.37,9.37,0,0,1-3.18,0,4.5,4.5,0,0,1-2.32.16s1.7-.16,2.32.42A13.87,13.87,0,0,1,1099.84,27.85Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1134.4,21s1.69,3.36,4,3.92,5.91-1.77,5.36.16,4.43,2.8,6.57,2.28,6.83-5.1,6.8-6.55S1134.4,21,1134.4,21Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1134.33,18.28l.07,2.76,4.06,2.82,5.25-.14,1.25,2s3.62,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1l-.07-2.76Z"
            fill="#ccae79"
          />
          <path
            d="M1138.55,16.38l-4.22,1.9,4.35,2.81,5-.13,1.68,2.06s4.94,1.33,5.54-.15,4.25-5.15,4.25-5.15l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="1138.68 21.09 1138.46 23.86 1143.71 23.72 1143.7 20.96 1138.68 21.09"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1149.67,23.54s.87,2.51.07,2.68a12,12,0,0,0,5.5-5.74l-.07-2.76S1150.82,23.52,1149.67,23.54Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1146.28,23.23l1,.19s-.62-.17-.47,1A2.75,2.75,0,0,0,1146.28,23.23Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1148.56,23.59c-.11,0,.2,0,1.09-.93a6,6,0,0,0,1.22-1.9s-2.13,2.46-1.61,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1136.87,19.92a16,16,0,0,1,.06,2s-.12-1.5.3-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1144.59,16.22l2-.06c.14,0-1.57,0-2,.94l0-.88"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1136.46,17.32l1-.47s-.59.38-.35.46,1.17.45,1.55.25a1.53,1.53,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1105.48,452.15c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72S1106,453,1106,453s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1105.48,452.15Z"
              fill="#2f6840"
            />
            <path
              d="M1105,451.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1105,451.8Z"
              fill="#3ba525"
            />
            <path
              d="M1105.73,451.78a2.18,2.18,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1105.73,451.78Z"
              fill="#2f6840"
            />
            <path
              d="M1109.2,451c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1109.2,451Z"
              fill="#2f6840"
            />
            <path
              d="M1107.84,454.19a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1107.84,454.19Z"
              fill="#2f6840"
            />
            <path
              d="M1105.88,452.23c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1105.88,452.23Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1102.82,460.88c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1102.82,460.88Z"
              fill="#2f6840"
            />
            <path
              d="M1102.31,460.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1102.31,460.53Z"
              fill="#3ba525"
            />
            <path
              d="M1103.07,460.5a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1103.07,460.5Z"
              fill="#2f6840"
            />
            <path
              d="M1106.54,459.71c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1106.54,459.71Z"
              fill="#2f6840"
            />
            <path
              d="M1105.18,462.92a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1105.18,462.92Z"
              fill="#2f6840"
            />
            <path
              d="M1103.22,461c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1103.22,461Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1097.47,455.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1097.47,455.92Z"
              fill="#2f6840"
            />
            <path
              d="M1097,455.57c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1097,455.57Z"
              fill="#3ba525"
            />
            <path
              d="M1097.71,455.55a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1097.71,455.55Z"
              fill="#2f6840"
            />
            <path
              d="M1101.19,454.75c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1101.19,454.75Z"
              fill="#2f6840"
            />
            <path
              d="M1099.82,458a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1099.82,458Z"
              fill="#2f6840"
            />
            <path
              d="M1097.87,456a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1097.87,456Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1089.12,452.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1089.12,452.55Z"
              fill="#2f6840"
            />
            <path
              d="M1088.62,452.2c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.62,452.2Z"
              fill="#3ba525"
            />
            <path
              d="M1089.37,452.17a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1089.37,452.17Z"
              fill="#2f6840"
            />
            <path
              d="M1092.85,451.38c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1092.85,451.38Z"
              fill="#2f6840"
            />
            <path
              d="M1091.48,454.59a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1091.48,454.59Z"
              fill="#2f6840"
            />
            <path
              d="M1089.52,452.63c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1089.52,452.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1103.83,468c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1103.83,468Z"
              fill="#2f6840"
            />
            <path
              d="M1103.32,467.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1103.32,467.69Z"
              fill="#3ba525"
            />
            <path
              d="M1104.08,467.66a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1104.08,467.66Z"
              fill="#2f6840"
            />
            <path
              d="M1107.55,466.87a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1107.55,466.87Z"
              fill="#2f6840"
            />
            <path
              d="M1106.19,470.08a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1106.19,470.08Z"
              fill="#2f6840"
            />
            <path
              d="M1104.23,468.12c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1104.23,468.12Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1090.37,462.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.46,14.46,0,0,1,1090.37,462.47Z"
              fill="#2f6840"
            />
            <path
              d="M1089.87,462.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1089.87,462.12Z"
              fill="#3ba525"
            />
            <path
              d="M1090.62,462.09a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1090.62,462.09Z"
              fill="#2f6840"
            />
            <path
              d="M1094.1,461.3c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1094.1,461.3Z"
              fill="#2f6840"
            />
            <path
              d="M1092.73,464.51a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1092.73,464.51Z"
              fill="#2f6840"
            />
            <path
              d="M1090.77,462.55c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1090.77,462.55Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1132.55,460.21c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1132.55,460.21Z"
              fill="#2f6840"
            />
            <path
              d="M1132.05,459.87c4.42-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.77,14.77,0,0,1,1132.05,459.87Z"
              fill="#3ba525"
            />
            <path
              d="M1132.8,459.84a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1132.8,459.84Z"
              fill="#2f6840"
            />
            <path
              d="M1136.28,459c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1136.28,459Z"
              fill="#2f6840"
            />
            <path
              d="M1134.91,462.25a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1134.91,462.25Z"
              fill="#2f6840"
            />
            <path
              d="M1133,460.3c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1133,460.3Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1129.89,468.94c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1129.89,468.94Z"
              fill="#2f6840"
            />
            <path
              d="M1129.39,468.59c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1129.39,468.59Z"
              fill="#3ba525"
            />
            <path
              d="M1130.14,468.57a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1130.14,468.57Z"
              fill="#2f6840"
            />
            <path
              d="M1133.62,467.77c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1133.62,467.77Z"
              fill="#2f6840"
            />
            <path
              d="M1132.25,471a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1132.25,471Z"
              fill="#2f6840"
            />
            <path
              d="M1130.29,469c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1130.29,469Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1124.54,464c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1124.54,464Z"
              fill="#2f6840"
            />
            <path
              d="M1124,463.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1124,463.64Z"
              fill="#3ba525"
            />
            <path
              d="M1124.79,463.61a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1124.79,463.61Z"
              fill="#2f6840"
            />
            <path
              d="M1128.27,462.81c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1128.27,462.81Z"
              fill="#2f6840"
            />
            <path
              d="M1126.9,466a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1126.9,466Z"
              fill="#2f6840"
            />
            <path
              d="M1124.94,464.07a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1124.94,464.07Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1116.2,460.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.37,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1116.2,460.61Z"
              fill="#2f6840"
            />
            <path
              d="M1115.69,460.26c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1115.69,460.26Z"
              fill="#3ba525"
            />
            <path
              d="M1116.45,460.24a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1116.45,460.24Z"
              fill="#2f6840"
            />
            <path
              d="M1119.92,459.44c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1119.92,459.44Z"
              fill="#2f6840"
            />
            <path
              d="M1118.56,462.65a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1118.56,462.65Z"
              fill="#2f6840"
            />
            <path
              d="M1116.6,460.7a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1116.6,460.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1130.9,476.1c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1130.9,476.1Z"
              fill="#2f6840"
            />
            <path
              d="M1130.4,475.75c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1130.4,475.75Z"
              fill="#3ba525"
            />
            <path
              d="M1131.15,475.73a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1131.15,475.73Z"
              fill="#2f6840"
            />
            <path
              d="M1134.63,474.93c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1134.63,474.93Z"
              fill="#2f6840"
            />
            <path
              d="M1133.26,478.14a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1133.26,478.14Z"
              fill="#2f6840"
            />
            <path
              d="M1131.3,476.18c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1131.3,476.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1117.45,470.53c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1117.45,470.53Z"
              fill="#2f6840"
            />
            <path
              d="M1116.94,470.18c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1116.94,470.18Z"
              fill="#3ba525"
            />
            <path
              d="M1117.69,470.16a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1117.69,470.16Z"
              fill="#2f6840"
            />
            <path
              d="M1121.17,469.36c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1121.17,469.36Z"
              fill="#2f6840"
            />
            <path
              d="M1119.8,472.57a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1119.8,472.57Z"
              fill="#2f6840"
            />
            <path
              d="M1117.85,470.62a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1117.85,470.62Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1157.84,473.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1157.84,473.2Z"
              fill="#2f6840"
            />
            <path
              d="M1157.33,472.86c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1157.33,472.86Z"
              fill="#3ba525"
            />
            <path
              d="M1158.09,472.83a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1158.09,472.83Z"
              fill="#2f6840"
            />
            <path
              d="M1161.57,472c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1161.57,472Z"
              fill="#2f6840"
            />
            <path
              d="M1160.2,475.24a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1160.2,475.24Z"
              fill="#2f6840"
            />
            <path
              d="M1158.24,473.29c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1158.24,473.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1155.18,481.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1155.18,481.93Z"
              fill="#2f6840"
            />
            <path
              d="M1154.68,481.58c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1154.68,481.58Z"
              fill="#3ba525"
            />
            <path
              d="M1155.43,481.56a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1155.43,481.56Z"
              fill="#2f6840"
            />
            <path
              d="M1158.91,480.76c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1158.91,480.76Z"
              fill="#2f6840"
            />
            <path
              d="M1157.54,484a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1157.54,484Z"
              fill="#2f6840"
            />
            <path
              d="M1155.58,482a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1155.58,482Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1149.83,477c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1149.83,477Z"
              fill="#2f6840"
            />
            <path
              d="M1149.32,476.63c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1149.32,476.63Z"
              fill="#3ba525"
            />
            <path
              d="M1150.08,476.6a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1150.08,476.6Z"
              fill="#2f6840"
            />
            <path
              d="M1153.55,475.8c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1153.55,475.8Z"
              fill="#2f6840"
            />
            <path
              d="M1152.19,479a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1152.19,479Z"
              fill="#2f6840"
            />
            <path
              d="M1150.23,477.06a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1150.23,477.06Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1141.49,473.6c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1141.49,473.6Z"
              fill="#2f6840"
            />
            <path
              d="M1141,473.25c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1141,473.25Z"
              fill="#3ba525"
            />
            <path
              d="M1141.73,473.23a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1141.73,473.23Z"
              fill="#2f6840"
            />
            <path
              d="M1145.21,472.43c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1145.21,472.43Z"
              fill="#2f6840"
            />
            <path
              d="M1143.84,475.64a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1143.84,475.64Z"
              fill="#2f6840"
            />
            <path
              d="M1141.88,473.69a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1141.88,473.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1156.19,489.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1156.19,489.09Z"
              fill="#2f6840"
            />
            <path
              d="M1155.69,488.74c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1155.69,488.74Z"
              fill="#3ba525"
            />
            <path
              d="M1156.44,488.72a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1156.44,488.72Z"
              fill="#2f6840"
            />
            <path
              d="M1159.92,487.92c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.1,2.1,0,0,1,1159.92,487.92Z"
              fill="#2f6840"
            />
            <path
              d="M1158.55,491.13a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1158.55,491.13Z"
              fill="#2f6840"
            />
            <path
              d="M1156.59,489.18a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1156.59,489.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1142.73,483.52c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1142.73,483.52Z"
              fill="#2f6840"
            />
            <path
              d="M1142.23,483.17c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1142.23,483.17Z"
              fill="#3ba525"
            />
            <path
              d="M1143,483.15a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1143,483.15Z"
              fill="#2f6840"
            />
            <path
              d="M1146.46,482.35c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1146.46,482.35Z"
              fill="#2f6840"
            />
            <path
              d="M1145.09,485.56a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1145.09,485.56Z"
              fill="#2f6840"
            />
            <path
              d="M1143.13,483.61c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1143.13,483.61Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1185,472.22c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1185,472.22Z"
              fill="#2f6840"
            />
            <path
              d="M1184.49,471.87c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1184.49,471.87Z"
              fill="#3ba525"
            />
            <path
              d="M1185.24,471.84a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1185.24,471.84Z"
              fill="#2f6840"
            />
            <path
              d="M1188.72,471.05c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1188.72,471.05Z"
              fill="#2f6840"
            />
            <path
              d="M1187.35,474.26a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1187.35,474.26Z"
              fill="#2f6840"
            />
            <path
              d="M1185.39,472.3c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1185.39,472.3Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1182.34,480.94c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1182.34,480.94Z"
              fill="#2f6840"
            />
            <path
              d="M1181.83,480.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1181.83,480.6Z"
              fill="#3ba525"
            />
            <path
              d="M1182.58,480.57a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1182.58,480.57Z"
              fill="#2f6840"
            />
            <path
              d="M1186.06,479.78c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1186.06,479.78Z"
              fill="#2f6840"
            />
            <path
              d="M1184.69,483a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1184.69,483Z"
              fill="#2f6840"
            />
            <path
              d="M1182.74,481c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1182.74,481Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1177,476c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1177,476Z"
              fill="#2f6840"
            />
            <path
              d="M1176.48,475.64c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1176.48,475.64Z"
              fill="#3ba525"
            />
            <path
              d="M1177.23,475.61a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1177.23,475.61Z"
              fill="#2f6840"
            />
            <path
              d="M1180.71,474.82a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1180.71,474.82Z"
              fill="#2f6840"
            />
            <path
              d="M1179.34,478a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1179.34,478Z"
              fill="#2f6840"
            />
            <path
              d="M1177.38,476.07c-.24.06-.47.09-.7.16a3.48,3.48,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1177.38,476.07Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1168.64,472.61c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1168.64,472.61Z"
              fill="#2f6840"
            />
            <path
              d="M1168.14,472.27c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1168.14,472.27Z"
              fill="#3ba525"
            />
            <path
              d="M1168.89,472.24a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1168.89,472.24Z"
              fill="#2f6840"
            />
            <path
              d="M1172.37,471.45c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1172.37,471.45Z"
              fill="#2f6840"
            />
            <path
              d="M1171,474.66a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1171,474.66Z"
              fill="#2f6840"
            />
            <path
              d="M1169,472.7c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1169,472.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1183.35,488.1c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1183.35,488.1Z"
              fill="#2f6840"
            />
            <path
              d="M1182.84,487.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1182.84,487.76Z"
              fill="#3ba525"
            />
            <path
              d="M1183.59,487.73a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1183.59,487.73Z"
              fill="#2f6840"
            />
            <path
              d="M1187.07,486.94c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1187.07,486.94Z"
              fill="#2f6840"
            />
            <path
              d="M1185.7,490.15a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1185.7,490.15Z"
              fill="#2f6840"
            />
            <path
              d="M1183.74,488.19c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1183.74,488.19Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1169.89,482.53c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1169.89,482.53Z"
              fill="#2f6840"
            />
            <path
              d="M1169.38,482.19c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1169.38,482.19Z"
              fill="#3ba525"
            />
            <path
              d="M1170.14,482.16a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1170.14,482.16Z"
              fill="#2f6840"
            />
            <path
              d="M1173.61,481.37c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1173.61,481.37Z"
              fill="#2f6840"
            />
            <path
              d="M1172.25,484.58a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1172.25,484.58Z"
              fill="#2f6840"
            />
            <path
              d="M1170.29,482.62c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1170.29,482.62Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1212.33,464.64c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1212.33,464.64Z"
              fill="#2f6840"
            />
            <path
              d="M1211.82,464.3c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1211.82,464.3Z"
              fill="#3ba525"
            />
            <path
              d="M1212.58,464.27a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1212.58,464.27Z"
              fill="#2f6840"
            />
            <path
              d="M1216.05,463.48c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1216.05,463.48Z"
              fill="#2f6840"
            />
            <path
              d="M1214.69,466.69a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1214.69,466.69Z"
              fill="#2f6840"
            />
            <path
              d="M1212.73,464.73c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1212.73,464.73Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1209.67,473.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1209.67,473.37Z"
              fill="#2f6840"
            />
            <path
              d="M1209.16,473c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1209.16,473Z"
              fill="#3ba525"
            />
            <path
              d="M1209.92,473a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1209.92,473Z"
              fill="#2f6840"
            />
            <path
              d="M1213.4,472.2c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1213.4,472.2Z"
              fill="#2f6840"
            />
            <path
              d="M1212,475.41a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1212,475.41Z"
              fill="#2f6840"
            />
            <path
              d="M1210.07,473.46c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1210.07,473.46Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1204.32,468.41c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1204.32,468.41Z"
              fill="#2f6840"
            />
            <path
              d="M1203.81,468.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1203.81,468.07Z"
              fill="#3ba525"
            />
            <path
              d="M1204.57,468a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1204.57,468Z"
              fill="#2f6840"
            />
            <path
              d="M1208,467.25c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1208,467.25Z"
              fill="#2f6840"
            />
            <path
              d="M1206.68,470.46a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1206.68,470.46Z"
              fill="#2f6840"
            />
            <path
              d="M1204.72,468.5c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1204.72,468.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1196,465c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1196,465Z"
              fill="#2f6840"
            />
            <path
              d="M1195.47,464.7c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1195.47,464.7Z"
              fill="#3ba525"
            />
            <path
              d="M1196.22,464.67a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1196.22,464.67Z"
              fill="#2f6840"
            />
            <path
              d="M1199.7,463.87c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1199.7,463.87Z"
              fill="#2f6840"
            />
            <path
              d="M1198.33,467.08a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1198.33,467.08Z"
              fill="#2f6840"
            />
            <path
              d="M1196.37,465.13c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1196.37,465.13Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1210.68,480.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1210.68,480.53Z"
              fill="#2f6840"
            />
            <path
              d="M1210.17,480.19c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1210.17,480.19Z"
              fill="#3ba525"
            />
            <path
              d="M1210.93,480.16a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1210.93,480.16Z"
              fill="#2f6840"
            />
            <path
              d="M1214.41,479.36c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,1214.41,479.36Z"
              fill="#2f6840"
            />
            <path
              d="M1213,482.57a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1213,482.57Z"
              fill="#2f6840"
            />
            <path
              d="M1211.08,480.62c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1211.08,480.62Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1197.22,475c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1197.22,475Z"
              fill="#2f6840"
            />
            <path
              d="M1196.72,474.62c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1196.72,474.62Z"
              fill="#3ba525"
            />
            <path
              d="M1197.47,474.59a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1197.47,474.59Z"
              fill="#2f6840"
            />
            <path
              d="M1201,473.79c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1201,473.79Z"
              fill="#2f6840"
            />
            <path
              d="M1199.58,477a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1199.58,477Z"
              fill="#2f6840"
            />
            <path
              d="M1197.62,475.05c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1197.62,475.05Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1221.92,428.52c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1221.92,428.52Z"
              fill="#2f6840"
            />
            <path
              d="M1221.42,428.18c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1221.42,428.18Z"
              fill="#3ba525"
            />
            <path
              d="M1222.17,428.15a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1222.17,428.15Z"
              fill="#2f6840"
            />
            <path
              d="M1225.65,427.35c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1225.65,427.35Z"
              fill="#2f6840"
            />
            <path
              d="M1224.28,430.56a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1224.28,430.56Z"
              fill="#2f6840"
            />
            <path
              d="M1222.32,428.61c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1222.32,428.61Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1219.26,437.25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1219.26,437.25Z"
              fill="#2f6840"
            />
            <path
              d="M1218.76,436.91c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1218.76,436.91Z"
              fill="#3ba525"
            />
            <path
              d="M1219.51,436.88a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1219.51,436.88Z"
              fill="#2f6840"
            />
            <path
              d="M1223,436.08c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1223,436.08Z"
              fill="#2f6840"
            />
            <path
              d="M1221.62,439.29a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1221.62,439.29Z"
              fill="#2f6840"
            />
            <path
              d="M1219.66,437.34a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1219.66,437.34Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1213.91,432.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1213.91,432.29Z"
              fill="#2f6840"
            />
            <path
              d="M1213.4,432c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1213.4,432Z"
              fill="#3ba525"
            />
            <path
              d="M1214.16,431.92a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1214.16,431.92Z"
              fill="#2f6840"
            />
            <path
              d="M1217.63,431.12c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1217.63,431.12Z"
              fill="#2f6840"
            />
            <path
              d="M1216.27,434.33a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1216.27,434.33Z"
              fill="#2f6840"
            />
            <path
              d="M1214.31,432.38c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1214.31,432.38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1205.57,428.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1205.57,428.92Z"
              fill="#2f6840"
            />
            <path
              d="M1205.06,428.58c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1205.06,428.58Z"
              fill="#3ba525"
            />
            <path
              d="M1205.81,428.55a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1205.81,428.55Z"
              fill="#2f6840"
            />
            <path
              d="M1209.29,427.75c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1209.29,427.75Z"
              fill="#2f6840"
            />
            <path
              d="M1207.92,431a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1207.92,431Z"
              fill="#2f6840"
            />
            <path
              d="M1206,429c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1206,429Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1220.27,444.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1220.27,444.41Z"
              fill="#2f6840"
            />
            <path
              d="M1219.77,444.07c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1219.77,444.07Z"
              fill="#3ba525"
            />
            <path
              d="M1220.52,444a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1220.52,444Z"
              fill="#2f6840"
            />
            <path
              d="M1224,443.24c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1224,443.24Z"
              fill="#2f6840"
            />
            <path
              d="M1222.63,446.45a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1222.63,446.45Z"
              fill="#2f6840"
            />
            <path
              d="M1220.67,444.5a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1220.67,444.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1206.81,438.84c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1206.81,438.84Z"
              fill="#2f6840"
            />
            <path
              d="M1206.31,438.5c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1206.31,438.5Z"
              fill="#3ba525"
            />
            <path
              d="M1207.06,438.47a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1207.06,438.47Z"
              fill="#2f6840"
            />
            <path
              d="M1210.54,437.67c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1210.54,437.67Z"
              fill="#2f6840"
            />
            <path
              d="M1209.17,440.88a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1209.17,440.88Z"
              fill="#2f6840"
            />
            <path
              d="M1207.21,438.93c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1207.21,438.93Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1200.82,409.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1200.82,409.89Z"
              fill="#2f6840"
            />
            <path
              d="M1200.32,409.55c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1200.32,409.55Z"
              fill="#3ba525"
            />
            <path
              d="M1201.07,409.52a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1201.07,409.52Z"
              fill="#2f6840"
            />
            <path
              d="M1204.55,408.72c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1204.55,408.72Z"
              fill="#2f6840"
            />
            <path
              d="M1203.18,411.93a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1203.18,411.93Z"
              fill="#2f6840"
            />
            <path
              d="M1201.22,410c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1201.22,410Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1198.16,418.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1198.16,418.62Z"
              fill="#2f6840"
            />
            <path
              d="M1197.66,418.28c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1197.66,418.28Z"
              fill="#3ba525"
            />
            <path
              d="M1198.41,418.25a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1198.41,418.25Z"
              fill="#2f6840"
            />
            <path
              d="M1201.89,417.45c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1201.89,417.45Z"
              fill="#2f6840"
            />
            <path
              d="M1200.52,420.66a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1200.52,420.66Z"
              fill="#2f6840"
            />
            <path
              d="M1198.56,418.71c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1198.56,418.71Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1192.81,413.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1192.81,413.66Z"
              fill="#2f6840"
            />
            <path
              d="M1192.3,413.32c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1192.3,413.32Z"
              fill="#3ba525"
            />
            <path
              d="M1193.06,413.29a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1193.06,413.29Z"
              fill="#2f6840"
            />
            <path
              d="M1196.53,412.5c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1196.53,412.5Z"
              fill="#2f6840"
            />
            <path
              d="M1195.17,415.71a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1195.17,415.71Z"
              fill="#2f6840"
            />
            <path
              d="M1193.21,413.75c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1193.21,413.75Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1184.47,410.29c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1184.47,410.29Z"
              fill="#2f6840"
            />
            <path
              d="M1184,410c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1184,410Z"
              fill="#3ba525"
            />
            <path
              d="M1184.71,409.92a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1184.71,409.92Z"
              fill="#2f6840"
            />
            <path
              d="M1188.19,409.12c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1188.19,409.12Z"
              fill="#2f6840"
            />
            <path
              d="M1186.82,412.33a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1186.82,412.33Z"
              fill="#2f6840"
            />
            <path
              d="M1184.87,410.38c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1184.87,410.38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1199.17,425.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1199.17,425.78Z"
              fill="#2f6840"
            />
            <path
              d="M1198.67,425.44c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1198.67,425.44Z"
              fill="#3ba525"
            />
            <path
              d="M1199.42,425.41a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1199.42,425.41Z"
              fill="#2f6840"
            />
            <path
              d="M1202.9,424.61c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1202.9,424.61Z"
              fill="#2f6840"
            />
            <path
              d="M1201.53,427.82a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1201.53,427.82Z"
              fill="#2f6840"
            />
            <path
              d="M1199.57,425.87c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1199.57,425.87Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1185.72,420.21c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1185.72,420.21Z"
              fill="#2f6840"
            />
            <path
              d="M1185.21,419.87c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1185.21,419.87Z"
              fill="#3ba525"
            />
            <path
              d="M1186,419.84a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1186,419.84Z"
              fill="#2f6840"
            />
            <path
              d="M1189.44,419c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1189.44,419Z"
              fill="#2f6840"
            />
            <path
              d="M1188.07,422.25a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1188.07,422.25Z"
              fill="#2f6840"
            />
            <path
              d="M1186.11,420.3c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1186.11,420.3Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1196,468.07l2.26,1.4a.71.71,0,0,0,.68,0l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.69.69,0,0,0-.57-.17l-7.68,1A.73.73,0,0,0,1196,468.07Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1200.05 462.47 1196.99 463.12 1194.3 465.18 1198.81 466.99 1204.34 464.73 1200.05 462.47"
            fill="#ffedc8"
          />
          <polygon
            points="1194.3 465.18 1194.3 466.99 1198.63 468.85 1204.45 466.48 1204.34 464.73 1198.81 466.99 1194.3 465.18"
            fill="#ccae79"
          />
          <polygon
            points="1198.81 466.99 1198.63 468.85 1204.45 466.48 1204.34 464.73 1198.81 466.99"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1195.59,465.7a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79S1195.59,465.7,1195.59,465.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1197.49,466.46a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1201.09,466.06a.83.83,0,0,1,.45.73l-.13-.86Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1203.11,464.08a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1203.11,464.08Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1170.53,487.59l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.76.76,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1170.53,487.59Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1174.53 481.99 1171.48 482.64 1168.79 484.7 1173.3 486.51 1178.82 484.25 1174.53 481.99"
            fill="#ffedc8"
          />
          <polygon
            points="1168.79 484.7 1168.79 486.51 1173.11 488.37 1178.94 486 1178.82 484.25 1173.3 486.51 1168.79 484.7"
            fill="#ccae79"
          />
          <polygon
            points="1173.3 486.51 1173.11 488.37 1178.94 486 1178.82 484.25 1173.3 486.51"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1170.07,485.22a.82.82,0,0,1,0,.93c.21-.29.25-.83.35-.79Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1172,486a2.58,2.58,0,0,0,1.13-1.15l-.82,1.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1175.58,485.58a.84.84,0,0,1,.45.73l-.14-.86Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1177.59,483.6a5.31,5.31,0,0,1-1.79,0,2.55,2.55,0,0,1-1.3.1s1-.1,1.3.23A7.66,7.66,0,0,1,1177.59,483.6Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1154.27,473.5l3.89,2.41a1.23,1.23,0,0,0,1.19.08l9.34-4.17a1.27,1.27,0,0,0,.31-2.11h0a1.25,1.25,0,0,0-1-.3l-13.23,1.76A1.27,1.27,0,0,0,1154.27,473.5Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1161.18 463.84 1155.91 464.95 1151.27 468.52 1159.05 471.64 1168.57 467.74 1161.18 463.84"
            fill="#ffedc8"
          />
          <polygon
            points="1151.27 468.52 1151.27 471.64 1158.73 474.83 1168.78 470.76 1168.57 467.74 1159.05 471.64 1151.27 468.52"
            fill="#ccae79"
          />
          <polygon
            points="1159.05 471.64 1158.73 474.83 1168.78 470.76 1168.57 467.74 1159.05 471.64"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1153.49,469.41a1.41,1.41,0,0,1,0,1.6c.35-.5.43-1.43.6-1.36Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1156.77,470.72a4.35,4.35,0,0,0,2-2l-1.41,2.22Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1163,470a1.42,1.42,0,0,1,.77,1.26l-.23-1.49Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1166.46,466.62a9.12,9.12,0,0,1-3.09,0,4.37,4.37,0,0,1-2.25.16s1.65-.16,2.25.4A13.86,13.86,0,0,1,1166.46,466.62Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1141.36,473.68s-1.6,3.18-3.83,3.72-5.6-1.68-5.08.15-4.21,2.65-6.23,2.16-6.48-4.83-6.45-6.21S1141.36,473.68,1141.36,473.68Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1141.43,471.06l-.07,2.62-3.84,2.67-5-.13-1.18,1.91s-3.44,1.6-5.73-.15a18.53,18.53,0,0,1-4-4.84l.07-2.61Z"
            fill="#ccae79"
          />
          <path
            d="M1137.43,469.26l4,1.8-4.12,2.67-4.76-.13-1.59,2s-4.68,1.26-5.25-.14-4-4.89-4-4.89l3.74-1.59Z"
            fill="#ffedc8"
          />
          <polygon
            points="1137.31 473.73 1137.52 476.35 1132.54 476.22 1132.55 473.6 1137.31 473.73"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1126.89,476.05s-.82,2.38-.07,2.54a11.41,11.41,0,0,1-5.21-5.45l.07-2.61S1125.8,476,1126.89,476.05Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1130.1,475.76l-.94.17s.59-.15.44.95A2.76,2.76,0,0,1,1130.1,475.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1127.94,476.09c.11,0-.18,0-1-.88a5.69,5.69,0,0,1-1.16-1.79s2,2.33,1.53,2.66Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1139,472.62a15.09,15.09,0,0,0,0,1.89s.11-1.42-.29-1.67Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1131.71,469.11l-1.9-.05c-.13,0,1.49,0,1.87.89l0-.84"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1139.42,470.16l-1-.45s.56.36.34.43-1.11.43-1.47.24a1.45,1.45,0,0,0-1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1160.56,483.78s-1,2.07-2.5,2.42-3.65-1.09-3.32.1-2.74,1.73-4.06,1.41-4.22-3.15-4.2-4S1160.56,483.78,1160.56,483.78Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1160.6,482.07l0,1.71-2.51,1.74-3.25-.09-.77,1.25s-2.24,1.05-3.73-.1a12.2,12.2,0,0,1-2.62-3.15l0-1.7Z"
            fill="#ccae79"
          />
          <path
            d="M1158,480.9l2.61,1.17-2.68,1.74-3.11-.08-1,1.27s-3,.83-3.42-.09a18.8,18.8,0,0,0-2.62-3.18l2.44-1Z"
            fill="#ffedc8"
          />
          <polygon
            points="1157.91 483.81 1158.05 485.52 1154.81 485.43 1154.81 483.73 1157.91 483.81"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1151.12,485.32s-.53,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.55l0-1.7S1150.41,485.31,1151.12,485.32Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1153.22,485.13l-.62.12s.38-.1.29.61A1.77,1.77,0,0,1,1153.22,485.13Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1151.81,485.35c.07,0-.12,0-.67-.57a3.83,3.83,0,0,1-.76-1.17s1.32,1.52,1,1.73Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1159,483.09a10.65,10.65,0,0,0,0,1.23s.07-.93-.19-1.09Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1154.26,480.8l-1.23,0c-.09,0,1,0,1.22.59v-.55"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1159.29,481.48l-.65-.29s.37.23.22.28-.72.28-1,.16a1,1,0,0,0-.61,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope5;
